<div class="mt-4 v_analysis" [style.height]="vAnalysisHeight"
  [class.loading-active]="!isDataFullyLoaded || !isLayoutCalculated"
  [class.is-fullscreen]="isFullscreen">
  <div class="tender-header-bg border">
    <div class="row align-items-center">
      <div class="col d-flex flex-row align-items-center min-height border-bottom">
        <h1 class="page-title mx-3">
          @if (round) {
          <jft-time-remaining [round]="round"></jft-time-remaining>
          }
        </h1>
        @if (round) {
        <jft-round-status [status]="$safeNavigationMigration(round?.status)"></jft-round-status>
        }

        <ul class="nav nav-links ms-3">
          @if (tender && round && contract && rounds) {
          <jft-round-controls [tender]="tender" [round]="round" (onRoundChange)="roundChanged($event)" [rounds]="rounds"
            [contract]="contract" [isSubmittedBid]="isSubmittedBid()" [suppliersCount]="suppliers.length">
          </jft-round-controls>
          }

        </ul>
        <ul class="nav nav-links ms-auto align-items-center">
          @if (allContracts.length > 1) {
          <li class="nav-item location-nav">
            <button type="button"
                    class="location-nav-btn"
                    [disabled]="!hasPreviousLocation"
                    (click)="navigatePreviousLocation()"
                    [ngbTooltip]="previousLocationLabel"
                    placement="bottom">
              <i class="fas fa-chevron-left"></i>
            </button>
            <span class="location-counter"
                  *ngIf="currentContractIndex >= 0">
              {{ currentContractIndex + 1 }} / {{ allContracts.length }}
            </span>
            <button type="button"
                    class="location-nav-btn"
                    [disabled]="!hasNextLocation"
                    (click)="navigateNextLocation()"
                    [ngbTooltip]="nextLocationLabel"
                    placement="bottom">
              <i class="fas fa-chevron-right"></i>
            </button>
          </li>
          }
          @if (tender && contract && user.canManage(tender)) {
          <li class="nav-item">
            <jft-bid-hide-show-modal [tender]="tender" [contract]="contract" [offers]="contractBidsDisplayOptions"
              [hideInvalidBids]="hideInvalidBids" (onClosed)="onUpdatedHideBids($event)"
              (onUpdated)="onUpdatedHideBids($event)" (onHideInvalidBidsChange)="onHideInvalidBidsChange($event)">
            </jft-bid-hide-show-modal>
          </li>
          }
          @if (userSettings && tender) {
          <li class="nav-item">
            <jft-va-display-settings-modal [userSettings]="userSettings" [tender]="tender"
              (onUpdated)="updatedDisplayFieldsSetting($event)"></jft-va-display-settings-modal>
          </li>
          }
          <li class="nav-item">
            <button type="button"
                    class="btn btn-sm btn-link text-decoration-none px-2 fullscreen-toggle"
                    (click)="toggleFullscreen()"
                    [ngbTooltip]="isFullscreen ? 'Exit fullscreen (Esc)' : 'Fullscreen'"
                    placement="bottom-end">
              <svg *ngIf="!isFullscreen" xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                   viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                   stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                <path d="M3 7V5a2 2 0 0 1 2-2h2"/>
                <path d="M17 3h2a2 2 0 0 1 2 2v2"/>
                <path d="M21 17v2a2 2 0 0 1-2 2h-2"/>
                <path d="M7 21H5a2 2 0 0 1-2-2v-2"/>
              </svg>
              <svg *ngIf="isFullscreen" xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                   viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                   stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                <path d="M9 3v4a2 2 0 0 1-2 2H3"/>
                <path d="M15 3v4a2 2 0 0 0 2 2h4"/>
                <path d="M15 21v-4a2 2 0 0 1 2-2h4"/>
                <path d="M9 21v-4a2 2 0 0 0-2-2H3"/>
              </svg>
              <span class="ms-1 d-none d-lg-inline">{{ isFullscreen ? 'Exit Fullscreen' : 'Fullscreen' }}</span>
            </button>
          </li>
        </ul>
      </div>

    </div>

    <!-- Location Info Bar -->
    @if (tender && contract) {
    <div class="row align-items-center px-3 py-2 bg-light border-top">
      <div class="col-auto d-flex flex-wrap gap-4 small">
        <div *ngIf="contract?.location">
          <span class="text-muted">Location:</span>
          <span class="fw-bold ms-1">{{contract.location?.getLabel()}}</span>
        </div>
        <div
          *ngIf="!tender?.company?.settings?.isHiddenField('location_company') && (contract?.companyChild || contract?.companyInfo)">
          <span class="text-muted">Company:</span>
          <span class="fw-bold ms-1" *ngIf="contract?.companyChild">{{contract.companyChild.getDisplayName()}}</span>
          <span class="fw-bold ms-1"
            *ngIf="!contract?.companyChild && contract?.companyInfo">{{contract.companyInfo}}</span>
        </div>
        <div *ngIf="!tender?.company?.settings?.isHiddenField('location_fuel_type') && contract?.fuelType">
          <span class="text-muted">Fuel Type:</span>
          <span class="fw-bold ms-1">{{contract.fuelType.name || contract.fuelType}}</span>
        </div>
        <div *ngIf="!tender?.company?.settings?.isHiddenField('location_flight_type') && contract?.flightType">
          <span class="text-muted">Flight Type:</span>
          <span class="fw-bold ms-1">{{contract.flightType.name || contract.flightType}}</span>
        </div>
        <div *ngIf="!tender?.company?.settings?.isHiddenField('location_delivery_point') && contract?.fuelPreference">
          <span class="text-muted">Preferred Delivery Point:</span>
          <span class="fw-bold ms-1">{{contract.fuelPreference.name}}</span>
        </div>
        <div *ngIf="contract?.volume">
          <span class="text-muted">Contract Volume:</span>
          <span class="fw-bold ms-1">{{contract.volume | number:'1.0-0'}} {{contract.units?.code}}</span>
        </div>
        <div *ngIf="contract?.tags?.length">
          <span class="text-muted">Tags:</span>
          <span *ngFor="let tag of contract.tags"
            class="badge py-1 px-2 ms-1 text-warning-emphasis bg-warning-subtle border border-warning-subtle rounded-pill">{{tag.name}}</span>
        </div>
      </div>
    </div>
    }
  </div>

  <!-- Content Area Loading Overlay - Inside wrapper for proper positioning -->
  @if (!isDataFullyLoaded || !isLayoutCalculated) {
  <div class="content-loading-overlay">
    <div class="content-loading-content">
      <div class="loading-spinner"></div>
      <h5>Loading...</h5>
      <p>Preparing bid data and calculations...</p>
    </div>
  </div>
  }

  <div class="va-wrapper overflow-auto" [class.content-hidden]="!isDataFullyLoaded || !isLayoutCalculated">

    <!-- Actual Content - Always rendered but hidden during loading -->
    @if (tender && contract) {
    <div class="va-table flex-row flex-nowrap overflow-auto-inner" [attr.data-layout-ready]="isLayoutCalculated">
      <!-- Header-column -->
      <div class="va-column va-header-col" [style.order]="-2">
        <div [ngStyle]="{ 'order' : usOrderedFields.bid_status }" class="va-cell row-index-1 bid-status">
          Status
        </div>
        <div [ngStyle]="{ 'order' : $safeNavigationMigration(usOrderedFields?.supplier) }" class="va-cell va-header-row row-index-2 supplier">
          Supplier</div>
        <div [ngStyle]="{ 'order' : $safeNavigationMigration(usOrderedFields?.offer_id) }" class="va-cell row-index-3 offer-id">Bid
          Menu</div>
        <div [ngStyle]="{ 'order' : $safeNavigationMigration(usOrderedFields?.delivery_point) }" class="va-cell row-index-4 delivery-point"
          *ngIf="!(usHiddenFields && usHiddenFields[VIEW_FIELDS?.DELIVERY_POINT] === false)">Delivery Point
        </div>
        <div [ngStyle]="{ 'order' : $safeNavigationMigration(usOrderedFields?.price_base) }" class="va-cell row-index-5 price-base"
          *ngIf="!(usHiddenFields && usHiddenFields[VIEW_FIELDS?.PRICE_BASE] === false)">Price Base
          <span class="small" *ngIf="this.dateRange == 'custom'">
            {{this.dateStartPriceBase | date: defaultDateFormat : 'utc' }} - {{this.dateEndPriceBase |
            date: defaultDateFormat}}
          </span>
        </div>
        <div [ngStyle]="{ 'order' : $safeNavigationMigration(usOrderedFields?.average_price_base) }"
          class="va-cell row-index-6 average-price-base p-0"
          *ngIf="!(usHiddenFields && usHiddenFields[VIEW_FIELDS?.AVERAGE_PRICE_BASE] === false)">
          <div class="d-flex align-content-start flex-column py-1 px-2">
            <p class="mb-2">Average Price Base
              <ng-template #popPBVTitle>What is Average Price Base?</ng-template>
              <ng-template #popPBVContent>
                <p>The average price base value is defined by the time period which is selected in
                  the
                  dropdown menu.<br>
                  Choose from a list of predefined time periods or set a custom date range to see
                  the
                  value of the Platts
                  symbol over the specified time period.</p>
              </ng-template>
              <a href="javascript:void(0)" [ngbPopover]="popPBVContent" [popoverTitle]="popPBVTitle"><i
                  class="fas fa-info-circle mx-1" aria-hidden="true"></i></a>
            </p>
            <div ngbDropdown class="">
              <jft-index-date-range [dateRange]="dateRange" [placeholder]="'Select Date Range'"
                [class]="'form-control form-control-sm'"
                (onDates)="onDateRangePriceBase($event)"></jft-index-date-range>
            </div>
          </div>
        </div>
        <div [ngStyle]="{ 'order' : $safeNavigationMigration(usOrderedFields?.differential) }" class="va-cell row-index-7 differential d-flex"
          *ngIf="!(usHiddenFields && usHiddenFields[VIEW_FIELDS?.DIFFERENTIAL] === false)">
          <p class="mb-0">Differential</p>
          <a href="#" class="ms-auto sort-btn"
            [ngClass]="{'active': isActiveSort('differential'), 'inactive': !isActiveSort('differential')}"
            (click)="sort($event, 'differential')">
            <i class="fas"
              [ngClass]="{'fa-sort-amount-up-alt': !isSort('differential'),'fa-sort-amount-down-alt': isSort('differential')}">
            </i>
          </a>
        </div>
        <div [ngStyle]="{ 'order' : $safeNavigationMigration(usOrderedFields?.volume_fees) }" class="va-cell row-index-8 vol-fees"
          *ngIf="!(usHiddenFields && usHiddenFields[VIEW_FIELDS?.VOLUME_FEES] === false) ">Volume Fees
        </div>
        <div [ngStyle]="{ 'order' : $safeNavigationMigration(usOrderedFields?.custom_volume_fees) }" class="va-cell row-index-9 airline-vol-fees"
          *ngIf="!(usHiddenFields && usHiddenFields[VIEW_FIELDS?.CUSTOM_VOLUME_FEES] === false) && !tender?.company?.settings?.isHiddenField('bid_custom_volume_fees')">
          Custom Volume Fees
          <a href="javascript:void(0)" class="" [ngbPopover]="popCustomFeeContent" [popoverTitle]="popCustomFeeTitle">
            <i class="fas fa-info-circle mx-1" aria-hidden="true"></i>
          </a><br>
          <span class="small">(Example: Posted Price)</span>
          <ng-template #popCustomFeeTitle>How the custom fee works?</ng-template>
          <ng-template #popCustomFeeContent>
            <p>Airlines may add custom fees to supplier's offers.</p>
            <p>These fees are intended for internal use and are not visible to suppliers.</p>
            <p>Custom fees can be managed in the "Edit Bid" panel</p>
          </ng-template>
        </div>
        <div [ngStyle]="{ 'order' : $safeNavigationMigration(usOrderedFields?.volume_fees_total) }" class="va-cell row-index-10 total-vol-fees"
          *ngIf="!(usHiddenFields && usHiddenFields[VIEW_FIELDS?.TOTAL_VOLUME_FEES] === false)">Volume Fees Total
        </div>
        <div [ngStyle]="{ 'order' : $safeNavigationMigration(usOrderedFields?.total_fields) }" class="va-cell row-index-11 total-fields d-flex">
          <p class="mb-0">Total Price</p>
          <a href="#" class="ms-auto sort-btn"
            [ngClass]="{'active': isActiveSort('total'), 'inactive': !isActiveSort('total')}"
            (click)="sort($event, 'total')">
            <i class="fas"
              [ngClass]="{'fa-sort-amount-up-alt': !isSort('total'),'fa-sort-amount-down-alt': isSort('total')}">
            </i>
          </a>
        </div>
        <div [ngStyle]="{ 'order' : $safeNavigationMigration(usOrderedFields?.ranking) }"
          *ngIf="!(usHiddenFields && usHiddenFields[VIEW_FIELDS?.RANKING] === false)"
          class="va-cell row-index-12 ranking d-flex">
          <p class="mb-0">Bid Ranking</p>
          <a href="#" class="ms-auto sort-btn"
            [ngClass]="{'active': isActiveSort('ranking'), 'inactive': !isActiveSort('ranking')}"
            (click)="sort($event, 'ranking')">
            <i class="fas"
              [ngClass]="{'fa-sort-amount-up-alt': !isSort('ranking'),'fa-sort-amount-down-alt': isSort('ranking')}">
            </i>
          </a>
        </div>
        <div [ngStyle]="{ 'order' : $safeNavigationMigration(usOrderedFields?.ranking_gap) }"
          *ngIf="!(usHiddenFields && usHiddenFields[VIEW_FIELDS?.RANKING_GAP] === false) && !tender?.company?.settings?.isHiddenField('bid_gap_from_total')"
          class="va-cell row-index-13 ranking-gap d-flex">
          <p class="mb-0">Gap from Total</p>
          <a href="#" class="ms-auto sort-btn"
            [ngClass]="{'active': isActiveSort('ranking_gap'), 'inactive': !isActiveSort('ranking_gap')}"
            (click)="sort($event, 'ranking_gap')">
            <i class="fas"
              [ngClass]="{'fa-sort-amount-up-alt': !isSort('ranking_gap'),'fa-sort-amount-down-alt': isSort('ranking_gap')}">
            </i>
          </a>
        </div>
        <div [ngStyle]="{ 'order' : $safeNavigationMigration(usOrderedFields?.event_fees) }" class="va-cell row-index-14 event-fees"
          *ngIf="!(usHiddenFields && usHiddenFields[VIEW_FIELDS?.EVENT_FEES] === false)">Per-Uplift Fees
        </div>
        <div [ngStyle]="{ 'order' : $safeNavigationMigration(usOrderedFields?.total_event_fees) }" class="va-cell row-index-15 total-event-fees"
          *ngIf="!(usHiddenFields && usHiddenFields[VIEW_FIELDS?.TOTAL_EVENT_FEES] === false)">Per-Uplift Fees Total
        </div>
        <div [ngStyle]="{ 'order' : $safeNavigationMigration(usOrderedFields?.wacc) }" class="va-cell row-index-17 wacc d-flex"
          *ngIf="!(usHiddenFields && usHiddenFields[VIEW_FIELDS?.WACC] === false)">
          <p class="mb-0"><span class="me-1">WACC</span>
            <a href="javascript:void(0)" class="" [ngbPopover]="popCCPTContent" [popoverTitle]="popCCPTTitle">
              <i class="fas fa-info-circle mx-1" aria-hidden="true"></i>
            </a>
          </p>
          <ng-template #popCCPTTitle>How is WACC calculated?</ng-template>
          <ng-template #popCCPTContent>
            <p>WACC is calculated based on the WACC %, payment terms and total price of each offer.</p>
            <p>Formula: (WACC % / 365) × Payment Terms × Total Price × -1</p>
            <p>WACC % can be updated on the <a [routerLink]="['/tenders', $safeNavigationMigration(tender?.id), 'analytics-settings']"
                routerLinkActive="active">Analytics Settings</a> page.</p>
          </ng-template>

          <a href="#!" class="ms-auto sort-btn"
            [ngClass]="{'active': isActiveSort('cost_of_capital'), 'inactive': !isActiveSort('cost_of_capital')}"
            (click)="sort($event, 'cost_of_capital')">
            <i class="fas"
              [ngClass]="{'fa-sort-amount-up-alt': !isSort('cost_of_capital'),'fa-sort-amount-down-alt': isSort('cost_of_capital')}">
            </i>
          </a>
        </div>
        <div [ngStyle]="{ 'order' : $safeNavigationMigration(usOrderedFields?.saf_mandate) }" class="va-cell row-index-18 saf-mandate"
          *ngIf="!tender?.company?.settings?.isHiddenField('bid_saf_mandate') &&  !(usHiddenFields && usHiddenFields[VIEW_FIELDS?.SAF_MANDATE] === false)">
          SAF Mandate
        </div>
        <div [ngStyle]="{ 'order' : $safeNavigationMigration(usOrderedFields?.saf_mandate_blend) }" class="va-cell row-index-19 saf-blend"
          *ngIf="!tender?.company?.settings?.isHiddenField('bid_saf_mandate_blend') && !(usHiddenFields && usHiddenFields[VIEW_FIELDS?.SAF_MANDATE_BLEND] === false)">
          SAF Mandate Blend %
        </div>
        <div [ngStyle]="{ 'order' : $safeNavigationMigration(usOrderedFields?.neat_saf) }" class="va-cell row-index-20 saf-neat"
          *ngIf="!tender?.company?.settings?.isHiddenField('bid_neat_saf_mandated_price') && !(usHiddenFields && usHiddenFields[VIEW_FIELDS?.NEAT_SAF] === false)">
          Neat SAF Mandated Price
        </div>
        <div [ngStyle]="{ 'order' : $safeNavigationMigration(usOrderedFields?.neat_saf_volume) }" class="va-cell row-index-21 saf-neat-vol"
          *ngIf="!tender?.company?.settings?.isHiddenField('bid_neat_saf_volume') && !(usHiddenFields && usHiddenFields[VIEW_FIELDS?.NEAT_SAF_VOLUME] === false)">
          Neat SAF Voluntary Volume
        </div>
        <div [ngStyle]="{ 'order' : $safeNavigationMigration(usOrderedFields?.saf_blended_volume) }" class="va-cell row-index-22 saf-blended-vol"
          *ngIf="!tender?.company?.settings?.isHiddenField('bid_saf_blend_volume') && !(usHiddenFields && usHiddenFields[VIEW_FIELDS?.SAF_BLENDED_VOLUME] === false)">
          SAF Blended Volume
        </div>
        <div [ngStyle]="{ 'order' : $safeNavigationMigration(usOrderedFields?.saf_fee_amount) }" class="va-cell row-index-23 saf-fee-amount"
          *ngIf="!tender?.company?.settings?.isHiddenField('bid_saf_fee_amount') && !(usHiddenFields && usHiddenFields[VIEW_FIELDS?.SAF_FEE_AMOUNT] === false)">
          SAF Fee Amount
        </div>
        <div [ngStyle]="{ 'order' : $safeNavigationMigration(usOrderedFields?.saf_cost) }" class="va-cell row-index-24 saf-cost"
          *ngIf="!tender?.company?.settings?.isHiddenField('bid_saf_cost') && !(usHiddenFields && usHiddenFields[VIEW_FIELDS?.SAF_COST] === false)">
          SAF Cost
        </div>
        <div [ngStyle]="{ 'order' : $safeNavigationMigration(usOrderedFields?.saf_premium) }" class="va-cell row-index-25 saf-premium"
          *ngIf="!tender?.company?.settings?.isHiddenField('bid_saf_premium') && !(usHiddenFields && usHiddenFields[VIEW_FIELDS?.SAF_PREMIUM] === false)">
          SAF Premium
        </div>
        <div [ngStyle]="{ 'order' : $safeNavigationMigration(usOrderedFields?.conventional_jet_percentage) }"
          class="va-cell row-index-26 conv-jet-perc"
          *ngIf="!tender?.company?.settings?.isHiddenField('bid_conventional_jet_percentage') && !(usHiddenFields && usHiddenFields[VIEW_FIELDS?.CONVENTIONAL_JET_PERCENTAGE] === false)">
          Conventional Jet Percentage
        </div>
        <div [ngStyle]="{ 'order' : $safeNavigationMigration(usOrderedFields?.conventional_jet_percentage_price) }"
          class="va-cell row-index-27 conv-jet-perc-price"
          *ngIf="!tender?.company?.settings?.isHiddenField('bid_conventional_jet_percentage_price') && !(usHiddenFields && usHiddenFields[VIEW_FIELDS?.CONVENTIONAL_JET_PERCENTAGE_PRICE] === false)">
          Conventional Jet Percentage Price
        </div>
        <div [ngStyle]="{ 'order' : $safeNavigationMigration(usOrderedFields?.conventional_jet_and_saf_premium) }"
          class="va-cell row-index-28 conv-jet-saf-premium"
          *ngIf="!tender?.company?.settings?.isHiddenField('bid_conventional_jet_and_saf_premium') && !(usHiddenFields && usHiddenFields[VIEW_FIELDS?.CONVENTIONAL_JET_AND_SAF_PREMIUM] === false)">
          Conventional Jet and SAF Premium
        </div>
        <div [ngStyle]="{ 'order' : $safeNavigationMigration(usOrderedFields?.conventional_jet_volume) }"
          class="va-cell row-index-29 conv-jet-vol"
          *ngIf="!tender?.company?.settings?.isHiddenField('bid_conventional_jet_volume') && !(usHiddenFields && usHiddenFields[VIEW_FIELDS?.CONVENTIONAL_JET_VOLUME] === false)">
          Conventional Jet Volume
        </div>
        <div [ngStyle]="{ 'order' : $safeNavigationMigration(usOrderedFields?.conventional_jet_cost) }" class="va-cell row-index-30 conv-jet-cost"
          *ngIf="!tender?.company?.settings?.isHiddenField('bid_conventional_jet_cost') && !(usHiddenFields && usHiddenFields[VIEW_FIELDS?.CONVENTIONAL_JET_COST] === false)">
          Conventional Jet Cost
        </div>
        <!-- Dynamic formula rows (all formulas except total_price) -->
        <ng-container *ngFor="let fKey of dynamicFormulaKeys">
          <div [ngStyle]="{ 'order' : $safeNavigationMigration(usOrderedFields?.[fKey]) }" class="va-cell row-index-31 sum-diff-vol d-flex"
            *ngIf="!(usHiddenFields && usHiddenFields[fKey] === false)">
            <p class="mb-0">{{ activeFormulas[fKey]?.name }}</p>
            <a *ngIf="fKey === 'diff_vol_fees'" href="#" class="ms-auto sort-btn"
              [ngClass]="{'active': isActiveSort('diff_fees'), 'inactive': !isActiveSort('diff_fees')}"
              (click)="sort($event, 'diff_fees')">
              <i class="fas"
                [ngClass]="{'fa-sort-amount-up-alt': !isSort('diff_fees'),'fa-sort-amount-down-alt': isSort('diff_fees')}">
              </i>
            </a>
          </div>
        </ng-container>

        <div [ngStyle]="{ 'order' : $safeNavigationMigration(usOrderedFields?.non_mandatory_fees) }"
          class="va-cell row-index-37 non-mandatory-fees"
          *ngIf="!(usHiddenFields && usHiddenFields[VIEW_FIELDS?.NON_MANDATORY_FEES] === false) && !tender?.company?.settings?.isHiddenField('bid_non_mandatory_fees')">
          Non-mandatory Fees
        </div>
        <div [ngStyle]="{ 'order' : $safeNavigationMigration(usOrderedFields?.payment_type) }" class="va-cell row-index-38 payment-type"
          *ngIf="!(usHiddenFields && usHiddenFields[VIEW_FIELDS?.PAYMENT_TYPE] === false) && !tender?.company?.settings?.isHiddenField('bid_payment_type')">
          Payment Type
        </div>
        <div [ngStyle]="{ 'order' : $safeNavigationMigration(usOrderedFields?.payment_terms) }" class="va-cell row-index-39 payment-terms"
          *ngIf="!(usHiddenFields && usHiddenFields[VIEW_FIELDS?.PAYMENT_TERMS] === false) && !tender?.company?.settings?.isHiddenField('bid_payment_terms')">
          Payment Terms
        </div>
        <div [ngStyle]="{ 'order' : $safeNavigationMigration(usOrderedFields?.payment_currency) }" class="va-cell row-index-40 payment_currency"
          *ngIf="!(usHiddenFields && usHiddenFields[VIEW_FIELDS?.PAYMENT_CURRENCY] === false) && !tender?.company?.settings?.isHiddenField('bid_payment_currency')">
          Payment Currency
        </div>
        <div [ngStyle]="{ 'order' : $safeNavigationMigration(usOrderedFields?.payment_unit) }" class="va-cell row-index-41 payment-unit"
          *ngIf="!(usHiddenFields && usHiddenFields[VIEW_FIELDS?.PAYMENT_UNIT] === false) && !tender?.company?.settings?.isHiddenField('bid_payment_unit')">
          Payment Unit
        </div>
        <div [ngStyle]="{ 'order' : $safeNavigationMigration(usOrderedFields?.payment_method) }" class="va-cell row-index-42 payment-method"
          *ngIf="!(usHiddenFields && usHiddenFields[VIEW_FIELDS?.PAYMENT_METHOD] === false) && !tender?.company?.settings?.isHiddenField('bid_method_of_payment')">
          Method Of Payment
        </div>
        <div [ngStyle]="{ 'order' : $safeNavigationMigration(usOrderedFields?.guarantees_deposits_required) }"
          class="va-cell row-index-43 deposit"
          *ngIf="!(usHiddenFields && usHiddenFields[VIEW_FIELDS?.GUARANTEES_DEPOSITS_REQUIRED] === false) && !tender?.company?.settings?.isHiddenField('bid_guarantees_deposits_required')">
          Guarantees Deposits Required
        </div>
        <div [ngStyle]="{ 'order' : $safeNavigationMigration(usOrderedFields?.bank_guarantee_amount) }"
          class="va-cell row-index-44 bank-guarantee-amount"
          *ngIf="!(usHiddenFields && usHiddenFields[VIEW_FIELDS?.BANK_GUARANTEE_AMOUNT] === false) && !tender?.company?.settings?.isHiddenField('bank_guarantee_amount')">
          Bank Guarantee Amount
        </div>
        <div [ngStyle]="{ 'order' : $safeNavigationMigration(usOrderedFields?.bank_guarantee_currency) }"
          class="va-cell row-index-45 bank-guarantee-currency"
          *ngIf="!(usHiddenFields && usHiddenFields[VIEW_FIELDS?.BANK_GUARANTEE_CURRENCY] === false) && !tender?.company?.settings?.isHiddenField('bank_guarantee_currency')">
          Bank Guarantee Currency
        </div>
        <div [ngStyle]="{ 'order' : $safeNavigationMigration(usOrderedFields?.transit_time) }" class="va-cell row-index-46 transit-time"
          *ngIf="!(usHiddenFields && usHiddenFields[VIEW_FIELDS?.TRANSIT_TIME] === false) && !tender?.company?.settings?.isHiddenField('transit_time')">
          Transit Time (Days)
        </div>
        <div [ngStyle]="{ 'order' : usOrderedFields.fin_source }" class="va-cell row-index-46 fin-source" *ngIf="false">
          Financial Source</div>
        <div [ngStyle]="{ 'order' : $safeNavigationMigration(usOrderedFields?.fin_averaging_method) }"
          class="va-cell row-index-47 fin-averaging-method" *ngIf="false">Averaging</div>
        <div [ngStyle]="{ 'order' : $safeNavigationMigration(usOrderedFields?.fin_averaging_offset) }"
          class="va-cell row-index-48 fin-averaging-offset" *ngIf="false">Offset</div>
        <div [ngStyle]="{ 'order' : $safeNavigationMigration(usOrderedFields?.invoice_frequency) }" class="va-cell row-index-49 invoice-frequency"
          *ngIf="!(usHiddenFields && usHiddenFields[VIEW_FIELDS?.INVOICE_FREQUENCY] === false) && !tender?.company?.settings?.isHiddenField('bid_open_invoice_invoice_frequency')">
          Invoice Frequency
        </div>
        <div [ngStyle]="{ 'order' : $safeNavigationMigration(usOrderedFields?.invoice_type) }" class="va-cell row-index-50 invoice-type"
          *ngIf="!(usHiddenFields && usHiddenFields[VIEW_FIELDS?.INVOICE_TYPE] === false) && !tender?.company?.settings?.isHiddenField('bid_invoice_type')">
          Invoice Type
        </div>
        <div [ngStyle]="{ 'order' : $safeNavigationMigration(usOrderedFields?.payment_reference_date) }"
          class="va-cell row-index-51 payment-reference-date"
          *ngIf="!(usHiddenFields && usHiddenFields[VIEW_FIELDS?.PAYMENT_REFERENCE_DATE] === false) && !tender?.company?.settings?.isHiddenField('bid_payment_reference_date')">
          Payment Reference Date
        </div>
        <div [ngStyle]="{ 'order' : $safeNavigationMigration(usOrderedFields?.payment_details) }" class="va-cell row-index-52 payment-details"
          *ngIf="!(usHiddenFields && usHiddenFields[VIEW_FIELDS?.PAYMENT_DETAILS] === false) && (!tender?.company?.settings?.isHiddenField('bid_exchange_rate') || !tender?.company?.settings?.isHiddenField('bid_ex_rate_financial_source') || !tender?.company?.settings?.isHiddenField('bid_ex_rate_averageing_method'))">
          Payment Details
        </div>
        <div [ngStyle]="{ 'order' : $safeNavigationMigration(usOrderedFields?.intoplane) }" class="va-cell row-index-51 intoplane" *ngIf="false">
          Intoplane Agent</div>
        <div [ngStyle]="{ 'order' : $safeNavigationMigration(usOrderedFields?.open_release) }" class="va-cell row-index-52 open-release"
          *ngIf="!(usHiddenFields && usHiddenFields[VIEW_FIELDS?.OPEN_RELEASE] === false) && !tender?.company?.settings?.isHiddenField('bid_open_fuel_release')">
          Open
          Fuel
          Release
        </div>
        <div [ngStyle]="{ 'order' : $safeNavigationMigration(usOrderedFields?.gross_or_net_billing) }" class="va-cell row-index-53 gross-net"
          *ngIf="!(usHiddenFields && usHiddenFields[VIEW_FIELDS?.GROSS_OR_NET_BILLING] === false) && !tender?.company?.settings?.isHiddenField('bid_gross_or_net_billing')">
          Gross or Net Billing
        </div>
        <div [ngStyle]="{ 'order' : $safeNavigationMigration(usOrderedFields?.iata_service_level) }"
          class="va-cell row-index-54 iata-service-level"
          *ngIf="!(usHiddenFields && usHiddenFields[VIEW_FIELDS?.IATA_SERVICE_LEVEL] === false) && !tender?.company?.settings?.isHiddenField('bid_iata_service_level')">
          IATA Service Level
        </div>
        <div [ngStyle]="{ 'order' : $safeNavigationMigration(usOrderedFields?.into_plane_service_provider) }"
          class="va-cell row-index-55 into-plane-provider"
          *ngIf="!(usHiddenFields && usHiddenFields[VIEW_FIELDS?.INTO_PLANE_SERVICE_PROVIDER] === false) && !tender?.company?.settings?.isHiddenField('bid_into_plane_service_provider')">
          Into Plane Service Provider
        </div>
        <div [ngStyle]="{ 'order' : $safeNavigationMigration(usOrderedFields?.delivery_airport) }"
          *ngIf="!(usHiddenFields && usHiddenFields[VIEW_FIELDS?.DELIVERY_AIRPORT] === false) && isAirPortDeliveryMethods()"
          class="va-cell row-index-56 delivery-airport">Delivery to
          airport
        </div>
        <div [ngStyle]="{ 'order' : $safeNavigationMigration(usOrderedFields?.delivery_aircraft) }"
          *ngIf="!(usHiddenFields && usHiddenFields[VIEW_FIELDS?.DELIVERY_AIRCRAFT] === false) && isAirCraftDeliveryMethods()"
          drum class="va-cell row-index-57 delivery-aircraft">Delivery to
          aircraft
        </div>
        <div [ngStyle]="{ 'order' : $safeNavigationMigration(usOrderedFields?.pre_flight_notification) }"
          class="va-cell row-index-58 pre-flight-notification"
          *ngIf="!(usHiddenFields && usHiddenFields[VIEW_FIELDS?.PRE_FLIGHT_NOTIFICATION] === false) && (!tender?.company?.settings?.isHiddenField('bid_pre_flight_notification_notes') || !tender?.company?.settings?.isHiddenField('bid_pre_flight_notification_hours'))">
          Pre-flight Notification
        </div>
        <div [ngStyle]="{ 'order' : $safeNavigationMigration(usOrderedFields?.ramp) }" class="va-cell row-index-59 ramp"
          *ngIf="!(usHiddenFields && usHiddenFields[VIEW_FIELDS?.RAMP] === false) && !tender?.company?.settings?.isHiddenField('bid_ramp_limitations_notes')">
          Ramp
          Limitations
        </div>
        <div [ngStyle]="{ 'order' : $safeNavigationMigration(usOrderedFields?.open_hours) }" class="va-cell row-index-60 open-hours"
          *ngIf="!(usHiddenFields && usHiddenFields[VIEW_FIELDS?.OPEN_HOURS] === false) && !tender?.company?.settings?.isHiddenField('bid_open_hours')">
          Operating Hours
        </div>
        <div [ngStyle]="{ 'order' : $safeNavigationMigration(usOrderedFields?.weight_conversion_factor) }"
          class="va-cell row-index-61 weight-conversion-factor" *ngIf="false">Weight to Volume Conversion
          Factor
        </div>
        <div [ngStyle]="{ 'order' : $safeNavigationMigration(usOrderedFields?.fuel_availability) }" class="va-cell row-index-62 fuel-availability"
          *ngIf="!(usHiddenFields && usHiddenFields[VIEW_FIELDS?.FUEL_AVAILABILITY] === false) && !tender?.company?.settings?.isHiddenField('bid_fuel_availability')">
          Fuel Availability
        </div>
        <div [ngStyle]="{ 'order' : $safeNavigationMigration(usOrderedFields?.contract_start) }" class="va-cell row-index-63 contract-start"
          *ngIf="!(usHiddenFields && usHiddenFields[VIEW_FIELDS?.CONTRACT_START] === false)">Contract Start
        </div>
        <div [ngStyle]="{ 'order' : $safeNavigationMigration(usOrderedFields?.contract_end) }" class="va-cell row-index-64 contract-end"
          *ngIf="!(usHiddenFields && usHiddenFields[VIEW_FIELDS?.CONTRACT_END] === false)">Contract End
        </div>

        <div [ngStyle]="{ 'order' : $safeNavigationMigration(usOrderedFields?.supply_conditions_notes) }"
          class="va-cell row-index-65 supplier-comments"
          *ngIf="!(usHiddenFields && usHiddenFields[VIEW_FIELDS?.SUPPLY_CONDITIONS_NOTES] === false)">Supply Conditions
          Notes
        </div>
        <div [ngStyle]="{ 'order' : $safeNavigationMigration(usOrderedFields?.notes) }" class="va-cell row-index-66 notes"
          *ngIf="!(usHiddenFields && usHiddenFields[VIEW_FIELDS?.BID_NOTES] === false)">
          Bid Notes
        </div>
        <div [ngStyle]="{ 'order' : $safeNavigationMigration(usOrderedFields?.shared_files) }" class="va-cell row-index-67 shared-files"
          *ngIf="!(usHiddenFields && usHiddenFields[VIEW_FIELDS?.SHARED_FILES] === false)">Shared Files
        </div>
        <div [ngStyle]="{ 'order' : usOrderedFields.bid_feedback }" class="va-cell row-index-68 bid-feedback"
          *ngIf="isBidFeedbacks">Previous Round Feedback</div>
        <div [ngStyle]="{ 'order' : $safeNavigationMigration(usOrderedFields?.awarded_contract_volume) }"
          class="va-cell row-index-69 awarded-contract-volume"
          *ngIf="!(usHiddenFields && usHiddenFields[VIEW_FIELDS?.AWARDED_CONTRACT_VOLUME] === false)">Awarded Contract
          Volume
        </div>
        <div [ngStyle]="{ 'order' : $safeNavigationMigration(usOrderedFields?.awarded_monthly_volume) }"
          class="va-cell row-index-70 awarded-monthly-volume"
          *ngIf="!(usHiddenFields && usHiddenFields[VIEW_FIELDS?.AWARDED_MONTHLY_VOLUME] === false)">Awarded Monthly
          Volume
        </div>
        <div [ngStyle]="{ 'order' : $safeNavigationMigration(usOrderedFields?.weight_to_volume) }" class="va-cell row-index-71 weight_to_volume"
          *ngIf="!(usHiddenFields && usHiddenFields[VIEW_FIELDS?.WEIGHT_TO_VOLUME] === false)">Weight to volume
        </div>
        <div [ngStyle]="{ 'order' : $safeNavigationMigration(usOrderedFields?.status) }" class="va-cell row-index-73 award-comment">
          Award Comment
        </div>
        <div [ngStyle]="{ 'order' : $safeNavigationMigration(usOrderedFields?.status) }" class="va-cell row-index-72 status">
          Status
        </div>
      </div>

      <!-- Current Contract Column -->

      <div class="va-column current-contract" [style.order]="-1" *ngFor="let currentOffer of currentOffers">
        <div [ngStyle]="{ 'order' : usOrderedFields.bid_status }" class="va-cell row-index-1 bid-status">
          <div class="badge-status badge-status-yellow">
            Current Contract
          </div>

          <div class="mt-2" *ngIf="tender?.tenderCurrentContractId">
            <p class="mb-0"><small>Imported from Tender</small><br>
              <span class="text-capitalize">{{currentOffer?.tender?.name}}</span>
            </p>
          </div>
          <div class="mt-2" *ngIf="!tender?.tenderCurrentContractId">
            <p class="mb-0 text-muted"><small>Imported from past tender</small><br>
              <span class="">{{currentOffer?.tender?.name}}</span>
            </p>
          </div>
          <div>
            <ul class="list-group list-group-flush small border-bottom text-start">
              <li class="list-group-item px-0 py-1">
                <small>Award Type: </small><br>
                <span
                  *ngIf="currentOffer.awardSelfSupply && currentOffer.awardSelfSupply == selfSupplyOptions.LOGISTICS">Logistics
                  Only</span>
                <span
                  *ngIf="currentOffer.awardSelfSupply && currentOffer.awardSelfSupply == selfSupplyOptions.FUEL_ONLY">Fuel
                  Only</span>
                <span *ngIf="!currentOffer.awardSelfSupply">Fuel & Logistics</span>
              </li>
              <li class="list-group-item px-0 py-1" *ngIf="currentOffer.bid">
                <small>Award Contract Start Date:</small><br>
                <span>{{ awardContractDate(currentOffer, 'start') | date: defaultDateFormat : 'utc' }}</span>
              </li>
              <li class="list-group-item px-0 py-1" *ngIf="currentOffer.bid">
                <small>Award Contract End Date: </small><br>
                <span>{{ awardContractDate(currentOffer, 'end') | date: defaultDateFormat : 'utc' }}</span>
              </li>
              <li class="list-group-item px-0 py-1">
                <small>Percent: </small><br>
                {{currentOffer.awardedPercent}}%
              </li>
            </ul>

            <jft-edit-contract-conditions-btn [class]="'btn btn-outline-primary btn-sm w-100 mt-2'"
              [popoverPlacement]="'bottom'" [offer]="currentOffer" [contract]="contract"
              (onEdit)="editCurrentContractAwardedConditions($event)">
            </jft-edit-contract-conditions-btn>

          </div>
        </div>
        <div [ngStyle]="{ 'order' : $safeNavigationMigration(usOrderedFields?.supplier) }" class="va-cell va-header-row row-index-2 supplier">
          {{ currentOffer.supplier?.name || 'Unknown Supplier' }}<span *ngIf="currentOffer.supplier?.supplierAlias"
            class="text-muted"><br>({{ currentOffer.supplier?.supplierAlias }})</span><br>
          <div *ngIf="currentOffer.supplier?.logo" class="avatar avatar-68 bg-white">
            <img src="{{ currentOffer.supplier?.logo }}" alt="{{ currentOffer.supplier?.name || 'Supplier Logo' }}">
          </div>
        </div>
        <div [ngStyle]="{ 'order' : $safeNavigationMigration(usOrderedFields?.offer_id) }" class="va-cell row-index-3 offer-id p-0">
          <div class="d-flex list-group list-group-flush w-100">
            <div class="list-group-item px-2 py-1">
              <a class="btn btn-link p-0 d-flex w-100"
                [routerLink]="['/tenders',$safeNavigationMigration(tender?.tenderCurrentContractId),'locations',$safeNavigationMigration(currentOffer.round?.contractId),'dashboard', 'rounds', $safeNavigationMigration(currentOffer.round?.round), 'suppliers', currentOffer.id]"
                target="_blank">
                <span class="">Go to {{ currentOffer.name }} Detail</span>
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
                  stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                  class="lucide lucide-arrow-up-right-from-square ms-auto">
                  <path d="M21 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h6" />
                  <path d="m21 3-9 9" />
                  <path d="M15 3h6v6" />
                </svg>
              </a>
            </div>
            <div class="list-group-item px-2 py-1">
              <jft-contract-edit-modal [tender]="tender" [contract]="contract" [currentOffer]="currentOffer"
                (onUpdated)="onUpdatedContractModal($event, currentOffer)"></jft-contract-edit-modal>
            </div>
          </div>
        </div>
        <div [ngStyle]="{ 'order' : $safeNavigationMigration(usOrderedFields?.delivery_point) }" class="va-cell row-index-4 delivery-point"
          *ngIf="!(usHiddenFields && usHiddenFields[VIEW_FIELDS?.DELIVERY_POINT] === false)">
          {{tender?.company?.settings?.getFilteredOptionLabel('delivery_point',
          $safeNavigationMigration(currentOffer.bid?.fuelPreference))}}
        </div>
        <div [ngStyle]="{ 'order' : $safeNavigationMigration(usOrderedFields?.price_base) }" class="va-cell row-index-5 price-base d-flex p-0"
          *ngIf="!(usHiddenFields && usHiddenFields[VIEW_FIELDS?.PRICE_BASE] === false)">
          <div class="mb-auto list-group list-group-flush w-100"
            *ngIf="currentOffer.bid.marketPrice && currentOffer.bid.marketPrice.price">
            <div class="list-group-item px-2 py-1" *ngIf="currentOffer.bid.marketPrice.source_type">
              <p class="mb-0"><small>Market Price Source</small><br>
                <span class="text-capitalize">{{currentOffer.bid.marketPrice.source_type?.name}}</span>
              </p>
            </div>
            <div class="list-group-item px-2 py-1" *ngIf="currentOffer.bid.marketPrice.source_name">
              <p class="mb-0"><small>Market Price Detail</small><br>
                <span class="text-capitalize">{{currentOffer.bid.marketPrice.source_name}}</span>
              </p>
            </div>
            <div class="list-group-item px-2 py-1"
              *ngIf="currentOffer.bid.marketPrice['file'] && currentOffer.bid.marketPrice['file']['name']">
              <p class="mb-0"><small>Document</small><br>
                <a class="pointer d-flex align-items-center"
                  (click)="downloadDocument(currentOffer.bid.marketPrice['file'])" placement="top"
                  ngbTooltip="{{currentOffer.bid.marketPrice['file']['name'] }}">
                  <i class="fas fa-file-alt me-2"></i>
                  <span class="d-inline-block text-truncate">
                    {{ currentOffer.bid.marketPrice['file']['name'] }}
                  </span>
                </a>
              </p>
            </div>
          </div>

          <div class="mb-auto list-group list-group-flush w-100" *ngIf="currentOffer.bid.index">
            <div class="list-group-item  px-2 py-1">
              <p class="mb-0"><small>Index Provider</small><br>
                <span class="text-capitalize">{{currentOffer.bid.index.index_code.provider}}</span>
              </p>
            </div>
            <div class="list-group-item px-2 py-1">
              <p class="mb-0"><small>Index Code</small><br>
                <span class="">{{tender?.company?.settings?.getFilteredOptionLabel('index',
                  currentOffer.bid.index.index_code, 'code')}}</span>
                - {{currentOffer.bid.index.bate?.name}}
              </p>
            </div>
            <div class="list-group-item px-2 py-1"
              *ngIf="!tender?.company?.settings?.isHiddenField('bid_averaging_method')">
              <p class="mb-0"><small>Index Averaging</small><br>
                <span class="text-capitalize">{{tender?.company?.settings?.getFilteredOptionLabel('averaging_method',
                  $safeNavigationMigration(currentOffer.bid.index?.averaging_method))}}</span>
              </p>
            </div>
            <div class="list-group-item px-2 py-1"
              *ngIf="!tender?.company?.settings?.isHiddenField('bid_average_offset') && currentOffer.bid.index.averaging_offset?.name">
              <p class="mb-0"><small>Index Averaging Offset</small><br>
                <span class="">{{currentOffer.bid.index.averaging_offset?.name}}</span>
              </p>
            </div>
            <div class="list-group-item px-2 py-1"
              *ngIf="!tender?.company?.settings?.isHiddenField('bid_effective_day')">
              <p class="mb-0"><small>Price Effective Day</small><br>
                <span class="">{{currentOffer.bid.index.effective_day?.name}}</span>
              </p>
            </div>
          </div>
        </div>
        <div [ngStyle]="{ 'order' : $safeNavigationMigration(usOrderedFields?.average_price_base) }"
          class="va-cell row-index-6 average-price-base p-0"
          *ngIf="!(usHiddenFields && usHiddenFields[VIEW_FIELDS?.AVERAGE_PRICE_BASE] === false)">
          <p *ngIf="currentOffer.bid.index && isAveragePriceEnabled && currentOffer.bid.index.index_code.provider && currentOffer.bid.index.average_price != null && currentOffer.bid.index.average_price !== 0"
            class="mb-0 py-1 px-2"><small>Index Value</small><br>
            <span class="">{{currentOffer.bid.index.average_price}} {{tenderSettings.currency.code + ' /
              ' +
              tenderSettings.units.code}}</span>
          </p>
        </div>
        <div [ngStyle]="{ 'order' : $safeNavigationMigration(usOrderedFields?.differential) }" class="va-cell row-index-7 differential"
          *ngIf="!(usHiddenFields && usHiddenFields[VIEW_FIELDS?.DIFFERENTIAL] === false)">
          <div class="d-flex w-100">
            {{ currentOffer.bid['exchanged_differential'] }} {{baseCurrency.code}} / {{baseUnit.code}}
            &nbsp;
            <ng-template #popConv2Title>Supplier's Input</ng-template>
            <ng-template #popConv2Content>
              <p>This value was entered in different currency and units.</p>
              <p class="mb-0"><strong>{{currentOffer.bid.differential?.getLabel()}}</strong></p>
            </ng-template>
            <a href="javascript:void(0)"
              *ngIf="isConverted($safeNavigationMigration(currentOffer.bid.differential?.price?.currency?.code), $safeNavigationMigration(currentOffer.bid.differential?.units?.code))"
              [ngbPopover]="popConv2Content" [popoverTitle]="popConv2Title" class="ms-auto">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                class="lucide lucide-git-compare-arrows">
                <circle cx="5" cy="6" r="3" />
                <path d="M12 6h5a2 2 0 0 1 2 2v7" />
                <path d="m15 9-3-3 3-3" />
                <circle cx="19" cy="18" r="3" />
                <path d="M12 18H7a2 2 0 0 1-2-2V9" />
                <path d="m9 15 3 3-3 3" />
              </svg>
            </a>
          </div>
        </div>
        <div [ngStyle]="{ 'order' : $safeNavigationMigration(usOrderedFields?.volume_fees) }" class="va-cell row-index-8 vol-fees d-flex p-0"
          *ngIf="!(usHiddenFields && usHiddenFields[VIEW_FIELDS?.VOLUME_FEES] === false) ">
          <ul class="list-group list-group-flush w-100 mb-auto">
            <li *ngFor="let volumeFee of currentOffer.bid['exchanged_volume_based_fees']; let index = index;"
              class="list-group-item py-1 px-2" [ngClass]="{'opacity-25': volumeFee.value == 0.0000}">
              <p class="mb-0"><small>{{volumeFee.name}}</small><br>
                <span class="">{{volumeFee.value}} {{baseCurrency.code}} / {{baseUnit.code}}</span>
                <ng-template #popConv3Title>Supplier's Input</ng-template>
                <ng-template #popConv3Content>
                  <div>
                    <p>This value was entered in different currency and units.</p>
                    <span class="">{{volumeFee['original']['value']}}
                      {{volumeFee['original']['currency']}}
                      /
                      {{volumeFee['original']['unit']}}</span>
                  </div>
                </ng-template>
                <a href="javascript:void(0)"
                  *ngIf="isConverted(volumeFee['original']['currency'], volumeFee['original']['unit'])"
                  [ngbPopover]="popConv3Content" [popoverTitle]="popConv3Title"
                  class="float-end">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                    class="lucide lucide-git-compare-arrows">
                    <circle cx="5" cy="6" r="3" />
                    <path d="M12 6h5a2 2 0 0 1 2 2v7" />
                    <path d="m15 9-3-3 3-3" />
                    <circle cx="19" cy="18" r="3" />
                    <path d="M12 18H7a2 2 0 0 1-2-2V9" />
                    <path d="m9 15 3 3-3 3" />
                  </svg>
                </a>
                <input type="checkbox" [(ngModel)]="volumeFee['is_add_in_total']" [ngModelOptions]="{standalone: true}"
                  (ngModelChange)="onIncludeTotalFeesCurrentOffers($event, volumeFee, currentOffer)"
                  class="form-check-input total-check-fees" title="Include in total"
                  [disabled]="!user.canManage(tender)">
              </p>
            </li>
            <li *ngFor="let volumeFee of currentOffer.bid.volumeFeesPercent; let index = index;"
              class="list-group-item py-1 px-2">
              <span>
                {{volumeFee.percent + '% '}}
                <span *ngIf="volumeFee.based_fee">
                  {{volumeFee.based_fee.name}} {{volumeFee?.based_fee?.notes}}
                </span>
              </span>
            </li>
          </ul>
        </div>
        <div [ngStyle]="{ 'order' : $safeNavigationMigration(usOrderedFields?.custom_volume_fees) }"
          class="va-cell row-index-9 airline-vol-fees d-flex p-0"
          *ngIf="!(usHiddenFields && usHiddenFields[VIEW_FIELDS?.CUSTOM_VOLUME_FEES] === false) && !tender?.company?.settings?.isHiddenField('bid_custom_volume_fees')">
          <ul class="list-group list-group-flush w-100 mb-auto">
            <li
              *ngFor="let volumeFee of currentOffer.bid['exchanged_volume_based_fees_airline_input']; let index = index;"
              class="list-group-item py-1 px-2">
              <p class="mb-0"><small>{{volumeFee.name}}</small><br>
                <span class="">{{volumeFee.value}} {{baseCurrency.code}} / {{baseUnit.code}}</span>
              </p>
            </li>
          </ul>
        </div>
        <div [ngStyle]="{ 'order' : $safeNavigationMigration(usOrderedFields?.volume_fees_total) }" class="va-cell row-index-10 total-vol-fees"
          *ngIf="!(usHiddenFields && usHiddenFields[VIEW_FIELDS?.TOTAL_VOLUME_FEES] === false)">
          {{ currentOffer.bid['volume_fees_total'] }} {{baseCurrency.code}} / {{baseUnit.code}}
        </div>
        <div [ngStyle]="{ 'order' : $safeNavigationMigration(usOrderedFields?.total_fields) }" class="va-cell row-index-11 total-fields">
          {{ currentOffer.bid['total_field'] | number:'1.2-6' }} {{baseCurrency.code}} / {{baseUnit.code}}
        </div>
        <div [ngStyle]="{ 'order' : $safeNavigationMigration(usOrderedFields?.ranking) }"
          *ngIf="!(usHiddenFields && usHiddenFields[VIEW_FIELDS?.RANKING] === false)"
          class="va-cell row-index-12 ranking">
        </div>
        <div [ngStyle]="{ 'order' : $safeNavigationMigration(usOrderedFields?.ranking_gap) }"
          *ngIf="!(usHiddenFields && usHiddenFields[VIEW_FIELDS?.RANKING_GAP] === false) && !tender?.company?.settings?.isHiddenField('bid_gap_from_total')"
          class="va-cell row-index-13 ranking-gap">
        </div>
        <div [ngStyle]="{ 'order' : $safeNavigationMigration(usOrderedFields?.event_fees) }" class="va-cell row-index-14 event-fees d-flex p-0"
          *ngIf="!(usHiddenFields && usHiddenFields[VIEW_FIELDS?.EVENT_FEES] === false)">
          <div class="mb-auto list-group list-group-flush w-100 mb-auto">
            <div class="list-group-item py-1 px-2" *ngFor="let perUsageFee of currentOffer.bid['exchanged_per_fees']"
              [ngClass]="{'opacity-25': perUsageFee.value == 0.0000}">
              <p class="mb-0"><small>{{perUsageFee.name}}</small><br>
                <span class="">
                  {{perUsageFee.value}} {{baseCurrency.code}}
                  <ng-template #popConv7Title>Supplier's Input</ng-template>
                  <ng-template #popConv7Content>
                    <div>
                      <p>This value was entered in different currency and units.</p>
                      <span class="">{{perUsageFee['original']['value']}}
                        {{perUsageFee['original']['currency']}}</span>
                    </div>
                  </ng-template>
                  <a href="javascript:void(0)"
                    *ngIf="isConverted(perUsageFee['original']['currency'])"
                    [ngbPopover]="popConv7Content" [popoverTitle]="popConv7Title"
                    class="float-end">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
                      stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                      class="lucide lucide-git-compare-arrows">
                      <circle cx="5" cy="6" r="3" />
                      <path d="M12 6h5a2 2 0 0 1 2 2v7" />
                      <path d="m15 9-3-3 3-3" />
                      <circle cx="19" cy="18" r="3" />
                      <path d="M12 18H7a2 2 0 0 1-2-2V9" />
                      <path d="m9 15 3 3-3 3" />
                    </svg>
                  </a>
                  <input type="checkbox" [(ngModel)]="perUsageFee['is_add_in_total']"
                    [ngModelOptions]="{standalone: true}"
                    (ngModelChange)="onIncludeTotalPerFeesCurrentOffers($event, perUsageFee, currentOffer)"
                    class="form-check-input total-check-fees" title="Include in total"
                  [disabled]="!user.canManage(tender)">
                </span>
              </p>
            </div>
          </div>
        </div>
        <div [ngStyle]="{ 'order' : $safeNavigationMigration(usOrderedFields?.total_event_fees) }" class="va-cell row-index-15 total-event-fees"
          *ngIf="!(usHiddenFields && usHiddenFields[VIEW_FIELDS?.TOTAL_EVENT_FEES] === false)">
          {{ currentOffer.bid['per_uplift_fees_total'] }} {{baseCurrency.code}}
        </div>
        <div [ngStyle]="{ 'order' : $safeNavigationMigration(usOrderedFields?.wacc) }" class="va-cell row-index-17 wacc wacc-value"
          *ngIf="!(usHiddenFields && usHiddenFields[VIEW_FIELDS?.WACC] === false)"></div>
        <div [ngStyle]="{ 'order' : $safeNavigationMigration(usOrderedFields?.saf_mandate) }" class="va-cell row-index-18 saf-mandate"
          *ngIf="!tender?.company?.settings?.isHiddenField('bid_saf_mandate') && !(usHiddenFields && usHiddenFields[VIEW_FIELDS?.SAF_MANDATE] === false)">
          {{currentOffer.bid.safMandate}}</div>
        <div [ngStyle]="{ 'order' : $safeNavigationMigration(usOrderedFields?.saf_mandate_blend) }" class="va-cell row-index-19 saf-mandate-blend"
          *ngIf="!tender?.company?.settings?.isHiddenField('bid_saf_mandate_blend') && !(usHiddenFields && usHiddenFields[VIEW_FIELDS?.SAF_MANDATE_BLEND] === false)">
          <span *ngIf="currentOffer.bid.safMandateBlend !== null && currentOffer.bid.safMandateBlend !== undefined">
            {{ currentOffer.bid.safMandateBlend }}%
          </span>
        </div>
        <div [ngStyle]="{ 'order' : $safeNavigationMigration(usOrderedFields?.saf_fee_amount) }" class="va-cell row-index-23 saf-fee-amount"
          *ngIf="!tender?.company?.settings?.isHiddenField('bid_saf_fee_amount') && !(usHiddenFields && usHiddenFields[VIEW_FIELDS?.SAF_FEE_AMOUNT] === false)">
          <jft-converted-amount [value]="currentOffer.bid['exchanged_fee_amount']"
            [currencyCode]="baseCurrency.code" [unitCode]="baseUnit.code"
            [originalValue]="$safeNavigationMigration(currentOffer.bid.safFeeAmountUnits?.price?.value)"
            [originalCurrencyCode]="$safeNavigationMigration(currentOffer.bid.safFeeAmountUnits?.price?.currency?.code)"
            [originalUnitCode]="$safeNavigationMigration(currentOffer.bid.safFeeAmountUnits?.units?.code)"></jft-converted-amount>
        </div>
        <div [ngStyle]="{ 'order' : $safeNavigationMigration(usOrderedFields?.neat_saf) }" class="va-cell row-index-20 saf-neat"
          *ngIf="!tender?.company?.settings?.isHiddenField('bid_neat_saf_mandated_price') && !(usHiddenFields && usHiddenFields[VIEW_FIELDS?.NEAT_SAF] === false)">
          {{neatSafOf(currentOffer.bid)?.getLabel?.() ?? ''}}</div>
        <div [ngStyle]="{ 'order' : $safeNavigationMigration(usOrderedFields?.neat_saf_volume) }" class="va-cell row-index-21 saf-neat-vol"
          *ngIf="!tender?.company?.settings?.isHiddenField('bid_neat_saf_volume') && !(usHiddenFields && usHiddenFields[VIEW_FIELDS?.NEAT_SAF_VOLUME] === false)">
          {{currentOffer.bid.neatSafVolume}}</div>
        <!-- Dynamic formula value cells -->
        <ng-container *ngFor="let fKey of dynamicFormulaKeys">
          <div [ngStyle]="{ 'order' : $safeNavigationMigration(usOrderedFields?.[fKey]) }" class="va-cell row-index-31 sum-diff-vol"
            *ngIf="!(usHiddenFields && usHiddenFields[fKey] === false)" [ngbPopover]="currentOfferFormulaPopover"
            [popoverTitle]="$safeNavigationMigration(activeFormulas[fKey]?.name)" triggers="mouseenter:mouseleave" container="body">
            {{ currentOffer.bid[fKey] | number: '1.' }} {{baseCurrency.code}} / {{baseUnit.code}}
            <ng-template #currentOfferFormulaPopover>
              <div class="small">
                <div class="text-muted mb-1">{{ formulaLabels[fKey] }}</div>
                <div *ngIf="getFormulaTooltip(fKey, currentOffer.bid) as tt">
                  <code>{{ tt.values }} = {{ tt.result | number:'1.2-6' }}</code>
                </div>
              </div>
            </ng-template>
          </div>
        </ng-container>
        <div [ngStyle]="{ 'order' : $safeNavigationMigration(usOrderedFields?.non_mandatory_fees) }"
          class="va-cell row-index-37 non-mandatory-fees d-flex"
          *ngIf="!(usHiddenFields && usHiddenFields[VIEW_FIELDS?.NON_MANDATORY_FEES] === false) && !tender?.company?.settings?.isHiddenField('bid_non_mandatory_fees')">
          <div class="mb-auto text-wrap">
            <jft-read-more-modal [title]="'Non-mandatory fees'" [text]="currentOffer.bid.nonMandatoryFeesText">
            </jft-read-more-modal>
          </div>
        </div>
        <div [ngStyle]="{ 'order' : $safeNavigationMigration(usOrderedFields?.payment_type) }" class="va-cell row-index-38 payment-type"
          *ngIf="!(usHiddenFields && usHiddenFields[VIEW_FIELDS?.PAYMENT_TYPE] === false) && !tender?.company?.settings?.isHiddenField('bid_payment_type')">
          <div>
            {{ currentOffer.bid.getPaymentTypeLabel() }}
          </div>
        </div>
        <div [ngStyle]="{ 'order' : $safeNavigationMigration(usOrderedFields?.payment_terms) }" class="va-cell row-index-39 payment-terms p-0"
          *ngIf="!(usHiddenFields && usHiddenFields[VIEW_FIELDS?.PAYMENT_TERMS] === false) && !tender?.company?.settings?.isHiddenField('bid_payment_terms')">

          <ul class="list-group list-group-flush"
            *ngIf="currentOffer.bid.payment?.prepayment && !tender?.company?.settings?.isHiddenField('bid_prepayment')">
            <li class="list-group-item py-1 px-2"
              *ngIf="!tender?.company?.settings?.isHiddenField('bid_prepayment_number_of_days_prepaid')">
              <p class="mb-0"><small>Number of Days Prepaid</small><br>
                <span class="">{{currentOffer.bid.payment?.prepayment?.number_days_prepaid}}</span>
              </p>
            </li>
            <li class="list-group-item py-1 px-2"
              *ngIf="!tender?.company?.settings?.isHiddenField('bid_prepayment_payment_first_delivery')">
              <p class="mb-0"><small>First Delivery Date</small><br>
                <span class="">{{currentOffer.bid.payment?.prepayment?.payment_first_delivery_date}}</span>
              </p>
            </li>
            <li class="list-group-item py-1 px-2"
              *ngIf="!tender?.company?.settings?.isHiddenField('bid_prepayment_payment_frequency')">
              <p class="mb-0"><small>Prepayment Frequency</small><br>
                <span class="">{{currentOffer.bid.payment?.prepayment?.payment_frequency.name}}</span>
              </p>
            </li>
            <li class="list-group-item py-1 px-2"
              *ngIf="!tender?.company?.settings?.isHiddenField('bid_prepayment_amount')">
              <p class="mb-0"><small>Prepayment Amount</small><br>
                <span class="">{{currentOffer.bid.payment?.prepayment?.amount}}</span>
              </p>
            </li>
          </ul>

          <ul class="list-group list-group-flush"
            *ngIf="currentOffer.bid.payment?.open_invoice && !tender?.company?.settings?.isHiddenField('bid_open_invoice')">
            <li class="list-group-item py-1 px-2"
              *ngIf="currentOffer.bid.payment?.open_invoice?.payment_terms && !tender?.company?.settings?.isHiddenField('bid_payment_terms')">
              <p class="mb-0"><small>Number of Days Credit</small><br>
                <span class="">{{currentOffer.bid.payment?.open_invoice?.payment_terms}}</span>
              </p>
            </li>
            <li class="list-group-item py-1 px-2"
              *ngIf="currentOffer.bid.payment?.payment_reference_date?.name && !tender?.company?.settings?.isHiddenField('bid_payment_reference_date')">
              <p class="mb-0"><small>Payment Reference Date</small><br>
                <span class="">{{currentOffer.bid.payment?.payment_reference_date?.name}}</span>
              </p>
            </li>
            <li class="list-group-item py-1 px-2"
              *ngIf="currentOffer.bid.getOpenInvoiceFrequencyLabel(tender) && (!tender?.company?.settings?.isHiddenField('bid_open_invoice_invoice_frequency'))">
              <p class="mb-0"><small>Invoice Frequency</small><br>
                <span class="">{{currentOffer.bid.getOpenInvoiceFrequencyLabel(tender)}}</span>
              </p>
            </li>
            <li class="list-group-item py-1 px-2"
              *ngIf="currentOffer.bid.getOpenInvoiceTypeLabel(tender) && !tender?.company?.settings?.isHiddenField('bid_invoice_type')">
              <p class="mb-0"><small>Invoice Type</small><br>
                <span class="">{{currentOffer.bid.getOpenInvoiceTypeLabel(tender)}}</span>
              </p>
            </li>
          </ul>


        </div>
        <div [ngStyle]="{ 'order' : $safeNavigationMigration(usOrderedFields?.payment_currency) }" class="va-cell row-index-40 payment-currency"
          *ngIf="!(usHiddenFields && usHiddenFields[VIEW_FIELDS?.PAYMENT_CURRENCY] === false) && !tender?.company?.settings?.isHiddenField('bid_payment_currency')">
          {{ currentOffer.bid.getPaymentCurrencyLabel() }}
        </div>
        <div [ngStyle]="{ 'order' : $safeNavigationMigration(usOrderedFields?.payment_unit) }" class="va-cell row-index-41 payment-unit"
          *ngIf="!(usHiddenFields && usHiddenFields[VIEW_FIELDS?.PAYMENT_UNIT] === false) && !tender?.company?.settings?.isHiddenField('bid_payment_unit')">
          {{ currentOffer.bid.getPaymentUnitLabel() }}
        </div>
        <div [ngStyle]="{ 'order' : usOrderedFields.payment_method }" class="va-cell row-index-42 payment-method"
          *ngIf="!(usHiddenFields && usHiddenFields[VIEW_FIELDS?.PAYMENT_METHOD] === false) && !tender?.company?.settings?.isHiddenField('bid_method_of_payment')">
          {{ currentOffer.bid.getPaymentMethodLabel() }}
        </div>
        <div [ngStyle]="{ 'order' : $safeNavigationMigration(usOrderedFields?.guarantees_deposits_required) }"
          class="va-cell row-index-43 deposit"
          *ngIf="!(usHiddenFields && usHiddenFields[VIEW_FIELDS?.GUARANTEES_DEPOSITS_REQUIRED] === false) && !tender?.company?.settings?.isHiddenField('bid_guarantees_deposits_required')">
          <span>
            {{ currentOffer.bid.getPaymentGuaranteesDeposit() }}
          </span>
        </div>
        <div [ngStyle]="{ 'order' : $safeNavigationMigration(usOrderedFields?.bank_guarantee_amount) }"
          class="va-cell row-index-44 bank-guarantee-amount"
          *ngIf="!(usHiddenFields && usHiddenFields[VIEW_FIELDS?.BANK_GUARANTEE_AMOUNT] === false) && !tender?.company?.settings?.isHiddenField('bank_guarantee_amount')">
          <span>
            {{ currentOffer.bid.bankGuaranteeAmount | number:'1.2-2' }}
          </span>
        </div>
        <div [ngStyle]="{ 'order' : $safeNavigationMigration(usOrderedFields?.bank_guarantee_currency) }"
          class="va-cell row-index-45 bank-guarantee-currency"
          *ngIf="!(usHiddenFields && usHiddenFields[VIEW_FIELDS?.BANK_GUARANTEE_CURRENCY] === false) && !tender?.company?.settings?.isHiddenField('bank_guarantee_currency')">
          <span>
            {{ currentOffer.bid.bankGuaranteeCurrency ? currencies.getById(currentOffer.bid.bankGuaranteeCurrency)?.code
            : '' }}
          </span>
        </div>
        <div [ngStyle]="{ 'order' : $safeNavigationMigration(usOrderedFields?.transit_time) }" class="va-cell row-index-46 transit-time"
          *ngIf="!(usHiddenFields && usHiddenFields[VIEW_FIELDS?.TRANSIT_TIME] === false) && !tender?.company?.settings?.isHiddenField('transit_time')">
          <span>
            {{ currentOffer.bid.transitTime }}
          </span>
        </div>
        <div [ngStyle]="{ 'order' : usOrderedFields.fin_source }" class="va-cell row-index-46 fin-source" *ngIf="false">
          {{currentOffer.bid.getRateFinancialSourceLabel()}}
        </div>
        <div [ngStyle]="{ 'order' : usOrderedFields.fin_averaging_method }"
          class="va-cell row-index-47 fin-averaging-method" *ngIf="false">
          {{currentOffer.bid.getRateAverageingMethodLabel()}}
        </div>
        <div [ngStyle]="{ 'order' : usOrderedFields.fin_averaging_offset }"
          class="va-cell row-index-48 fin-averaging-offset" *ngIf="false">
          {{currentOffer.bid.getRateAveragingOffsetLabel()}}
        </div>
        <div [ngStyle]="{ 'order' : $safeNavigationMigration(usOrderedFields?.invoice_frequency) }" class="va-cell row-index-49 invoice-frequency"
          *ngIf="!(usHiddenFields && usHiddenFields[VIEW_FIELDS?.INVOICE_FREQUENCY] === false) && !tender?.company?.settings?.isHiddenField('bid_open_invoice_invoice_frequency')">
          {{currentOffer.bid.getOpenInvoiceFrequencyLabel(tender)}}
        </div>
        <div [ngStyle]="{ 'order' : $safeNavigationMigration(usOrderedFields?.invoice_type) }" class="va-cell row-index-50 invoice-type"
          *ngIf="!(usHiddenFields && usHiddenFields[VIEW_FIELDS?.INVOICE_TYPE] === false) && !tender?.company?.settings?.isHiddenField('bid_invoice_type')">
          {{currentOffer.bid.getOpenInvoiceTypeLabel(tender)}}
        </div>
        <div [ngStyle]="{ 'order' : $safeNavigationMigration(usOrderedFields?.payment_reference_date) }"
          class="va-cell row-index-51 payment-reference-date"
          *ngIf="!(usHiddenFields && usHiddenFields[VIEW_FIELDS?.PAYMENT_REFERENCE_DATE] === false) && !tender?.company?.settings?.isHiddenField('bid_payment_reference_date')">
          {{currentOffer.bid.getOpenInvoiceReferenceDateLabel()}}
        </div>
        <div [ngStyle]="{ 'order' : $safeNavigationMigration(usOrderedFields?.payment_details) }" class="va-cell row-index-52 payment-details p-0"
          *ngIf="!(usHiddenFields && usHiddenFields[VIEW_FIELDS?.PAYMENT_DETAILS] === false) && (!tender?.company?.settings?.isHiddenField('bid_exchange_rate') || !tender?.company?.settings?.isHiddenField('bid_ex_rate_financial_source') || !tender?.company?.settings?.isHiddenField('bid_ex_rate_averageing_method'))">

          <ul class="list-group list-group-flush"
            *ngIf="currentOffer.bid.payment && currentOffer.bid.payment.exchange_rate">
            <li class="list-group-item py-1 px-2"
              *ngIf="!tender?.company?.settings?.isHiddenField('bid_ex_rate_financial_source')">
              <p class="mb-0"><small>Financial Source</small><br>
                <span class="">{{currentOffer.bid.payment?.exchange_rate?.financial_source}}</span>
              </p>
            </li>
            <li class="list-group-item py-1 px-2"
              *ngIf="!tender?.company?.settings?.isHiddenField('bid_ex_rate_averageing_method')">
              <p class="mb-0"><small>Exchange Rate Averaging</small><br>
                <span class="">{{currentOffer.bid.payment?.exchange_rate?.averageing_method?.name}}</span>
              </p>
            </li>
          </ul>

        </div>
        <div [ngStyle]="{ 'order' : usOrderedFields.intoplane }" class="va-cell row-index-51 intoplane" *ngIf="false">
          {{ currentOffer.bid.fuelPreference.name}}
        </div>
        <div [ngStyle]="{ 'order' : usOrderedFields.open_release }" class="va-cell row-index-52 open-release"
          *ngIf="!(usHiddenFields && usHiddenFields[VIEW_FIELDS?.OPEN_RELEASE] === false) && !tender?.company?.settings?.isHiddenField('bid_open_fuel_release')">
          <span>{{ currentOffer.bid.getopenFuelReleaseLabel() }}</span>
        </div>
        <div [ngStyle]="{ 'order' : usOrderedFields.gross_or_net_billing }" class="va-cell row-index-53 gross-net"
          *ngIf="!(usHiddenFields && usHiddenFields[VIEW_FIELDS?.GROSS_OR_NET_BILLING] === false) && !tender?.company?.settings?.isHiddenField('bid_gross_or_net_billing')">
          {{ currentOffer.bid.grossNetBilling?.getLabel() }}
        </div>
        <div [ngStyle]="{ 'order' : usOrderedFields.iata_service_level }"
          class="va-cell row-index-54 iata-service-level"
          *ngIf="!(usHiddenFields && usHiddenFields[VIEW_FIELDS?.IATA_SERVICE_LEVEL] === false) && !tender?.company?.settings?.isHiddenField('bid_iata_service_level')">
          {{ currentOffer.bid.iataServiceLevel?.name }}
        </div>
        <div [ngStyle]="{ 'order' : usOrderedFields.into_plane_service_provider }"
          class="va-cell row-index-55 into-plane-provider"
          *ngIf="!(usHiddenFields && usHiddenFields[VIEW_FIELDS?.INTO_PLANE_SERVICE_PROVIDER] === false) && !tender?.company?.settings?.isHiddenField('bid_into_plane_service_provider')">
          {{ currentOffer.bid.intoPlaneServiceProvider?.name || currentOffer.bid.intoPlane }}
        </div>
        <div [ngStyle]="{ 'order' : usOrderedFields.delivery_airport }"
          *ngIf="!(usHiddenFields && usHiddenFields[VIEW_FIELDS?.DELIVERY_AIRPORT] === false) && isAirPortDeliveryMethods()"
          class="va-cell row-index-56 delivery-airport p-0">
          <ul class="list-group list-group-flush" *ngIf="currentOffer.bid">
            <li class="list-group-item py-1 px-2"
              *ngFor="let airPortDelivery of currentOffer.bid.airPortDeliveryMethods">
              <p class="mb-0">
                <small>{{airPortDelivery.method.name}}</small><br>
                <span>{{airPortDelivery.percentage ? airPortDelivery.percentage + '%' : '-'}}</span>
                <span *ngIf="airPortDelivery.isPrimary"> - Primary</span>
              </p>
            </li>
          </ul>
        </div>
        <div [ngStyle]="{ 'order' : usOrderedFields.delivery_aircraft }"
          *ngIf="!(usHiddenFields && usHiddenFields[VIEW_FIELDS?.DELIVERY_AIRCRAFT] === false) && isAirCraftDeliveryMethods()"
          class="va-cell row-index-57 delivery-aircraft">
          <div class="value">
            <span>{{ currentOffer.bid.airCraftDeliveryMethod.name }}</span>
          </div>
        </div>
        <div [ngStyle]="{ 'order' : usOrderedFields.pre_flight_notification }"
          class="va-cell row-index-58 pre-flight-notification d-flex w-100"
          *ngIf="!(usHiddenFields && usHiddenFields[VIEW_FIELDS?.PRE_FLIGHT_NOTIFICATION] === false) && (!tender?.company?.settings?.isHiddenField('bid_pre_flight_notification_notes') || !tender?.company?.settings?.isHiddenField('bid_pre_flight_notification_hours'))">
          <div class="mb-auto text-wrap">
            <jft-read-more-modal [title]="'Pre-flight notification'"
              [text]="$safeNavigationMigration(currentOffer.bid.preFlightNotification?.getLabel())"></jft-read-more-modal>
          </div>
        </div>
        <div [ngStyle]="{ 'order' : usOrderedFields.ramp }" class="va-cell row-index-59 ramp d-flex w-100"
          *ngIf="!(usHiddenFields && usHiddenFields[VIEW_FIELDS?.RAMP] === false) && !tender?.company?.settings?.isHiddenField('bid_ramp_limitations_notes')">
          <div class="mb-auto text-wrap">
            <jft-read-more-modal [title]="'Ramp limitations'" [text]="$safeNavigationMigration(currentOffer.bid.rampLimitations?.getLabel())">
            </jft-read-more-modal>
          </div>
        </div>
        <div [ngStyle]="{ 'order' : $safeNavigationMigration(usOrderedFields?.open_hours) }" class="va-cell row-index-60 open-hours d-flex w-100"
          *ngIf="!(usHiddenFields && usHiddenFields[VIEW_FIELDS?.OPEN_HOURS] === false) && !tender?.company?.settings?.isHiddenField('bid_open_hours')">
          <div class="mb-auto text-wrap">
            <jft-read-more-modal [title]="'Operating Hours'" [text]="$safeNavigationMigration(currentOffer.bid.fuelAvailability?.getLabel())">
            </jft-read-more-modal>
          </div>
        </div>
        <div [ngStyle]="{ 'order' : usOrderedFields.weight_conversion_factor }"
          class="va-cell row-index-61 weight-conversion-factor" *ngIf="false">
          <span>{{ currentOffer.bid.supplyCondition.volumeConversion }}</span>
        </div>
        <div [ngStyle]="{ 'order' : $safeNavigationMigration(usOrderedFields?.fuel_availability) }" class="va-cell row-index-62 fuel-availability"
          *ngIf="!(usHiddenFields && usHiddenFields[VIEW_FIELDS?.FUEL_AVAILABILITY] === false) && !tender?.company?.settings?.isHiddenField('bid_fuel_availability')">
          <span>{{ currentOffer.bid.fuelAvailabilityPercentage }}%</span>
        </div>
        <div [ngStyle]="{ 'order' : $safeNavigationMigration(usOrderedFields?.contract_start) }" class="va-cell row-index-63 contract-start"
          *ngIf="!(usHiddenFields && usHiddenFields[VIEW_FIELDS?.CONTRACT_START] === false)">
          <span *ngIf="currentOffer.round?.contract && currentOffer.round?.contract?.dateStart">
            {{ currentOffer.round?.contract?.dateStart.toFormat(defaultDateFormat, { zone: "utc" }) }}
          </span>
        </div>
        <div [ngStyle]="{ 'order' : $safeNavigationMigration(usOrderedFields?.contract_end) }" class="va-cell row-index-64 contract-end"
          *ngIf="!(usHiddenFields && usHiddenFields[VIEW_FIELDS?.CONTRACT_END] === false)">
          <span *ngIf="currentOffer.round?.contract && currentOffer.round?.contract?.dateEnd">
            {{ currentOffer.round?.contract?.dateEnd.toFormat(defaultDateFormat, { zone: "utc" }) }}
          </span>
        </div>
        <div
          *ngIf="!tender?.company?.settings?.isHiddenField('bid_saf_blend_volume') && !(usHiddenFields && usHiddenFields[VIEW_FIELDS?.SAF_BLENDED_VOLUME] === false)"
          [ngStyle]="{ 'order' : $safeNavigationMigration(usOrderedFields?.saf_blended_volume) }" class="va-cell row-index-22">
          <span *ngIf="currentOffer.bid.safMandateBlend !== null && currentOffer.bid.safMandateBlend !== undefined">
            {{ $safeNavigationMigration(contract?.volume) * (currentOffer.bid.safMandateBlend / 100) | number: '1.'}} {{contract?.units.code}}
          </span>
        </div>
        <div
          *ngIf="!tender?.company?.settings?.isHiddenField('bid_saf_cost') && !(usHiddenFields && usHiddenFields[VIEW_FIELDS?.SAF_COST] === false)"
          [ngStyle]="{ 'order' : $safeNavigationMigration(usOrderedFields?.saf_cost) }" class="va-cell row-index-24">
          <jft-converted-amount [value]="currentOffer.bid['exchanged_saf_cost']"
            [currencyCode]="baseCurrency.code" format="1.0-3"
            [originalValue]="currentOffer.bid['original_saf_cost']"
            [originalCurrencyCode]="currentOffer.bid['neat_saf_currency']"
            heading="In Supplier's Currency"
            note="Derived from the supplier's neat SAF price, which was entered in a different currency."></jft-converted-amount>
        </div>
        <div
          *ngIf="!tender?.company?.settings?.isHiddenField('bid_saf_premium') && !(usHiddenFields && usHiddenFields[VIEW_FIELDS?.SAF_PREMIUM] === false)"
          [ngStyle]="{ 'order' : $safeNavigationMigration(usOrderedFields?.saf_premium) }" class="va-cell row-index-25">
          <jft-converted-amount [value]="currentOffer.bid['exchanged_saf_premium']"
            [currencyCode]="baseCurrency.code" [unitCode]="baseUnit.code" format="1.0-4"
            [originalValue]="currentOffer.bid['original_saf_premium']"
            [originalCurrencyCode]="currentOffer.bid['neat_saf_currency']"
            [originalUnitCode]="currentOffer.bid['neat_saf_unit']"
            heading="In Supplier's Currency"
            note="Derived from the supplier's neat SAF price, which was entered in a different currency or unit."></jft-converted-amount>
        </div>
        <div
          *ngIf="!tender?.company?.settings?.isHiddenField('bid_conventional_jet_percentage') && !(usHiddenFields && usHiddenFields[VIEW_FIELDS?.CONVENTIONAL_JET_PERCENTAGE] === false)"
          [ngStyle]="{ 'order' : $safeNavigationMigration(usOrderedFields?.conventional_jet_percentage) }" class="va-cell row-index-26">
          <span *ngIf="currentOffer.bid.safMandateBlend !== null && currentOffer.bid.safMandateBlend !== undefined">
            {{ 100 - currentOffer.bid.safMandateBlend | number: '1.'}} {{'%'}}
          </span>
        </div>
        <div
          *ngIf="!tender?.company?.settings?.isHiddenField('bid_conventional_jet_percentage_price') && !(usHiddenFields && usHiddenFields[VIEW_FIELDS?.CONVENTIONAL_JET_PERCENTAGE_PRICE] === false)"
          [ngStyle]="{ 'order' : $safeNavigationMigration(usOrderedFields?.conventional_jet_percentage_price) }" class="va-cell row-index-27">
          <span *ngIf="currentOffer.bid.differential?.price && currentOffer.bid.safMandateBlend">
            {{ ((currentOffer.bid.index && currentOffer.bid.index.average_price ? currentOffer.bid.index.average_price :
            0) + currentOffer.bid['diff_plus_vbfees']) * ((100 - currentOffer.bid.safMandateBlend)/100) | number:
            '1.'}}
            {{baseCurrency.code}}
          </span>
        </div>
        <div
          *ngIf="!tender?.company?.settings?.isHiddenField('bid_conventional_jet_and_saf_premium') && !(usHiddenFields && usHiddenFields[VIEW_FIELDS?.CONVENTIONAL_JET_AND_SAF_PREMIUM] === false)"
          [ngStyle]="{ 'order' : $safeNavigationMigration(usOrderedFields?.conventional_jet_and_saf_premium) }" class="va-cell row-index-28">
          <span *ngIf="currentOffer.bid['exchanged_conventional_jet_and_saf_premium'] !== null">
            {{ currentOffer.bid['exchanged_conventional_jet_and_saf_premium'] | number: '1.0-4'}}
            {{ baseCurrency.code }} / {{ baseUnit.code }}
          </span>
        </div>
        <div
          *ngIf="!tender?.company?.settings?.isHiddenField('bid_conventional_jet_volume') && !(usHiddenFields && usHiddenFields[VIEW_FIELDS?.CONVENTIONAL_JET_VOLUME] === false)"
          [ngStyle]="{ 'order' : $safeNavigationMigration(usOrderedFields?.conventional_jet_volume) }" class="va-cell row-index-29">
          <span *ngIf="currentOffer.bid.safMandateBlend !== null && currentOffer.bid.safMandateBlend !== undefined">
            {{ $safeNavigationMigration(contract?.volume) * ((100 - currentOffer.bid.safMandateBlend) / 100) | number: '1.'}}
            {{ contract?.units.code }}
          </span>
        </div>
        <div
          *ngIf="!tender?.company?.settings?.isHiddenField('bid_conventional_jet_cost') && !(usHiddenFields && usHiddenFields[VIEW_FIELDS?.CONVENTIONAL_JET_COST] === false)"
          [ngStyle]="{ 'order' : $safeNavigationMigration(usOrderedFields?.conventional_jet_cost) }" class="va-cell row-index-30">
          <span *ngIf="currentOffer.bid.differential?.price && currentOffer.bid.safMandateBlend">
            {{
            ($safeNavigationMigration(contract?.volume) | unitExchange: $safeNavigationMigration(contract?.units.code) : unitRates: baseUnit.code) *
            ((currentOffer.bid.differential.price.value | unitExchange:
            currentOffer.bid.differential.units.code : unitRates: baseUnit.code) *
            (100 - currentOffer.bid.safMandateBlend)) | number: '1.'}}
            {{ currentOffer.bid.differential.units.code }}
          </span>
        </div>
        <div [ngStyle]="{ 'order' : $safeNavigationMigration(usOrderedFields?.supply_conditions_notes) }"
          class="va-cell row-index-65 supplier-comments d-flex"
          *ngIf="!(usHiddenFields && usHiddenFields[VIEW_FIELDS?.SUPPLY_CONDITIONS_NOTES] === false)">
          <div class="mb-auto text-wrap">
            <jft-read-more-modal [title]="'Supplier Comments'" [text]="currentOffer.bid.comments">
            </jft-read-more-modal>
          </div>
        </div>
        <div [ngStyle]="{ 'order' : $safeNavigationMigration(usOrderedFields?.notes) }" class="va-cell row-index-66 notes d-flex"
          *ngIf="!(usHiddenFields && usHiddenFields[VIEW_FIELDS?.BID_NOTES] === false)">
          <div class="mb-auto text-wrap">
            <jft-read-more-modal [title]="'Bid Notes'" [text]="currentOffer.bid.note"></jft-read-more-modal>
          </div>
        </div>
        <div [ngStyle]="{ 'order' : $safeNavigationMigration(usOrderedFields?.shared_files) }" class="va-cell row-index-67 shared-files d-flex"
          *ngIf="!(usHiddenFields && usHiddenFields[VIEW_FIELDS?.SHARED_FILES] === false)">
          <ul class="list-group list-group-flush w-100 mb-auto">
            <li *ngFor='let file of currentOffer.supplierRequestedDocument'
              class="list-group-item px-0 py-1 px-0 py-1 small">
              <a class="pointer d-flex align-items-center" (click)="downloadDocument(file.file)" placement="top"
                ngbTooltip="{{file.name }}">
                <i class="fas fa-file-alt me-2"></i>
                <span class="d-inline-block text-truncate">
                  {{file.name }}
                </span>
              </a>
            </li>
          </ul>
        </div>
        <div [ngStyle]="{ 'order' : usOrderedFields.bid_feedback }" class="va-cell row-index-68 bid-feedback"
          *ngIf="isBidFeedbacks">
          <div class="mb-auto text-wrap">
            <jft-read-more-modal [title]="'Previous Round Feedback'"
              [text]="currentOffer.bid.feedback"></jft-read-more-modal>
          </div>
        </div>
        <div [ngStyle]="{ 'order' : $safeNavigationMigration(usOrderedFields?.awarded_contract_volume) }"
          class="va-cell row-index-69 awarded-contract-volume text-center">
          <span *ngIf="supplier && supplier?.awardedPercent">{{$safeNavigationMigration(contract?.volume) /100 *
            $safeNavigationMigration(supplier?.awardedPercent) | number
            : '1.0-0' | usNumber}} {{contract?.units.code}}</span>
        </div>
        <div [ngStyle]="{ 'order' : $safeNavigationMigration(usOrderedFields?.awarded_monthly_volume) }"
          class="va-cell row-index-70 awarded-monthly-volume text-center">
          <span *ngIf="supplier && supplier?.awardedPercent">{{ $safeNavigationMigration(contract?.volume) / contract.monthService /
            100 *
            $safeNavigationMigration(supplier?.awardedPercent) | number : '1.0-0' | usNumber }} {{contract?.units.code}}</span>
        </div>
        <div [ngStyle]="{ 'order' : $safeNavigationMigration(usOrderedFields?.weight_to_volume) }"
          class="va-cell row-index-71 weight_to_volume text-center"
          *ngIf="!(usHiddenFields && usHiddenFields[VIEW_FIELDS?.WEIGHT_TO_VOLUME] === false)">
        </div>
        <div [ngStyle]="{ 'order' : $safeNavigationMigration(usOrderedFields?.status) }" class="va-cell row-index-73 award-comment text-center">
        </div>
        <div [ngStyle]="{ 'order' : $safeNavigationMigration(usOrderedFields?.status) }" class="va-cell row-index-72 status text-center">
          <div class="flex-grow-1">
            <ng-container *ngIf="isCurrentRound()">
              <jft-offer-status [signature]="currentOffer.bid.signature" [status]="currentOffer.status"
                [awardedPercent]="currentOffer.awardedPercent">
              </jft-offer-status>
              <div class="row" *ngIf="currentOffer.status == offerStatuses.RECEIVED && user.canManage(tender)">
                <div class="col">
                  <jft-award-button
                    *ngIf="[roundStatuses.ACTIVE, roundStatuses.TENTATIVE_AWARDED, roundStatuses.AWAITING_REVIEW, roundStatuses.EXPIRED].includes($safeNavigationMigration(round?.status))"
                    [class]="'btn btn-outline-primary btn-sm w-100 mt-2'" [popoverPlacement]="'top'"
                    [offer]="currentOffer" [contract]="contract" [loadingAward]="loadingAward"
                    (onAward)="award($event)">
                  </jft-award-button>
                </div>
              </div>
            </ng-container>
          </div>
        </div>
      </div>

      <div class="va-column mock-contract" [style.order]="mockOffer._displayOrder || 999"
        *ngFor="let mockOffer of mockOffers; let index = index;">
        <div [ngStyle]="{ 'order' : usOrderedFields.bid_status }" class="va-cell row-index-1 bid-status">
          <div class="badge-status badge-status-yellow">
            Mock Offer
          </div>
        </div>
        <div [ngStyle]="{ 'order' : $safeNavigationMigration(usOrderedFields?.supplier) }" class="va-cell va-header-row row-index-2 supplier">
          <p class="mb-0 mt-2">{{mockOffer.name }}</p>
        </div>
        <div [ngStyle]="{ 'order' : $safeNavigationMigration(usOrderedFields?.offer_id) }" class="va-cell row-index-3 offer-id p-0">
          <div class="d-flex list-group list-group-flush w-100">
            <div class="list-group-item px-2 py-1">
              <span class="text-muted small">Mock Bid</span>
            </div>
            <div class="list-group-item px-2 py-1">
              <div ngbDropdown placement="bottom-start" autoClose="outside" class="bid-menu-dropdown">
                <button type="button" ngbDropdownToggle
                        class="btn btn-sm btn-light bid-menu-toggle d-flex align-items-center justify-content-between w-100">
                  <span><i class="fas fa-bars me-2 text-muted"></i>Bid Menu</span>
                </button>
                <div ngbDropdownMenu class="bid-menu-panel">
                  <button type="button" ngbDropdownItem class="bid-menu-item"
                          *ngIf="user.canManage(tender)"
                          (click)="removeMockBid(mockOffer)">
                    <i class="fas fa-trash bid-menu-icon"></i><span class="bid-menu-label">Delete Bid</span>
                  </button>
                  <button type="button" ngbDropdownItem class="bid-menu-item"
                          *ngIf="user.canManage(tender)"
                          (click)="hideColumn($safeNavigationMigration(mockOffer?.id))">
                    <i class="fas fa-eye-slash bid-menu-icon"></i><span class="bid-menu-label">Hide Bid</span>
                  </button>
                  <div *ngIf="user.canManage(tender)" class="bid-menu-item-wrapper">
                    <i class="fas fa-pen bid-menu-icon"></i>
                    <jft-bid-edit-modal [tender]="tender" [contract]="contract" [offer]="mockOffer"
                      (onUpdated)="onUpdatedBidModal($event, mockOffer)"></jft-bid-edit-modal>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div [ngStyle]="{ 'order' : $safeNavigationMigration(usOrderedFields?.delivery_point) }" class="va-cell row-index-4 delivery-point"
          *ngIf="!(usHiddenFields && usHiddenFields[VIEW_FIELDS?.DELIVERY_POINT] === false)">
          {{tender?.company?.settings?.getFilteredOptionLabel('delivery_point',
          $safeNavigationMigration(mockOffer.bid?.fuelPreference))}}
        </div>
        <div [ngStyle]="{ 'order' : $safeNavigationMigration(usOrderedFields?.price_base) }" class="va-cell row-index-5 price-base d-flex p-0"
          *ngIf="!(usHiddenFields && usHiddenFields[VIEW_FIELDS?.PRICE_BASE] === false)">
          <div class="mb-auto list-group list-group-flush w-100"
            *ngIf="mockOffer.bid.marketPrice && mockOffer.bid.marketPrice.price">
            <div class="list-group-item px-2 py-1" *ngIf="mockOffer.bid.marketPrice.source_type">
              <p class="mb-0"><small>Market Price Source</small><br>
                <span class="text-capitalize">{{mockOffer.bid.marketPrice.source_type?.name}}</span>
              </p>
            </div>
            <div class="list-group-item px-2 py-1" *ngIf="mockOffer.bid.marketPrice.source_name">
              <p class="mb-0"><small>Market Price Detail</small><br>
                <span class="text-capitalize">{{mockOffer.bid.marketPrice.source_name}}</span>
              </p>
            </div>
            <div class="list-group-item px-2 py-1"
              *ngIf="mockOffer.bid.marketPrice['file'] && mockOffer.bid.marketPrice['file']['name']">
              <p class="mb-0"><small>Document</small><br>
                <a class="pointer d-flex align-items-center"
                  (click)="downloadDocument(mockOffer.bid.marketPrice['file'])" placement="top"
                  ngbTooltip="{{mockOffer.bid.marketPrice['file']['name'] }}">
                  <i class="fas fa-file-alt me-2"></i>
                  <span class="d-inline-block text-truncate">
                    {{ mockOffer.bid.marketPrice['file']['name'] }}
                  </span>
                </a>
              </p>
            </div>
          </div>

          <div class="mb-auto list-group list-group-flush w-100" *ngIf="mockOffer.bid.index">
            <div class="list-group-item px-2 py-1">
              <p class="mb-0"><small>Index Provider</small><br>
                <span class="text-capitalize">{{mockOffer.bid.index.index_code.provider}}</span>
              </p>
            </div>
            <div class="list-group-item px-2 py-1">
              <p class="mb-0"><small>Index Code</small><br>
                <span class="">{{tender?.company?.settings?.getFilteredOptionLabel('index',
                  mockOffer.bid.index.index_code, 'code')}}</span>
                - {{mockOffer.bid.index.bate?.name}}
              </p>
            </div>
            <div class="list-group-item px-2 py-1"
              *ngIf="!tender?.company?.settings?.isHiddenField('bid_averaging_method')">
              <p class="mb-0"><small>Index Averaging</small><br>
                <span class="text-capitalize">{{tender?.company?.settings?.getFilteredOptionLabel('averaging_method',
                  $safeNavigationMigration(mockOffer.bid.index?.averaging_method))}}</span>
              </p>
            </div>
            <div class="list-group-item px-2 py-1"
              *ngIf="!tender?.company?.settings?.isHiddenField('bid_average_offset') && mockOffer.bid.index.averaging_offset?.name">
              <p class="mb-0"><small>Index Averaging Offset</small><br>
                <span class="">{{mockOffer.bid.index.averaging_offset?.name}}</span>
              </p>
            </div>
            <div class="list-group-item px-2 py-1"
              *ngIf="!tender?.company?.settings?.isHiddenField('bid_effective_day')">
              <p class="mb-0"><small>Price Effective Day</small><br>
                <span class="">{{mockOffer.bid.index.effective_day?.name}}</span>
              </p>
            </div>
          </div>
        </div>
        <div [ngStyle]="{ 'order' : $safeNavigationMigration(usOrderedFields?.average_price_base) }"
          class="va-cell row-index-6 average-price-base p-0"
          *ngIf="!(usHiddenFields && usHiddenFields[VIEW_FIELDS?.AVERAGE_PRICE_BASE] === false)">
          <p *ngIf="mockOffer.bid.index && isAveragePriceEnabled && mockOffer.bid.index.index_code.provider && mockOffer.bid.index.average_price != null && mockOffer.bid.index.average_price !== 0"
            class="mb-0 py-1 px-2"><small>Index Value</small><br>
            <span class="">{{mockOffer.bid.index.average_price}} {{tenderSettings.currency.code + ' / '
              +
              tenderSettings.units.code}}</span>
          </p>
        </div>
        <div [ngStyle]="{ 'order' : $safeNavigationMigration(usOrderedFields?.differential) }" class="va-cell row-index-7 differential"
          *ngIf="!(usHiddenFields && usHiddenFields[VIEW_FIELDS?.DIFFERENTIAL] === false)">
          <div class="d-flex w-100">
            {{ mockOffer.bid['exchanged_differential'] }} {{baseCurrency.code}} / {{baseUnit.code}}
            &nbsp;
            <ng-template #popConv2Title>Supplier's Input</ng-template>
            <ng-template #popConv2Content>
              <p>This value was entered in different currency and units.</p>
              <p class="mb-0"><strong>{{mockOffer.bid.differential?.getLabel()}}</strong></p>
            </ng-template>
            <a href="javascript:void(0)"
              *ngIf="isConverted($safeNavigationMigration(mockOffer.bid.differential?.price?.currency?.code), $safeNavigationMigration(mockOffer.bid.differential?.units?.code))"
              [ngbPopover]="popConv2Content" [popoverTitle]="popConv2Title" class="ms-auto">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                class="lucide lucide-git-compare-arrows">
                <circle cx="5" cy="6" r="3" />
                <path d="M12 6h5a2 2 0 0 1 2 2v7" />
                <path d="m15 9-3-3 3-3" />
                <circle cx="19" cy="18" r="3" />
                <path d="M12 18H7a2 2 0 0 1-2-2V9" />
                <path d="m9 15 3 3-3 3" />
              </svg>
            </a>
          </div>
        </div>
        <div [ngStyle]="{ 'order' : $safeNavigationMigration(usOrderedFields?.volume_fees) }" class="va-cell row-index-8 vol-fees d-flex p-0"
          *ngIf="!(usHiddenFields && usHiddenFields[VIEW_FIELDS?.VOLUME_FEES] === false) ">
          <ul class="list-group list-group-flush w-100 mb-auto">
            <li *ngFor="let volumeFee of mockOffer.bid['exchanged_volume_based_fees']; let index = index;"
              class="list-group-item py-1 px-2" [ngClass]="{'opacity-25': volumeFee.value == 0.0000}">
              <p class="mb-0"><small>{{volumeFee.name}}</small><br>
                <span class="">{{volumeFee.value}} {{baseCurrency.code}} / {{baseUnit.code}}</span>
                <ng-template #popConv3Title>Supplier's Input</ng-template>
                <ng-template #popConv3Content>
                  <div>
                    <p>This value was entered in different currency and units.</p>
                    <span class="">{{volumeFee['original']['value']}}
                      {{volumeFee['original']['currency']}}
                      /
                      {{volumeFee['original']['unit']}}</span>
                  </div>
                </ng-template>
                <a href="javascript:void(0)"
                  *ngIf="isConverted(volumeFee['original']['currency'], volumeFee['original']['unit'])"
                  [ngbPopover]="popConv3Content" [popoverTitle]="popConv3Title"
                  class="float-end">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                    class="lucide lucide-git-compare-arrows">
                    <circle cx="5" cy="6" r="3" />
                    <path d="M12 6h5a2 2 0 0 1 2 2v7" />
                    <path d="m15 9-3-3 3-3" />
                    <circle cx="19" cy="18" r="3" />
                    <path d="M12 18H7a2 2 0 0 1-2-2V9" />
                    <path d="m9 15 3 3-3 3" />
                  </svg>
                </a>
                <input type="checkbox" [(ngModel)]="volumeFee['is_add_in_total']" [ngModelOptions]="{standalone: true}"
                  (ngModelChange)="onIncludeTotalFeesMockOffers($event, volumeFee, mockOffer)"
                  class="form-check-input total-check-fees" title="Include in total"
                  [disabled]="!user.canManage(tender)">
              </p>
            </li>
            <li *ngFor="let volumeFee of mockOffer.bid.volumeFeesPercent; let index = index;"
              class="list-group-item py-1 px-2">
              <span>
                {{volumeFee.percent + '% '}}
                <span *ngIf="volumeFee.based_fee">
                  {{volumeFee.based_fee.name}} {{volumeFee?.based_fee?.notes}}
                </span>
              </span>
            </li>
          </ul>
        </div>
        <div [ngStyle]="{ 'order' : $safeNavigationMigration(usOrderedFields?.custom_volume_fees) }"
          class="va-cell row-index-9 airline-vol-fees d-flex p-0"
          *ngIf="!(usHiddenFields && usHiddenFields[VIEW_FIELDS?.CUSTOM_VOLUME_FEES] === false) && !tender?.company?.settings?.isHiddenField('bid_custom_volume_fees')">
          <ul class="list-group list-group-flush w-100 mb-auto">
            <li *ngFor="let volumeFee of mockOffer.bid['exchanged_volume_based_fees_airline_input']; let index = index;"
              class="list-group-item py-1 px-2">
              <p class="mb-0"><small>{{volumeFee.name}}</small><br>
                <span class="">{{volumeFee.value}} {{baseCurrency.code}} / {{baseUnit.code}}</span>
              </p>
            </li>
          </ul>
        </div>
        <div [ngStyle]="{ 'order' : $safeNavigationMigration(usOrderedFields?.volume_fees_total) }" class="va-cell row-index-10 total-vol-fees"
          *ngIf="!(usHiddenFields && usHiddenFields[VIEW_FIELDS?.TOTAL_VOLUME_FEES] === false)">
          {{ mockOffer.bid['volume_fees_total'] }} {{baseCurrency.code}} / {{baseUnit.code}}
        </div>
        <div [ngStyle]="{ 'order' : $safeNavigationMigration(usOrderedFields?.total_fields) }" class="va-cell row-index-11 total-fields">
          {{ mockOffer.bid['total_field'] | number:'1.2-6' }} {{baseCurrency.code}} / {{baseUnit.code}}
        </div>
        <div [ngStyle]="{ 'order' : $safeNavigationMigration(usOrderedFields?.ranking) }"
          *ngIf="!(usHiddenFields && usHiddenFields[VIEW_FIELDS?.RANKING] === false)"
          class="va-cell row-index-12 ranking">
          {{ mockOffer.bid['ranking'] }}
        </div>
        <div [ngStyle]="{ 'order' : $safeNavigationMigration(usOrderedFields?.ranking_gap) }"
          *ngIf="!(usHiddenFields && usHiddenFields[VIEW_FIELDS?.RANKING_GAP] === false) && !tender?.company?.settings?.isHiddenField('bid_gap_from_total')"
          class="va-cell row-index-13 ranking-gap">
          {{ mockOffer.bid['ranking_gap'] }} {{baseCurrency.code}} / {{baseUnit.code}}
        </div>
        <div [ngStyle]="{ 'order' : $safeNavigationMigration(usOrderedFields?.event_fees) }" class="va-cell row-index-14 event-fees d-flex p-0"
          *ngIf="!(usHiddenFields && usHiddenFields[VIEW_FIELDS?.EVENT_FEES] === false)">
          <div class="mb-auto list-group list-group-flush w-100 mb-auto">
            <div class="list-group-item py-1 px-2" *ngFor="let perUsageFee of mockOffer.bid['exchanged_per_fees']"
              [ngClass]="{'opacity-25': perUsageFee.value == 0.0000}">
              <p class="mb-0"><small>{{perUsageFee.name}}</small><br>
                <span class="">
                  {{perUsageFee.value}} {{baseCurrency.code}}
                  <ng-template #popConv7Title>Supplier's Input</ng-template>
                  <ng-template #popConv7Content>
                    <div>
                      <p>This value was entered in different currency and units.</p>
                      <span class="">{{perUsageFee['original']['value']}}
                        {{perUsageFee['original']['currency']}}</span>
                    </div>
                  </ng-template>
                  <a href="javascript:void(0)"
                    *ngIf="isConverted(perUsageFee['original']['currency'])"
                    [ngbPopover]="popConv7Content" [popoverTitle]="popConv7Title"
                    class="float-end">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
                      stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                      class="lucide lucide-git-compare-arrows">
                      <circle cx="5" cy="6" r="3" />
                      <path d="M12 6h5a2 2 0 0 1 2 2v7" />
                      <path d="m15 9-3-3 3-3" />
                      <circle cx="19" cy="18" r="3" />
                      <path d="M12 18H7a2 2 0 0 1-2-2V9" />
                      <path d="m9 15 3 3-3 3" />
                    </svg>
                  </a>
                  <input type="checkbox" [(ngModel)]="perUsageFee['is_add_in_total']"
                    [ngModelOptions]="{standalone: true}"
                    (ngModelChange)="onIncludeTotalPerFeesMockOffers($event, perUsageFee, mockOffer)"
                    class="form-check-input total-check-fees" title="Include in total"
                  [disabled]="!user.canManage(tender)">
                </span>
              </p>
            </div>
          </div>
        </div>
        <div [ngStyle]="{ 'order' : $safeNavigationMigration(usOrderedFields?.total_event_fees) }" class="va-cell row-index-15 total-event-fees"
          *ngIf="!(usHiddenFields && usHiddenFields[VIEW_FIELDS?.TOTAL_EVENT_FEES] === false)">
          {{ mockOffer.bid['per_uplift_fees_total'] }} {{baseCurrency.code}}
        </div>
        <div [ngStyle]="{ 'order' : $safeNavigationMigration(usOrderedFields?.wacc) }" class="va-cell row-index-17 wacc wacc-value"
          *ngIf="!(usHiddenFields && usHiddenFields[VIEW_FIELDS?.WACC] === false)">
          <span [ngbTooltip]="waccTooltipContentMock" [tooltipClass]="'wacc-tooltip'" placement="top" container="body">
            {{ mockOffer.bid.isPaymentPrepayment() ? 'Prepayment' :
            mockOffer.bid['exchanged_wacc']}} {{baseCurrency.code}} / {{baseUnit.code}}
          </span>

          <!-- WACC Calculation Tooltip Template for Mock Offers -->
          <ng-template #waccTooltipContentMock>
            <div class="wacc-calculation-details">
              <strong class="text-white">WACC Calculation:</strong><br>
              <div class="mt-2">
                <strong class="text-white">Formula:</strong><br>
                (WACC % / 365) × Payment Terms × Total Price × -1
              </div>
              <div class="mt-2">
                <strong class="text-white">Values:</strong><br>
                WACC %: {{ tenderSettings?.costOfCapital || 0 }}%<br>
                Payment Terms: <ng-container *ngIf="mockOffer.bid?.transitTime">{{
                  mockOffer.bid?.payment?.open_invoice?.payment_terms || 0 }} - {{ mockOffer.bid?.transitTime }}
                  (transit) = </ng-container>{{ getEffectivePaymentTerms(mockOffer.bid) }} days<br>
                Total Price: {{ $safeNavigationMigration(mockOffer.bid?.['total_field']) - (mockOffer.bid?.['exchanged_wacc'] || 0) | number:
                '1.4-4' }} {{baseCurrency.code}}/{{baseUnit.code}}
              </div>
              <div class="mt-2">
                <strong class="text-white">Calculation:</strong><br>
                ({{ tenderSettings?.costOfCapital || 0 }} / 100 / 365) × {{
                getEffectivePaymentTerms(mockOffer.bid) }} × {{ $safeNavigationMigration(mockOffer.bid?.['total_field']) -
                (mockOffer.bid?.['exchanged_wacc'] || 0) | number: '1.4-4' }} × -1<br>
                = <strong>{{ mockOffer.bid['exchanged_wacc'] }} {{baseCurrency.code}}/{{baseUnit.code}}</strong>
              </div>
            </div>
          </ng-template>
        </div>
        <div [ngStyle]="{ 'order' : $safeNavigationMigration(usOrderedFields?.saf_mandate) }" class="va-cell row-index-18 saf-mandate"
          *ngIf="!tender?.company?.settings?.isHiddenField('bid_saf_mandate') && !(usHiddenFields && usHiddenFields[VIEW_FIELDS?.SAF_MANDATE] === false)">
          {{mockOffer.bid.safMandate}}</div>
        <div [ngStyle]="{ 'order' : $safeNavigationMigration(usOrderedFields?.saf_mandate_blend) }" class="va-cell row-index-19 saf-blend"
          *ngIf="!tender?.company?.settings?.isHiddenField('bid_saf_mandate_blend') && !(usHiddenFields && usHiddenFields[VIEW_FIELDS?.SAF_MANDATE_BLEND] === false)">
          <span *ngIf="mockOffer.bid.safMandateBlend !== null && mockOffer.bid.safMandateBlend !== undefined">
            {{ mockOffer.bid.safMandateBlend }}%
          </span>
        </div>
        <div [ngStyle]="{ 'order' : $safeNavigationMigration(usOrderedFields?.saf_fee_amount) }" class="va-cell row-index-23 saf-fee-amount"
          *ngIf="!tender?.company?.settings?.isHiddenField('bid_saf_fee_amount') && !(usHiddenFields && usHiddenFields[VIEW_FIELDS?.SAF_FEE_AMOUNT] === false)">
          <jft-converted-amount [value]="mockOffer.bid['exchanged_fee_amount']"
            [currencyCode]="baseCurrency.code" [unitCode]="baseUnit.code"
            [originalValue]="$safeNavigationMigration(mockOffer.bid.safFeeAmountUnits?.price?.value)"
            [originalCurrencyCode]="$safeNavigationMigration(mockOffer.bid.safFeeAmountUnits?.price?.currency?.code)"
            [originalUnitCode]="$safeNavigationMigration(mockOffer.bid.safFeeAmountUnits?.units?.code)"></jft-converted-amount>
        </div>
        <div [ngStyle]="{ 'order' : $safeNavigationMigration(usOrderedFields?.neat_saf) }" class="va-cell row-index-20 saf-neat"
          *ngIf="!tender?.company?.settings?.isHiddenField('bid_neat_saf_mandated_price') && !(usHiddenFields && usHiddenFields[VIEW_FIELDS?.NEAT_SAF] === false)">
          {{neatSafOf(mockOffer.bid)?.getLabel?.() ?? ''}}</div>
        <div [ngStyle]="{ 'order' : $safeNavigationMigration(usOrderedFields?.neat_saf_volume) }" class="va-cell row-index-21 saf-neat-vol"
          *ngIf="!tender?.company?.settings?.isHiddenField('bid_neat_saf_volume') && !(usHiddenFields && usHiddenFields[VIEW_FIELDS?.NEAT_SAF_VOLUME] === false)">
          {{mockOffer.bid.neatSafVolume}}</div>
        <!-- Dynamic formula value cells -->
        <ng-container *ngFor="let fKey of dynamicFormulaKeys">
          <div [ngStyle]="{ 'order' : $safeNavigationMigration(usOrderedFields?.[fKey]) }" class="va-cell row-index-31 sum-diff-vol"
            *ngIf="!(usHiddenFields && usHiddenFields[fKey] === false)" [ngbPopover]="mockFormulaPopover"
            [popoverTitle]="$safeNavigationMigration(activeFormulas[fKey]?.name)" triggers="mouseenter:mouseleave" container="body">
            {{ mockOffer.bid[fKey] | number: '1.' }} {{baseCurrency.code}} / {{baseUnit.code}}
            <ng-template #mockFormulaPopover>
              <div class="small">
                <div class="text-muted mb-1">{{ formulaLabels[fKey] }}</div>
                <div *ngIf="getFormulaTooltip(fKey, mockOffer.bid) as tt">
                  <code>{{ tt.values }} = {{ tt.result | number:'1.2-6' }}</code>
                </div>
              </div>
            </ng-template>
          </div>
        </ng-container>
        <div [ngStyle]="{ 'order' : $safeNavigationMigration(usOrderedFields?.non_mandatory_fees) }"
          class="va-cell row-index-37 non-mandatory-fees d-flex"
          *ngIf="!(usHiddenFields && usHiddenFields[VIEW_FIELDS?.NON_MANDATORY_FEES] === false) && !tender?.company?.settings?.isHiddenField('bid_non_mandatory_fees')">
          <div class="mb-auto text-wrap">
            <jft-read-more-modal [title]="'Non-mandatory fees'" [text]="mockOffer.bid.nonMandatoryFeesText">
            </jft-read-more-modal>
          </div>
        </div>
        <div [ngStyle]="{ 'order' : $safeNavigationMigration(usOrderedFields?.payment_type) }" class="va-cell row-index-38 payment-type"
          *ngIf="!(usHiddenFields && usHiddenFields[VIEW_FIELDS?.PAYMENT_TYPE] === false) && !tender?.company?.settings?.isHiddenField('bid_payment_type')">
          <div>
            {{ mockOffer.bid.getPaymentTypeLabel() }}
          </div>
        </div>
        <div [ngStyle]="{ 'order' : $safeNavigationMigration(usOrderedFields?.payment_terms) }" class="va-cell row-index-39 payment-terms p-0"
          *ngIf="!(usHiddenFields && usHiddenFields[VIEW_FIELDS?.PAYMENT_TERMS] === false) && !tender?.company?.settings?.isHiddenField('bid_payment_terms')">

          <ul class="list-group list-group-flush"
            *ngIf="mockOffer.bid.payment?.prepayment && !tender?.company?.settings?.isHiddenField('bid_prepayment')">
            <li class="list-group-item py-1 px-2"
              *ngIf="!tender?.company?.settings?.isHiddenField('bid_prepayment_number_of_days_prepaid')">
              <p class="mb-0"><small>Number of Days Prepaid</small><br>
                <span class="">{{mockOffer.bid.payment?.prepayment?.number_days_prepaid}}</span>
              </p>
            </li>
            <li class="list-group-item py-1 px-2"
              *ngIf="!tender?.company?.settings?.isHiddenField('bid_prepayment_payment_first_delivery')">
              <p class="mb-0"><small>First Delivery Date</small><br>
                <span class="">{{mockOffer.bid.payment?.prepayment?.payment_first_delivery_date}}</span>
              </p>
            </li>
            <li class="list-group-item py-1 px-2"
              *ngIf="!tender?.company?.settings?.isHiddenField('bid_prepayment_payment_frequency')">
              <p class="mb-0"><small>Prepayment Frequency</small><br>
                <span class="">{{mockOffer.bid.payment?.prepayment?.payment_frequency.name}}</span>
              </p>
            </li>
            <li class="list-group-item py-1 px-2"
              *ngIf="!tender?.company?.settings?.isHiddenField('bid_prepayment_amount')">
              <p class="mb-0"><small>Prepayment Amount</small><br>
                <span class="">{{mockOffer.bid.payment?.prepayment?.amount}}</span>
              </p>
            </li>
          </ul>

          <ul class="list-group list-group-flush"
            *ngIf="mockOffer.bid.payment?.open_invoice && !tender?.company?.settings?.isHiddenField('bid_open_invoice')">
            <li class="list-group-item py-1 px-2"
              *ngIf="mockOffer.bid.payment?.open_invoice?.payment_terms && !tender?.company?.settings?.isHiddenField('bid_payment_terms')">
              <p class="mb-0"><small>Number of Days Credit</small><br>
                <span class="">{{mockOffer.bid.payment?.open_invoice?.payment_terms}}</span>
              </p>
            </li>
            <li class="list-group-item py-1 px-2"
              *ngIf="mockOffer.bid.payment?.payment_reference_date?.name && !tender?.company?.settings?.isHiddenField('bid_payment_reference_date')">
              <p class="mb-0"><small>Payment Reference Date</small><br>
                <span class="">{{mockOffer.bid.payment?.payment_reference_date?.name}}</span>
              </p>
            </li>
            <li class="list-group-item py-1 px-2"
              *ngIf="mockOffer.bid.getOpenInvoiceFrequencyLabel(tender) && (!tender?.company?.settings?.isHiddenField('bid_open_invoice_invoice_frequency'))">
              <p class="mb-0"><small>Invoice Frequency</small><br>
                <span class="">{{mockOffer.bid.getOpenInvoiceFrequencyLabel(tender)}}</span>
              </p>
            </li>
            <li class="list-group-item py-1 px-2"
              *ngIf="mockOffer.bid.getOpenInvoiceTypeLabel(tender) && !tender?.company?.settings?.isHiddenField('bid_invoice_type')">
              <p class="mb-0"><small>Invoice Type</small><br>
                <span class="">{{mockOffer.bid.getOpenInvoiceTypeLabel(tender)}}</span>
              </p>
            </li>
          </ul>


        </div>
        <div [ngStyle]="{ 'order' : $safeNavigationMigration(usOrderedFields?.payment_currency) }" class="va-cell row-index-40 payment-currency"
          *ngIf="!(usHiddenFields && usHiddenFields[VIEW_FIELDS?.PAYMENT_CURRENCY] === false) && !tender?.company?.settings?.isHiddenField('bid_payment_currency')">
          {{ mockOffer.bid.getPaymentCurrencyLabel() }}
        </div>
        <div [ngStyle]="{ 'order' : $safeNavigationMigration(usOrderedFields?.payment_unit) }" class="va-cell row-index-41 payment-unit"
          *ngIf="!(usHiddenFields && usHiddenFields[VIEW_FIELDS?.PAYMENT_UNIT] === false) && !tender?.company?.settings?.isHiddenField('bid_payment_unit')">
          {{ mockOffer.bid.getPaymentUnitLabel() }}
        </div>
        <div [ngStyle]="{ 'order' : usOrderedFields.payment_method }" class="va-cell row-index-42 payment-method"
          *ngIf="!(usHiddenFields && usHiddenFields[VIEW_FIELDS?.PAYMENT_METHOD] === false) && !tender?.company?.settings?.isHiddenField('bid_method_of_payment')">
          {{ mockOffer.bid.getPaymentMethodLabel() }}
        </div>
        <div [ngStyle]="{ 'order' : $safeNavigationMigration(usOrderedFields?.guarantees_deposits_required) }"
          class="va-cell row-index-43 deposit"
          *ngIf="!(usHiddenFields && usHiddenFields[VIEW_FIELDS?.GUARANTEES_DEPOSITS_REQUIRED] === false) && !tender?.company?.settings?.isHiddenField('bid_guarantees_deposits_required')">
          <span>
            {{ mockOffer.bid.getPaymentGuaranteesDeposit() }}
          </span>
        </div>
        <div [ngStyle]="{ 'order' : $safeNavigationMigration(usOrderedFields?.bank_guarantee_amount) }"
          class="va-cell row-index-44 bank-guarantee-amount"
          *ngIf="!(usHiddenFields && usHiddenFields[VIEW_FIELDS?.BANK_GUARANTEE_AMOUNT] === false) && !tender?.company?.settings?.isHiddenField('bank_guarantee_amount')">
          <span>
            {{ mockOffer.bid.bankGuaranteeAmount | number:'1.2-2' }}
          </span>
        </div>
        <div [ngStyle]="{ 'order' : $safeNavigationMigration(usOrderedFields?.bank_guarantee_currency) }"
          class="va-cell row-index-45 bank-guarantee-currency"
          *ngIf="!(usHiddenFields && usHiddenFields[VIEW_FIELDS?.BANK_GUARANTEE_CURRENCY] === false) && !tender?.company?.settings?.isHiddenField('bank_guarantee_currency')">
          <span>
            {{ mockOffer.bid.bankGuaranteeCurrency ? currencies.getById(mockOffer.bid.bankGuaranteeCurrency)?.code : ''
            }}
          </span>
        </div>
        <div [ngStyle]="{ 'order' : $safeNavigationMigration(usOrderedFields?.transit_time) }" class="va-cell row-index-46 transit-time"
          *ngIf="!(usHiddenFields && usHiddenFields[VIEW_FIELDS?.TRANSIT_TIME] === false) && !tender?.company?.settings?.isHiddenField('transit_time')">
          <span>
            {{ mockOffer.bid.transitTime }}
          </span>
        </div>
        <div [ngStyle]="{ 'order' : usOrderedFields.fin_source }" class="va-cell row-index-46 fin-source" *ngIf="false">
          {{mockOffer.bid.getRateFinancialSourceLabel()}}
        </div>
        <div [ngStyle]="{ 'order' : usOrderedFields.fin_averaging_method }"
          class="va-cell row-index-47 fin-averaging-method" *ngIf="false">
          {{mockOffer.bid.getRateAverageingMethodLabel()}}
        </div>
        <div [ngStyle]="{ 'order' : usOrderedFields.fin_averaging_offset }"
          class="va-cell row-index-48 fin-averaging-offset" *ngIf="false">
          {{mockOffer.bid.getRateAveragingOffsetLabel()}}
        </div>
        <div [ngStyle]="{ 'order' : $safeNavigationMigration(usOrderedFields?.invoice_frequency) }" class="va-cell row-index-49 invoice-frequency"
          *ngIf="!(usHiddenFields && usHiddenFields[VIEW_FIELDS?.INVOICE_FREQUENCY] === false) && !tender?.company?.settings?.isHiddenField('bid_open_invoice_invoice_frequency')">
          {{mockOffer.bid.getOpenInvoiceFrequencyLabel(tender)}}
        </div>
        <div [ngStyle]="{ 'order' : $safeNavigationMigration(usOrderedFields?.invoice_type) }" class="va-cell row-index-50 invoice-type"
          *ngIf="!(usHiddenFields && usHiddenFields[VIEW_FIELDS?.INVOICE_TYPE] === false) && !tender?.company?.settings?.isHiddenField('bid_invoice_type')">
          {{mockOffer.bid.getOpenInvoiceTypeLabel(tender)}}
        </div>
        <div [ngStyle]="{ 'order' : $safeNavigationMigration(usOrderedFields?.payment_reference_date) }"
          class="va-cell row-index-51 payment-reference-date"
          *ngIf="!(usHiddenFields && usHiddenFields[VIEW_FIELDS?.PAYMENT_REFERENCE_DATE] === false) && !tender?.company?.settings?.isHiddenField('bid_payment_reference_date')">
          {{mockOffer.bid.getOpenInvoiceReferenceDateLabel()}}
        </div>
        <div [ngStyle]="{ 'order' : $safeNavigationMigration(usOrderedFields?.payment_details) }" class="va-cell row-index-52 payment-details p-0"
          *ngIf="!(usHiddenFields && usHiddenFields[VIEW_FIELDS?.PAYMENT_DETAILS] === false) && (!tender?.company?.settings?.isHiddenField('bid_exchange_rate') || !tender?.company?.settings?.isHiddenField('bid_ex_rate_financial_source') || !tender?.company?.settings?.isHiddenField('bid_ex_rate_averageing_method'))">


          <ul class="list-group list-group-flush" *ngIf="mockOffer.bid.payment && mockOffer.bid.payment.exchange_rate">
            <li class="list-group-item py-1 px-2"
              *ngIf="!tender?.company?.settings?.isHiddenField('bid_ex_rate_financial_source')">
              <p class="mb-0"><small>Financial Source</small><br>
                <span class="">{{mockOffer.bid.payment?.exchange_rate?.financial_source}}</span>
              </p>
            </li>
            <li class="list-group-item py-1 px-2"
              *ngIf="!tender?.company?.settings?.isHiddenField('bid_ex_rate_averageing_method')">
              <p class="mb-0"><small>Exchange Rate Averaging</small><br>
                <span class="">{{mockOffer.bid.payment?.exchange_rate?.averageing_method?.name}}</span>
              </p>
            </li>
          </ul>

        </div>
        <div [ngStyle]="{ 'order' : usOrderedFields.intoplane }" class="va-cell row-index-51 intoplane" *ngIf="false">
          {{ mockOffer.bid.fuelPreference.name}}
        </div>
        <div [ngStyle]="{ 'order' : usOrderedFields.open_release }" class="va-cell row-index-52 open-release"
          *ngIf="!(usHiddenFields && usHiddenFields[VIEW_FIELDS?.OPEN_RELEASE] === false) && !tender?.company?.settings?.isHiddenField('bid_open_fuel_release')">
          <span>{{ mockOffer.bid.getopenFuelReleaseLabel() }}</span>
        </div>
        <div [ngStyle]="{ 'order' : usOrderedFields.gross_or_net_billing }" class="va-cell row-index-53 gross-net"
          *ngIf="!(usHiddenFields && usHiddenFields[VIEW_FIELDS?.GROSS_OR_NET_BILLING] === false) && !tender?.company?.settings?.isHiddenField('bid_gross_or_net_billing')">
          {{ mockOffer.bid.grossNetBilling?.getLabel() }}
        </div>
        <div [ngStyle]="{ 'order' : usOrderedFields.iata_service_level }"
          class="va-cell row-index-54 iata-service-level"
          *ngIf="!(usHiddenFields && usHiddenFields[VIEW_FIELDS?.IATA_SERVICE_LEVEL] === false) && !tender?.company?.settings?.isHiddenField('bid_iata_service_level')">
          {{ mockOffer.bid.iataServiceLevel?.name }}
        </div>
        <div [ngStyle]="{ 'order' : usOrderedFields.into_plane_service_provider }"
          class="va-cell row-index-55 into-plane-provider"
          *ngIf="!(usHiddenFields && usHiddenFields[VIEW_FIELDS?.INTO_PLANE_SERVICE_PROVIDER] === false) && !tender?.company?.settings?.isHiddenField('bid_into_plane_service_provider')">
          {{ mockOffer.bid.intoPlaneServiceProvider?.name || mockOffer.bid.intoPlane }}
        </div>
        <div [ngStyle]="{ 'order' : usOrderedFields.delivery_airport }"
          *ngIf="!(usHiddenFields && usHiddenFields[VIEW_FIELDS?.DELIVERY_AIRPORT] === false) && isAirPortDeliveryMethods()"
          class="va-cell row-index-56 delivery-airport p-0">
          <ul class="list-group list-group-flush" *ngIf="mockOffer.bid">
            <li class="list-group-item py-1 px-2" *ngFor="let airPortDelivery of mockOffer.bid.airPortDeliveryMethods">
              <p class="mb-0">
                <small>{{airPortDelivery.method.name}}</small><br>
                <span>{{airPortDelivery.percentage ? airPortDelivery.percentage + '%' : '-'}}</span>
                <span *ngIf="airPortDelivery.isPrimary"> - Primary</span>
              </p>
            </li>
          </ul>
        </div>
        <div [ngStyle]="{ 'order' : usOrderedFields.delivery_aircraft }"
          *ngIf="!(usHiddenFields && usHiddenFields[VIEW_FIELDS?.DELIVERY_AIRCRAFT] === false) && isAirCraftDeliveryMethods()"
          class="va-cell row-index-57 delivery-aircraft">
          <div class="value">
            <span>{{ mockOffer.bid.airCraftDeliveryMethod.name }}</span>
          </div>
        </div>
        <div [ngStyle]="{ 'order' : usOrderedFields.pre_flight_notification }"
          class="va-cell row-index-58 pre-flight-notification d-flex w-100"
          *ngIf="!(usHiddenFields && usHiddenFields[VIEW_FIELDS?.PRE_FLIGHT_NOTIFICATION] === false) && (!tender?.company?.settings?.isHiddenField('bid_pre_flight_notification_notes') || !tender?.company?.settings?.isHiddenField('bid_pre_flight_notification_hours'))">
          <div class="mb-auto text-wrap">
            <jft-read-more-modal [title]="'Pre-flight notification'"
              [text]="mockOffer.bid.preFlightNotification.displayLabel()"></jft-read-more-modal>
          </div>
        </div>
        <div [ngStyle]="{ 'order' : usOrderedFields.ramp }" class="va-cell row-index-59 ramp d-flex w-100"
          *ngIf="!(usHiddenFields && usHiddenFields[VIEW_FIELDS?.RAMP] === false) && !tender?.company?.settings?.isHiddenField('bid_ramp_limitations_notes')">
          <div class="mb-auto text-wrap">
            <jft-read-more-modal [title]="'Ramp limitations'" [text]="$safeNavigationMigration(mockOffer.bid.rampLimitations?.getLabel())">
            </jft-read-more-modal>
          </div>
        </div>
        <div [ngStyle]="{ 'order' : $safeNavigationMigration(usOrderedFields?.open_hours) }" class="va-cell row-index-60 open-hours d-flex w-100"
          *ngIf="!(usHiddenFields && usHiddenFields[VIEW_FIELDS?.OPEN_HOURS] === false) && !tender?.company?.settings?.isHiddenField('bid_open_hours')">
          <div class="mb-auto text-wrap">
            <jft-read-more-modal [title]="'Operating Hours'" [text]="$safeNavigationMigration(mockOffer.bid.fuelAvailability?.getLabel())">
            </jft-read-more-modal>
          </div>
        </div>
        <div [ngStyle]="{ 'order' : usOrderedFields.weight_conversion_factor }"
          class="va-cell row-index-61 weight-conversion-factor" *ngIf="false">
          <span>{{ mockOffer.bid.supplyCondition.volumeConversion }}</span>
        </div>
        <div [ngStyle]="{ 'order' : $safeNavigationMigration(usOrderedFields?.fuel_availability) }" class="va-cell row-index-62 fuel-availability"
          *ngIf="!(usHiddenFields && usHiddenFields[VIEW_FIELDS?.FUEL_AVAILABILITY] === false) && !tender?.company?.settings?.isHiddenField('bid_fuel_availability')">
          <span>{{ mockOffer.bid.fuelAvailabilityPercentage }}%</span>
        </div>
        <div [ngStyle]="{ 'order' : $safeNavigationMigration(usOrderedFields?.contract_start) }" class="va-cell row-index-63 contract-start"
          *ngIf="!(usHiddenFields && usHiddenFields[VIEW_FIELDS?.CONTRACT_START] === false)">
          <span *ngIf="mockOffer.bid.date_contract_start">
            {{ mockOffer.bid.date_contract_start.format(defaultDateFormat) }}
          </span>
        </div>
        <div [ngStyle]="{ 'order' : $safeNavigationMigration(usOrderedFields?.contract_end) }" class="va-cell row-index-64 contract-end"
          *ngIf="!(usHiddenFields && usHiddenFields[VIEW_FIELDS?.CONTRACT_END] === false)">
          <span *ngIf="mockOffer.bid.date_contract_end">
            {{ mockOffer.bid.date_contract_end.format(defaultDateFormat) }}
          </span>
        </div>
        <div
          *ngIf="!tender?.company?.settings?.isHiddenField('bid_saf_blend_volume') && !(usHiddenFields && usHiddenFields[VIEW_FIELDS?.SAF_BLENDED_VOLUME] === false)"
          [ngStyle]="{ 'order' : $safeNavigationMigration(usOrderedFields?.saf_blended_volume) }" class="va-cell row-index-22">
          <span *ngIf="mockOffer.bid.safMandateBlend !== null && mockOffer.bid.safMandateBlend !== undefined">
            {{ $safeNavigationMigration(contract?.volume) * (mockOffer.bid.safMandateBlend / 100) | number: '1.'}} {{contract?.units.code}}
          </span>
        </div>
        <div
          *ngIf="!tender?.company?.settings?.isHiddenField('bid_saf_cost') && !(usHiddenFields && usHiddenFields[VIEW_FIELDS?.SAF_COST] === false)"
          [ngStyle]="{ 'order' : $safeNavigationMigration(usOrderedFields?.saf_cost) }" class="va-cell row-index-24">
          <jft-converted-amount [value]="mockOffer.bid['exchanged_saf_cost']"
            [currencyCode]="baseCurrency.code" format="1.0-3"
            [originalValue]="mockOffer.bid['original_saf_cost']"
            [originalCurrencyCode]="mockOffer.bid['neat_saf_currency']"
            heading="In Supplier's Currency"
            note="Derived from the supplier's neat SAF price, which was entered in a different currency."></jft-converted-amount>
        </div>
        <div
          *ngIf="!tender?.company?.settings?.isHiddenField('bid_saf_premium') && !(usHiddenFields && usHiddenFields[VIEW_FIELDS?.SAF_PREMIUM] === false)"
          [ngStyle]="{ 'order' : $safeNavigationMigration(usOrderedFields?.saf_premium) }" class="va-cell row-index-25">
          <jft-converted-amount [value]="mockOffer.bid['exchanged_saf_premium']"
            [currencyCode]="baseCurrency.code" [unitCode]="baseUnit.code" format="1.0-4"
            [originalValue]="mockOffer.bid['original_saf_premium']"
            [originalCurrencyCode]="mockOffer.bid['neat_saf_currency']"
            [originalUnitCode]="mockOffer.bid['neat_saf_unit']"
            heading="In Supplier's Currency"
            note="Derived from the supplier's neat SAF price, which was entered in a different currency or unit."></jft-converted-amount>
        </div>
        <div
          *ngIf="!tender?.company?.settings?.isHiddenField('bid_conventional_jet_percentage') && !(usHiddenFields && usHiddenFields[VIEW_FIELDS?.CONVENTIONAL_JET_PERCENTAGE] === false)"
          [ngStyle]="{ 'order' : $safeNavigationMigration(usOrderedFields?.conventional_jet_percentage) }" class="va-cell row-index-26">
          <span *ngIf="mockOffer.bid.safMandateBlend !== null && mockOffer.bid.safMandateBlend !== undefined">
            {{ 100 - mockOffer.bid.safMandateBlend | number: '1.'}} {{'%'}}
          </span>
        </div>
        <div
          *ngIf="!tender?.company?.settings?.isHiddenField('bid_conventional_jet_percentage_price') && !(usHiddenFields && usHiddenFields[VIEW_FIELDS?.CONVENTIONAL_JET_PERCENTAGE_PRICE] === false)"
          [ngStyle]="{ 'order' : $safeNavigationMigration(usOrderedFields?.conventional_jet_percentage_price) }" class="va-cell row-index-27">
          <span *ngIf="mockOffer.bid.differential?.price && mockOffer.bid.safMandateBlend">
            {{ ((mockOffer.bid.index && mockOffer.bid.index.average_price ? mockOffer.bid.index.average_price : 0) +
            mockOffer.bid['diff_plus_vbfees']) * ((100 - mockOffer.bid.safMandateBlend)/100) | number:
            '1.'}}
            {{baseCurrency.code}}
          </span>
        </div>
        <div
          *ngIf="!tender?.company?.settings?.isHiddenField('bid_conventional_jet_and_saf_premium') && !(usHiddenFields && usHiddenFields[VIEW_FIELDS?.CONVENTIONAL_JET_AND_SAF_PREMIUM] === false)"
          [ngStyle]="{ 'order' : $safeNavigationMigration(usOrderedFields?.conventional_jet_and_saf_premium) }" class="va-cell row-index-28">
          <span *ngIf="mockOffer.bid['exchanged_conventional_jet_and_saf_premium'] !== null">
            {{ mockOffer.bid['exchanged_conventional_jet_and_saf_premium'] | number: '1.0-4'}}
            {{ baseCurrency.code }} / {{ baseUnit.code }}
          </span>
        </div>
        <div
          *ngIf="!tender?.company?.settings?.isHiddenField('bid_conventional_jet_volume') && !(usHiddenFields && usHiddenFields[VIEW_FIELDS?.CONVENTIONAL_JET_VOLUME] === false)"
          [ngStyle]="{ 'order' : $safeNavigationMigration(usOrderedFields?.conventional_jet_volume) }" class="va-cell row-index-29">
          <span *ngIf="mockOffer.bid.safMandateBlend !== null && mockOffer.bid.safMandateBlend !== undefined">
            {{ $safeNavigationMigration(contract?.volume) * ((100 - mockOffer.bid.safMandateBlend) / 100) | number: '1.'}}
            {{ contract?.units.code }}
          </span>
        </div>
        <div
          *ngIf="!tender?.company?.settings?.isHiddenField('bid_conventional_jet_cost') && !(usHiddenFields && usHiddenFields[VIEW_FIELDS?.CONVENTIONAL_JET_COST] === false)"
          [ngStyle]="{ 'order' : $safeNavigationMigration(usOrderedFields?.conventional_jet_cost) }" class="va-cell row-index-30">
          <span *ngIf="mockOffer.bid.differential?.price && mockOffer.bid.safMandateBlend">
            {{
            ($safeNavigationMigration(contract?.volume) | unitExchange: $safeNavigationMigration(contract?.units.code) : unitRates: baseUnit.code) *
            ((mockOffer.bid.differential.price.value | unitExchange:
            mockOffer.bid.differential.units.code : unitRates: baseUnit.code) *
            (100 - mockOffer.bid.safMandateBlend)) | number: '1.'}}
            {{ mockOffer.bid.differential.units.code }}
          </span>
        </div>
        <div [ngStyle]="{ 'order' : $safeNavigationMigration(usOrderedFields?.supply_conditions_notes) }"
          class="va-cell row-index-65 supplier-comments d-flex"
          *ngIf="!(usHiddenFields && usHiddenFields[VIEW_FIELDS?.SUPPLY_CONDITIONS_NOTES] === false)">
          <div class="mb-auto text-wrap">
            <jft-read-more-modal [title]="'Supplier Comments'" [text]="mockOffer.bid.comments">
            </jft-read-more-modal>
          </div>
        </div>
        <div [ngStyle]="{ 'order' : $safeNavigationMigration(usOrderedFields?.notes) }" class="va-cell row-index-66 notes d-flex"
          *ngIf="!(usHiddenFields && usHiddenFields[VIEW_FIELDS?.BID_NOTES] === false)">
          <div class="mb-auto text-wrap">
            <jft-read-more-modal [title]="'Bid Notes'" [text]="mockOffer.bid.note"></jft-read-more-modal>
          </div>
        </div>
        <div [ngStyle]="{ 'order' : $safeNavigationMigration(usOrderedFields?.shared_files) }" class="va-cell row-index-67 shared-files d-flex"
          *ngIf="!(usHiddenFields && usHiddenFields[VIEW_FIELDS?.SHARED_FILES] === false)">
          <ul class="list-group list-group-flush w-100 mb-auto">
            <li *ngFor='let file of mockOffer.supplierRequestedDocument'
              class="list-group-item px-0 py-1 px-0 py-1 small">
              <a class="pointer d-flex align-items-center" (click)="downloadDocument(file.file)" placement="top"
                ngbTooltip="{{file.name }}">
                <i class="fas fa-file-alt me-2"></i>
                <span class="d-inline-block text-truncate">
                  {{file.name }}
                </span>
              </a>
            </li>
          </ul>
        </div>
        <div [ngStyle]="{ 'order' : usOrderedFields.bid_feedback }" class="va-cell row-index-68 bid-feedback"
          *ngIf="isBidFeedbacks">
          <div class="mb-auto text-wrap">
            <jft-read-more-modal [title]="'Previous Round Feedback'"
              [text]="mockOffer.bid.feedback"></jft-read-more-modal>
          </div>
        </div>
        <div [ngStyle]="{ 'order' : $safeNavigationMigration(usOrderedFields?.awarded_contract_volume) }"
          class="va-cell row-index-69 awarded-contract-volume text-center">

        </div>
        <div [ngStyle]="{ 'order' : $safeNavigationMigration(usOrderedFields?.awarded_monthly_volume) }"
          class="va-cell row-index-70 awarded-monthly-volume text-center">

        </div>
        <div [ngStyle]="{ 'order' : $safeNavigationMigration(usOrderedFields?.weight_to_volume) }"
          class="va-cell row-index-71 weight_to_volume text-center"
          *ngIf="!(usHiddenFields && usHiddenFields[VIEW_FIELDS?.WEIGHT_TO_VOLUME] === false)">
        </div>
        <div [ngStyle]="{ 'order' : $safeNavigationMigration(usOrderedFields?.status) }" class="va-cell row-index-73 award-comment text-center">
        </div>
        <div [ngStyle]="{ 'order' : $safeNavigationMigration(usOrderedFields?.status) }" class="va-cell row-index-72 status text-center">
          <div class="badge-status badge-status-yellow">
            Mock Offer
          </div>
          <p class="mt-2 mb-0">{{mockOffer.name }}</p>
        </div>
      </div>

      @for (supplier of suppliers; track supplier.id; let i = $index) {
      @if (supplier && supplier.supplier) {
      <div class="va-column current-bids p-0 {{'row_id_' + i}}" [style.order]="supplier._displayOrder || 999">
        <div [ngStyle]="{ 'order' : usOrderedFields.bid_status }" class="va-cell row-index-1 bid-status text-center">
          <div class="flex-grow-1 mb-auto">

            <ng-container *ngIf="!isCurrentRound() && user.canManage(tender)">
              <button class="btn btn-outline-primary btn-sm w-100" placement="bottom"
                [popoverTitle]="'Copy Bid to Latest Round'" [autoClose]="true" #p="ngbPopover"
                [ngbPopover]="moveToRound">
                Copy Bid to Latest Round
              </button>
              <button *ngIf="[offerStatuses.DECLINED, offerStatuses.DECLINED_SUBMITTED].includes($safeNavigationMigration(supplier?.status))"
                class="btn btn-outline-primary btn-sm w-100 ms-2 mt-1" placement="bottom"
                [popoverTitle]="'Invite Supplier to Current Round'" #p="ngbPopover" [ngbPopover]="inviteSupplier"
                [autoClose]="true">
                Invite Supplier to Current Round
              </button>
              <ng-template #moveToRound>
                <button (click)="p.close()" class="btn btn-light w-100">
                  Cancel
                </button>
                <button (click)="moveToCurrentRound(supplier)" class="btn btn-outline-primary btn-sm w-100">
                  Copy Bid to Latest Round
                </button>
              </ng-template>
              <ng-template #inviteSupplier>
                <button (click)="p.close()" class="btn btn-light w-100">
                  Cancel
                </button>
                <button (click)="moveDeclinedToCurrentRound(supplier)" class="btn btn-outline-primary btn-sm w-100">
                  Invite Supplier to Current Round
                </button>
              </ng-template>
            </ng-container>
            <ng-container *ngIf="isCurrentRound()">
              <div class="">
                <jft-offer-status [signature]="supplier?.bid ? $safeNavigationMigration(supplier?.bid.signature) : null"
                  [status]="$safeNavigationMigration(supplier?.status)">
                </jft-offer-status>
                <ul class="list-group list-group-flush border-bottom text-start"
                  *ngIf="supplier?.bid && supplier?.status == offerStatuses.AWARDED">
                  <li class="list-group-item px-0 py-1 px-0 py-1">
                    <small>Award Type:</small><br>
                    <span
                      *ngIf="supplier?.awardSelfSupply && supplier?.awardSelfSupply == selfSupplyOptions.LOGISTICS">Logistics
                      Only</span>
                    <span
                      *ngIf="supplier?.awardSelfSupply && supplier?.awardSelfSupply == selfSupplyOptions.FUEL_ONLY">Fuel
                      Only</span>
                    <span *ngIf="!supplier?.awardSelfSupply">Fuel & Logistics</span>
                  </li>
                  <li class="list-group-item px-0 py-1 px-0 py-1"
                    *ngIf="supplier?.bid && supplier?.bid.date_contract_start">
                    <small>Award Contract Start Date:</small><br>
                    {{ supplier?.bid.date_contract_start.toDate() | date: defaultDateFormat :
                    'utc' }}
                  </li>
                  <li class="list-group-item px-0 py-1 px-0 py-1"
                    *ngIf="supplier?.bid && supplier?.bid.date_contract_end">
                    <small>Award Contract End Date:</small><br>
                    {{ supplier?.bid.date_contract_end.toDate() | date: defaultDateFormat : 'utc'
                    }}
                  </li>
                  <li class="list-group-item px-0 py-1 px-0 py-1">
                    <small>Percent:</small><br>
                    {{supplier?.awardedPercent}}%
                  </li>
                  <li class="list-group-item px-0 py-1 px-0 py-1">
                    <small>Supplier Confirmation:</small><br>
                    <ng-container *ngIf="supplier?.bid?.signature; else awaitingConfirmation">
                      <span class="text-success"><i class="fas fa-check me-1"></i>Confirmed</span>
                      <span *ngIf="supplier?.bid?.signed_at"> on {{ $safeNavigationMigration(supplier?.bid?.signed_at) | date: defaultDateFormat : 'utc' }}</span>
                      <span *ngIf="supplier?.bid?.signed_by_name"> by {{ supplier?.bid?.signed_by_name }}</span>
                    </ng-container>
                    <ng-template #awaitingConfirmation>
                      <span class="text-muted">Awaiting confirmation</span>
                    </ng-template>
                  </li>
                </ul>
                <div class="mt-2"
                  *ngIf="supplier?.bid && (!supplier?.bid.signature && supplier?.status == offerStatuses.AWARDED) && user.canManage(tender)">
                  <div class="mb-0" role="alert">
                    <button class="btn btn-danger btn-sm w-100" (click)="openCancelAwardModal(supplier)">
                      <span [hidden]="!loadingAward">
                        <div class="spinner-border spinner-border-sm me-1" role="status">
                          <span class="visually-hidden">Loading..</span>
                        </div>
                      </span>
                      Cancel Award
                    </button>
                  </div>
                </div>
              </div>
              <!-- Tentative Award Information Block -->
              <ul class="list-group list-group-flush small border-bottom text-start"
                *ngIf="supplier?.bid && (!supplier?.bid.signature && supplier?.status == offerStatuses.TENTATIVE_AWARDED)">
                <li class="list-group-item px-0 py-1 px-0 py-1">
                  <small>Award Type: </small><br>
                  <span
                    *ngIf="supplier?.awardSelfSupply && supplier?.awardSelfSupply == selfSupplyOptions.LOGISTICS">Logistics
                    Only</span>
                  <span
                    *ngIf="supplier?.awardSelfSupply && supplier?.awardSelfSupply == selfSupplyOptions.FUEL_ONLY">Fuel
                    Only</span>
                  <span *ngIf="!supplier?.awardSelfSupply">Fuel & Logistics</span>
                </li>
                <li class="list-group-item px-0 py-1 px-0 py-1"
                  *ngIf="supplier?.bid && supplier?.bid.date_contract_start">
                  <small>Award Contract Start Date:</small><br>
                  {{ supplier?.bid.date_contract_start.toDate() | date: defaultDateFormat :
                  'utc' }}
                </li>
                <li class="list-group-item px-0 py-1 px-0 py-1"
                  *ngIf="supplier?.bid && supplier?.bid.date_contract_end">
                  <small>Award Contract End Date: </small><br>
                  {{ supplier?.bid.date_contract_end.toDate() | date: defaultDateFormat : 'utc'
                  }}
                </li>
                <li class="list-group-item px-0 py-1 px-0 py-1">
                  <small>Percent: </small><br>
                  {{supplier?.awardedPercent}}%
                </li>
              </ul>
              <!-- Cancel Tentative Award Section -->
              <div class="mt-2"
                *ngIf="supplier?.bid && (!supplier?.bid.signature && supplier?.status == offerStatuses.TENTATIVE_AWARDED) && user.canManage(tender)">
                <div class="mb-0" role="alert">
                  <button class="btn btn-outline-primary btn-sm w-100"
                    (click)="openCancelTentativeAwardModal(supplier)">
                    <span [hidden]="!loadingAward">
                      <div class="spinner-border spinner-border-sm me-1" role="status">
                        <span class="visually-hidden">Loading..</span>
                      </div>
                    </span>
                    Cancel Tentative Award
                  </button>
                </div>
              </div>
              <div *ngIf="supplier?.status == offerStatuses.RECEIVED && user.canManage(tender)">
                <div class="row">

                  <div class="col">
                    <jft-award-button
                      *ngIf="[roundStatuses.ACTIVE, roundStatuses.TENTATIVE_AWARDED, roundStatuses.AWAITING_REVIEW, roundStatuses.EXPIRED].includes($safeNavigationMigration(round?.status))"
                      [class]="'btn btn-outline-primary btn-sm w-100 mt-2'" [popoverPlacement]="'bottom'"
                      [offer]="supplier" [contract]="contract" [loadingAward]="loadingAward" (onAward)="award($event)">
                    </jft-award-button>
                  </div>





                </div>
                <div class="row">
                  <div *ngIf="user.canManage(tender)" class="col">
                    <button type="button" class="btn btn-outline-primary btn-sm w-100 mt-2 text-nowrap"
                      [disabled]="loadingAward" (click)="openWithdrawBidModal(supplier)">
                      <span [hidden]="!loadingAward">
                        <div class="spinner-border spinner-border-sm me-1" role="status">
                          <span class="visually-hidden">Loading..</span>
                        </div>
                      </span>
                      Withdraw Bid
                    </button>
                  </div>
                </div>
              </div>
            </ng-container>
          </div>
        </div>
        <div [ngStyle]="{ 'order' : $safeNavigationMigration(usOrderedFields?.supplier) }"
          class="va-cell va-header-row row-index-2 supplier d-flex w-100">
          <p class="mb-0">{{ supplier?.supplier?.name || 'Unknown Supplier' }}<span
              *ngIf="supplier?.supplier?.supplierAlias" class="text-muted"><br>({{ supplier?.supplier?.supplierAlias
              }})</span></p>
          <div *ngIf="supplier?.supplier?.logo" class="avatar avatar-68 ms-auto mb-auto">
            <img src="{{ supplier?.supplier?.logo }}" alt="{{ supplier?.supplier?.name || 'Supplier Logo' }}">
          </div>
        </div>
        <div [ngStyle]="{ 'order' : $safeNavigationMigration(usOrderedFields?.offer_id) }" class="va-cell row-index-3 offer-id p-0"
          *ngIf="[offerStatuses.RECEIVED, offerStatuses.AWARDED, offerStatuses.TENTATIVE_AWARDED, offerStatuses.DECLINED_SUBMITTED].includes($safeNavigationMigration(supplier?.status))">
          <div class="d-flex list-group list-group-flush w-100">
            <div class="list-group-item px-2 py-1">
              <a class="btn btn-link p-0 d-flex w-100"
                [routerLink]="['/tenders',$safeNavigationMigration(tender?.id),'locations',$safeNavigationMigration(contract?.id),'dashboard', 'rounds', $safeNavigationMigration(round?.round), 'suppliers', $safeNavigationMigration(supplier?.id)]"
                target="_blank">
                <span class="">Go to {{ supplier?.name }} Detail</span>
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
                  stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                  class="lucide lucide-arrow-up-right-from-square ms-auto">
                  <path d="M21 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h6" />
                  <path d="m21 3-9 9" />
                  <path d="M15 3h6v6" />
                </svg>
              </a>
            </div>
            <div class="list-group-item px-2 py-1">
              <div ngbDropdown placement="bottom-start" autoClose="outside" class="bid-menu-dropdown">
                <button type="button" ngbDropdownToggle
                        class="btn btn-sm btn-light bid-menu-toggle d-flex align-items-center justify-content-between w-100">
                  <span><i class="fas fa-bars me-2 text-muted"></i>Bid Menu</span>
                </button>
                <div ngbDropdownMenu class="bid-menu-panel">
                  <button type="button" ngbDropdownItem class="bid-menu-item"
                          *ngIf="user.canManage(tender)"
                          (click)="hideColumn($safeNavigationMigration(supplier?.id))">
                    <i class="fas fa-eye-slash bid-menu-icon"></i><span class="bid-menu-label">Hide Bid</span>
                  </button>
                  <div *ngIf="user.canManage(tender)" class="bid-menu-item-wrapper">
                    <i class="fas fa-pen bid-menu-icon"></i>
                    <jft-bid-edit-modal [tender]="tender" [contract]="contract" [offer]="supplier"
                      (onUpdated)="onUpdatedBidModal($event, supplier, true)"></jft-bid-edit-modal>
                  </div>
                  <div *ngIf="user.canManage(tender)" class="bid-menu-item-wrapper">
                    <i class="fas fa-plus bid-menu-icon"></i>
                    <a href="javascript:void(0);" [popoverTitle]="'Add New Offer'" [autoClose]="false"
                      class="bid-menu-label flex-grow-1 text-start"
                      #p="ngbPopover" [ngbPopover]="confNextOffer">
                      Add New Offer
                    </a>
                    <a href="javascript:void(0)" [ngbPopover]="popNextOfferContent" [popoverTitle]="popNextOfferTitle"
                       class="ms-2 text-muted bid-menu-info">
                      <i class="fas fa-info-circle" aria-hidden="true"></i>
                    </a>
                  </div>
                  <ng-template #confNextOffer>
                    <p class="mb-2">A duplicate offer will be created where the conditions can be adjusted. (Example: credit
                      terms, delivery point, etc.)</p>
                    <p>Note: this offer will be visible to the supplier.</p>
                    <p class="mb-2">Create a new offer for this supplier?</p>
                    <div class="row g-2">
                      <div class="col">
                        <button (click)="addNextOffer($event, supplier); p.close();" class="btn btn-outline-primary w-100">
                          Confirm
                        </button>
                      </div>
                      <div class="col">
                        <button (click)="p.close()" class="btn w-100 btn-light">
                          Cancel
                        </button>
                      </div>
                    </div>
                  </ng-template>
                  <ng-template #popNextOfferTitle>How "Add New Offer" Works?</ng-template>
                  <ng-template #popNextOfferContent>
                    <p>Suppliers can submit multiple offers with different conditions for each round at any location.</p>
                    <p>When you add a new offer, a new column is created with a duplicate of the current offer, which can
                      then be modified as needed.</p>
                  </ng-template>
                  <div *ngIf="user.canManage(tender)" class="bid-menu-item-wrapper">
                    <i class="fas fa-clone bid-menu-icon"></i>
                    <a href="javascript:void(0);" [popoverTitle]="'Create Mock Bid'" [autoClose]="'outside'"
                      class="bid-menu-label flex-grow-1 text-start"
                      #popoverMockBid="ngbPopover" [ngbPopover]="confMockBid">
                      Create Mock Bid
                    </a>
                    <ng-template #confMockBid>
                      <p class="mb-2">Create a new mock bid for modeling purppouses from this bid?</p>
                      <div class="row mb-2">
                        <div class="form-group col-12">
                          <label>Mock Bid Name</label>
                          <input [(ngModel)]="mockBidName" [ngModelOptions]="{standalone: true}" type="text"
                            class="form-control" placeholder="Name">
                        </div>
                      </div>
                      <div class="row g-2">
                        <div class="col">
                          <button (click)="onCopyMockBid(supplier, popoverMockBid)" class="btn btn-outline-primary w-100">
                            Confirm
                          </button>
                        </div>
                        <div class="col">
                          <button (click)="popoverMockBid.close()" class="btn w-100 btn-light">
                            Cancel
                          </button>
                        </div>
                      </div>
                    </ng-template>
                  </div>
                  <div class="bid-menu-item-wrapper">
                    <i class="fas fa-comment-dots bid-menu-icon"></i>
                    <jft-bid-feedback-modal [tender]="tender" [contract]="contract" [offer]="supplier"
                      [supplier]="$safeNavigationMigration(supplier?.supplier)"></jft-bid-feedback-modal>
                  </div>
                  <div class="bid-menu-item-wrapper">
                    <i class="fas fa-note-sticky bid-menu-icon"></i>
                    <jft-internal-notes-modal [buttonText]="'Save Note'" [tender]="tender" [contract]="contract"
                      [offer]="supplier" [supplier]="$safeNavigationMigration(supplier?.supplier)"></jft-internal-notes-modal>
                  </div>
                  <div class="bid-menu-item-wrapper">
                    <i class="fas fa-comments bid-menu-icon"></i>
                    <jft-bid-chat-modal [tender]="tender" [contract]="contract" [offer]="supplier"
                      [supplier]="$safeNavigationMigration(supplier?.supplier)"></jft-bid-chat-modal>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
        <ng-template [ngIf]="awaitingOfferStatuses.includes($safeNavigationMigration(supplier?.status))">
          <div [ngStyle]="{ 'order' : $safeNavigationMigration(usOrderedFields?.offer_id) }"
            class="va-cell row-index-3 border-bottom small text-muted p-0">

            <div class="d-flex list-group list-group-flush w-100">
              <div class="list-group-item px-2 py-1">
                Awaiting offer from supplier
              </div>
              <div class="list-group-item px-2 py-1">
                <div ngbDropdown placement="bottom-start" autoClose="outside" class="bid-menu-dropdown">
                  <button type="button" ngbDropdownToggle
                          class="btn btn-sm btn-light bid-menu-toggle d-flex align-items-center justify-content-between w-100">
                    <span><i class="fas fa-bars me-2 text-muted"></i>Bid Menu</span>
                  </button>
                  <div ngbDropdownMenu class="bid-menu-panel">
                    <div *ngIf="user.canManage(tender)" class="bid-menu-item-wrapper">
                      <i class="fas fa-pen bid-menu-icon"></i>
                      <jft-bid-edit-modal name="Add Bid" [tender]="tender" [contract]="contract" [offer]="supplier"
                        (onUpdated)="onUpdatedBidModal($event, supplier, true)"></jft-bid-edit-modal>
                    </div>
                    <button type="button" ngbDropdownItem class="bid-menu-item"
                            *ngIf="user.canManage(tender)"
                            (click)="hideColumn($safeNavigationMigration(supplier?.id))">
                      <i class="fas fa-eye-slash bid-menu-icon"></i><span class="bid-menu-label">Hide Bid</span>
                    </button>
                    <div class="bid-menu-item-wrapper">
                      <i class="fas fa-sticky-note bid-menu-icon"></i>
                      <jft-internal-notes-modal [buttonText]="'Save Note'" [tender]="tender" [contract]="contract"
                        [offer]="supplier" [supplier]="$safeNavigationMigration(supplier?.supplier)"></jft-internal-notes-modal>
                    </div>
                    <div class="bid-menu-item-wrapper">
                      <i class="fas fa-comments bid-menu-icon"></i>
                      <jft-bid-chat-modal [tender]="tender" [contract]="contract" [offer]="supplier"
                        [supplier]="$safeNavigationMigration(supplier?.supplier)"></jft-bid-chat-modal>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ng-template>
        <ng-template [ngIf]="[offerStatuses.DECLINED].includes($safeNavigationMigration(supplier?.status))">
          <div [ngStyle]="{ 'order' : $safeNavigationMigration(usOrderedFields?.offer_id) }"
            class="va-cell row-index-3 border-bottom small text-muted p-0">
            <div class="d-flex list-group list-group-flush w-100">
              <div class="list-group-item px-2 py-1">
                Supplier will not be submitting a bid at this location
              </div>
              <div class="list-group-item px-2 py-1">
                <div ngbDropdown placement="bottom-start" autoClose="outside" class="bid-menu-dropdown">
                  <button type="button" ngbDropdownToggle
                          class="btn btn-sm btn-light bid-menu-toggle d-flex align-items-center justify-content-between w-100">
                    <span><i class="fas fa-bars me-2 text-muted"></i>Bid Menu</span>
                  </button>
                  <div ngbDropdownMenu class="bid-menu-panel">
                    <button type="button" ngbDropdownItem class="bid-menu-item"
                            *ngIf="user.canManage(tender)"
                            (click)="hideColumn($safeNavigationMigration(supplier?.id))">
                      <i class="fas fa-eye-slash bid-menu-icon"></i><span class="bid-menu-label">Hide Bid</span>
                    </button>
                    <div class="bid-menu-item-wrapper">
                      <i class="fas fa-sticky-note bid-menu-icon"></i>
                      <jft-internal-notes-modal [buttonText]="'Save Note'" [tender]="tender" [contract]="contract"
                        [offer]="supplier" [supplier]="$safeNavigationMigration(supplier?.supplier)"></jft-internal-notes-modal>
                    </div>
                    <div class="bid-menu-item-wrapper">
                      <i class="fas fa-comments bid-menu-icon"></i>
                      <jft-bid-chat-modal [tender]="tender" [contract]="contract" [offer]="supplier"
                        [supplier]="$safeNavigationMigration(supplier?.supplier)"></jft-bid-chat-modal>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ng-template>
        <ng-template [ngIf]="supplier?.status == offerStatuses.EXPIRED">
          <div [ngStyle]="{ 'order' : $safeNavigationMigration(usOrderedFields?.offer_id) }"
            class="va-cell row-index-3 border-bottom small text-muted p-0">
            <div class="d-flex list-group list-group-flush w-100">
              <div class="list-group-item px-2 py-1">
                Bid not submitted for this location
              </div>
              <div class="list-group-item px-2 py-1">
                <div ngbDropdown placement="bottom-start" autoClose="outside" class="bid-menu-dropdown">
                  <button type="button" ngbDropdownToggle
                          class="btn btn-sm btn-light bid-menu-toggle d-flex align-items-center justify-content-between w-100">
                    <span><i class="fas fa-bars me-2 text-muted"></i>Bid Menu</span>
                  </button>
                  <div ngbDropdownMenu class="bid-menu-panel">
                    <div *ngIf="user.canManage(tender)" class="bid-menu-item-wrapper">
                      <i class="fas fa-pen bid-menu-icon"></i>
                      <jft-bid-edit-modal name="Add Bid" [tender]="tender" [contract]="contract" [offer]="supplier"
                        (onUpdated)="onUpdatedBidModal($event, supplier, true)"></jft-bid-edit-modal>
                    </div>
                    <button type="button" ngbDropdownItem class="bid-menu-item"
                            *ngIf="user.canManage(tender)"
                            (click)="hideColumn($safeNavigationMigration(supplier?.id))">
                      <i class="fas fa-eye-slash bid-menu-icon"></i><span class="bid-menu-label">Hide Bid</span>
                    </button>
                    <div class="bid-menu-item-wrapper">
                      <i class="fas fa-sticky-note bid-menu-icon"></i>
                      <jft-internal-notes-modal [buttonText]="'Save Note'" [tender]="tender" [contract]="contract"
                        [offer]="supplier" [supplier]="$safeNavigationMigration(supplier?.supplier)"></jft-internal-notes-modal>
                    </div>
                    <div class="bid-menu-item-wrapper">
                      <i class="fas fa-comments bid-menu-icon"></i>
                      <jft-bid-chat-modal [tender]="tender" [contract]="contract" [offer]="supplier"
                        [supplier]="$safeNavigationMigration(supplier?.supplier)"></jft-bid-chat-modal>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ng-template>

        <ng-template
          [ngIf]="[offerStatuses.RECEIVED, offerStatuses.AWARDED, offerStatuses.TENTATIVE_AWARDED, offerStatuses.DECLINED_SUBMITTED].includes($safeNavigationMigration(supplier?.status))">
          <div [ngStyle]="{ 'order' : $safeNavigationMigration(usOrderedFields?.delivery_point) }" class="va-cell row-index-4 delivery-point"
            *ngIf="!(usHiddenFields && usHiddenFields[VIEW_FIELDS?.DELIVERY_POINT] === false)">
            {{tender?.company?.settings?.getFilteredOptionLabel('delivery_point',
            $safeNavigationMigration(supplier?.bid?.fuelPreference))}}
          </div>
          <div [ngStyle]="{ 'order' : $safeNavigationMigration(usOrderedFields?.price_base) }" class="va-cell row-index-5 price-base d-flex p-0"
            *ngIf="!(usHiddenFields && usHiddenFields[VIEW_FIELDS?.PRICE_BASE] === false)">
            @if (supplier?.bid) {
            <div class="mb-auto list-group list-group-flush w-100"
              *ngIf="supplier?.bid.marketPrice && supplier?.bid.marketPrice.price">
              <div class="list-group-item px-2 py-1" *ngIf="supplier?.bid.marketPrice.source_type">
                <p class="mb-0"><small>Market Price Source</small><br>
                  <span class="text-capitalize">{{supplier?.bid.marketPrice.source_type?.name}}</span>
                </p>
              </div>
              <div class="list-group-item px-2 py-1" *ngIf="supplier?.bid.marketPrice.source_name">
                <p class="mb-0"><small>Market Price Detail</small><br>
                  <span class="text-capitalize">{{supplier?.bid.marketPrice.source_name}}</span>
                </p>
              </div>
              <div class="list-group-item px-2 py-1"
                *ngIf="supplier?.bid.marketPrice['file'] && supplier?.bid.marketPrice['file']['name']">
                <p class="mb-0"><small>Document</small><br>
                  <a class="pointer d-flex align-items-center"
                    (click)="downloadDocument(supplier?.bid.marketPrice['file'])" placement="top"
                    ngbTooltip="{{supplier?.bid.marketPrice['file']['name'] }}">
                    <i class="fas fa-file-alt me-2"></i>
                    <span class="d-inline-block text-truncate">
                      {{ supplier?.bid.marketPrice['file']['name'] }}
                    </span>
                  </a>
                </p>
              </div>
            </div>

            <div class="mb-auto list-group list-group-flush w-100" *ngIf="supplier?.bid.index">
              <div class="list-group-item px-2 py-1">
                <p class="mb-0"><small>Index Provider</small><br>
                  <span class="text-capitalize">{{supplier?.bid.index.index_code.provider}}</span>
                </p>
              </div>
              <div class="list-group-item px-2 py-1">
                <p class="mb-0"><small>Index Code</small><br>
                  <span class="">{{tender?.company?.settings?.getFilteredOptionLabel('index',
                    supplier?.bid.index.index_code, 'code')}}</span>
                  - {{supplier?.bid.index.bate?.name}}
                </p>
              </div>
              <div class="list-group-item px-2 py-1"
                *ngIf="!tender?.company?.settings?.isHiddenField('bid_averaging_method')">
                <p class="mb-0"><small>Index Averaging</small><br>
                  <span class="text-capitalize">{{tender?.company?.settings?.getFilteredOptionLabel('averaging_method',
                    $safeNavigationMigration(supplier?.bid.index?.averaging_method))}}</span>
                </p>
              </div>
              <div class="list-group-item px-2 py-1"
                *ngIf="!tender?.company?.settings?.isHiddenField('bid_average_offset') && supplier?.bid.index.averaging_offset?.name">
                <p class="mb-0"><small>Index Averaging Offset</small><br>
                  <span class="">{{supplier?.bid.index.averaging_offset?.name}}</span>
                </p>
              </div>
              <div class="list-group-item px-2 py-1"
                *ngIf="!tender?.company?.settings?.isHiddenField('bid_effective_day')">
                <p class="mb-0"><small>Price Effective Day</small><br>
                  <span class="">{{supplier?.bid.index.effective_day?.name}}</span>
                </p>
              </div>
            </div>
            }
          </div>
          <div [ngStyle]="{ 'order' : $safeNavigationMigration(usOrderedFields?.average_price_base) }"
            class="va-cell  row-index-6 average-price-base p-0"
            *ngIf="!(usHiddenFields && usHiddenFields[VIEW_FIELDS?.AVERAGE_PRICE_BASE] === false)">

            <ul class="list-group list-group-flush">
              <li class="list-group-item px-2 py-1 small"
                *ngIf="supplier?.bid && supplier?.bid.index && !isAveragePriceEnabled">
                S&P Global Energy subsctiption is required to view this information. <a
                  routerLink="/account/platts">Learn more.</a>
              </li>
              <li class="list-group-item px-2 py-1"
                *ngIf="supplier?.bid && supplier?.bid?.index?.index_code && isAveragePriceEnabled && supplier?.bid.index.average_price != null && supplier?.bid.index.average_price !== 0">
                <p class="mb-0"><small>Index Value</small><br>
                  <span class="">{{supplier?.bid.index.average_price}}
                    {{tenderSettings.currency.code + ' / ' +
                    tenderSettings.units.code}}</span>
                </p>
              </li>
              <li class="list-group-item px-0 py-1 px-0 py-1"
                *ngIf="!tender?.company?.settings?.isHiddenField('bid_market_price') && (supplier?.bid && supplier?.bid.marketPrice)">
                <p class="mb-0"><small class="text-capitalize">{{tender?.company?.settings?.getFieldName('market_price',
                    'Market price')}}
                    Value</small><br>
                  <span class="">{{supplier?.bid['exchanged_market_value']}} {{baseCurrency.code}}
                    /
                    {{baseUnit.code}}</span>
                  <span class="ms-1">
                    <ng-template #popConv10Title>Supplier's Input</ng-template>
                    <ng-template #popConv10Content>
                      <div>
                        <p>This value was entered in different currency and units.</p>
                        <span class="">{{supplier?.bid.marketPrice.price['price']['value']}}
                          {{supplier?.bid.marketPrice.price['price'].currency.code}}
                          / {{supplier?.bid.marketPrice['price']['units']['code']}}</span>
                      </div>
                    </ng-template>
                    <a href="javascript:void(0)"
                      *ngIf="isConverted($safeNavigationMigration(supplier?.bid.marketPrice?.price?.['price']?.currency?.code), $safeNavigationMigration(supplier?.bid.marketPrice?.price?.['units']?.code))"
                      [ngbPopover]="popConv10Content" [popoverTitle]="popConv10Title"
                      class="float-end">
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                        class="lucide lucide-git-compare-arrows">
                        <circle cx="5" cy="6" r="3" />
                        <path d="M12 6h5a2 2 0 0 1 2 2v7" />
                        <path d="m15 9-3-3 3-3" />
                        <circle cx="19" cy="18" r="3" />
                        <path d="M12 18H7a2 2 0 0 1-2-2V9" />
                        <path d="m9 15 3 3-3 3" />
                      </svg>
                    </a>
                  </span>
                </p>
              </li>
            </ul>
          </div>
          <div [ngStyle]="{ 'order' : $safeNavigationMigration(usOrderedFields?.differential) }" class="va-cell row-index-7 differential"
            *ngIf="!(usHiddenFields && usHiddenFields[VIEW_FIELDS?.DIFFERENTIAL] === false)">
            @if (supplier?.bid) {
            <div class="d-flex w-100">
              {{ supplier?.bid['exchanged_differential'] }} {{baseCurrency.code}} / {{baseUnit.code}}
              &nbsp;
              <ng-template #popConv2Title>Supplier's Input</ng-template>
              <ng-template #popConv2Content>
                <p>This value was entered in different currency and units.</p>
                <p class="mb-0"><strong>{{supplier?.bid?.differential?.getLabel()}}</strong></p>
              </ng-template>
              <a href="javascript:void(0)"
                *ngIf="isConverted($safeNavigationMigration(supplier?.bid.differential?.price?.currency?.code), $safeNavigationMigration(supplier?.bid.differential?.units?.code))"
                [ngbPopover]="popConv2Content" [popoverTitle]="popConv2Title"
                class="ms-auto">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
                  stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                  class="lucide lucide-git-compare-arrows">
                  <circle cx="5" cy="6" r="3" />
                  <path d="M12 6h5a2 2 0 0 1 2 2v7" />
                  <path d="m15 9-3-3 3-3" />
                  <circle cx="19" cy="18" r="3" />
                  <path d="M12 18H7a2 2 0 0 1-2-2V9" />
                  <path d="m9 15 3 3-3 3" />
                </svg>
              </a>
            </div>
            }
          </div>
          <div [ngStyle]="{ 'order' : $safeNavigationMigration(usOrderedFields?.volume_fees) }" class="va-cell row-index-8 vol-fees d-flex p-0"
            *ngIf="!(usHiddenFields && usHiddenFields[VIEW_FIELDS?.VOLUME_FEES] === false)">
            @if (supplier?.bid) {
            <ul class="list-group list-group-flush w-100 mb-auto">
              <li *ngFor="let volumeFee of supplier?.bid['exchanged_volume_based_fees']; let index = index;"
                class="list-group-item py-1 px-2" [ngClass]="{'opacity-25': volumeFee.value == 0.0000}">
                <p class="mb-0"><small>{{volumeFee.name}}</small><br>
                  <span class="">{{volumeFee.value}} {{baseCurrency.code}} /
                    {{baseUnit.code}}
                  </span>
                  <ng-template #popConv3Title>Supplier's Input</ng-template>
                  <ng-template #popConv3Content>
                    <div>
                      <p>This value was entered in different currency and units.</p>
                      <span class="">{{volumeFee['original']['value']}}
                        {{volumeFee['original']['currency']}}/
                        {{volumeFee['original']['unit']}}</span>
                    </div>
                  </ng-template>
                  <a href="javascript:void(0)"
                    *ngIf="isConverted(volumeFee['original']['currency'], volumeFee['original']['unit'])"
                    [ngbPopover]="popConv3Content" [popoverTitle]="popConv3Title"
                    class="float-end">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
                      stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                      class="lucide lucide-git-compare-arrows">
                      <circle cx="5" cy="6" r="3" />
                      <path d="M12 6h5a2 2 0 0 1 2 2v7" />
                      <path d="m15 9-3-3 3-3" />
                      <circle cx="19" cy="18" r="3" />
                      <path d="M12 18H7a2 2 0 0 1-2-2V9" />
                      <path d="m9 15 3 3-3 3" />
                    </svg>
                  </a>
                  <input type="checkbox" [(ngModel)]="volumeFee['is_add_in_total']"
                    [ngModelOptions]="{standalone: true}"
                    (ngModelChange)="onIncludeTotalFees($event, volumeFee, supplier)"
                    class="form-check-input total-check-fees" title="Include in total"
                  [disabled]="!user.canManage(tender)">
                </p>
              </li>
              <li *ngFor="let volumeFee of supplier?.bid.volumeFeesPercent; let index = index;"
                class="list-group-item py-1 px-2">
                <span>
                  {{volumeFee.percent + '% '}}
                  <span *ngIf="volumeFee.based_fee">
                    {{volumeFee.based_fee.name}} {{volumeFee?.based_fee?.notes}}
                  </span>
                </span>
              </li>
            </ul>
            }
          </div>
          <div [ngStyle]="{ 'order' : $safeNavigationMigration(usOrderedFields?.custom_volume_fees) }"
            class="va-cell row-index-9 airline-vol-fees d-flex p-0"
            *ngIf="!(usHiddenFields && usHiddenFields[VIEW_FIELDS?.CUSTOM_VOLUME_FEES] === false) && !tender?.company?.settings?.isHiddenField('bid_custom_volume_fees')">
            @if (supplier?.bid) {
            <ul class="list-group list-group-flush w-100 mb-auto">
              <li
                *ngFor="let volumeFee of supplier?.bid['exchanged_volume_based_fees_airline_input']; let index = index;"
                class="list-group-item py-1 px-2">
                <p class="mb-0"><small>{{volumeFee.name}}</small><br>
                  <span class="">{{volumeFee.value}} {{baseCurrency.code}} /
                    {{baseUnit.code}}</span>
              </li>
            </ul>
            }
          </div>
          <div [ngStyle]="{ 'order' : $safeNavigationMigration(usOrderedFields?.volume_fees_total) }" class="va-cell row-index-10 total-vol-fees"
            *ngIf="!(usHiddenFields && usHiddenFields[VIEW_FIELDS?.TOTAL_VOLUME_FEES] === false)">
            {{ supplier?.bid?.['volume_fees_total'] }} {{baseCurrency.code}} / {{baseUnit.code}}
          </div>
          <div [ngStyle]="{ 'order' : $safeNavigationMigration(usOrderedFields?.total_fields) }" class="va-cell row-index-11 total-fields"
            [ngbPopover]="supplierTotalPopover" [popoverTitle]="activeFormulas['total_price']?.name || 'Total Price'"
            triggers="mouseenter:mouseleave" container="body">
            {{ $safeNavigationMigration(supplier?.bid?.['total_field']) | number:'1.2-6' }} {{baseCurrency.code}} / {{baseUnit.code}}
            <ng-template #supplierTotalPopover>
              <div class="small">
                <div class="text-muted mb-1">{{ formulaLabels['total_price'] }}</div>
                <div *ngIf="getFormulaTooltip('total_price', $safeNavigationMigration(supplier?.bid)) as tt">
                  <code>{{ tt.values }} = {{ tt.result | number:'1.2-6' }}</code>
                </div>
              </div>
            </ng-template>
          </div>
          <div [ngStyle]="{ 'order' : $safeNavigationMigration(usOrderedFields?.ranking) }"
            *ngIf="!(usHiddenFields && usHiddenFields[VIEW_FIELDS?.RANKING] === false)"
            class="va-cell row-index-12 ranking">
            {{ supplier?.bid?.['ranking'] }}
          </div>
          <div [ngStyle]="{ 'order' : $safeNavigationMigration(usOrderedFields?.ranking_gap) }"
            *ngIf="!(usHiddenFields && usHiddenFields[VIEW_FIELDS?.RANKING_GAP] === false) && !tender?.company?.settings?.isHiddenField('bid_gap_from_total')"
            class="va-cell row-index-13 ranking-gap">
            @if (supplier?.bid) {
            {{ supplier?.bid?.['ranking_gap'] }} {{baseCurrency.code}} / {{baseUnit.code}}
            }
          </div>
          <div [ngStyle]="{ 'order' : $safeNavigationMigration(usOrderedFields?.event_fees) }" class="va-cell row-index-14 event-fees d-flex p-0"
            *ngIf="!(usHiddenFields && usHiddenFields[VIEW_FIELDS?.EVENT_FEES] === false)">
            @if (supplier?.bid) {
            <div class="mb-auto list-group list-group-flush w-100 mb-auto">
              <div class="list-group-item py-1 px-2" *ngFor="let perUsageFee of supplier?.bid['exchanged_per_fees']"
                [ngClass]="{'opacity-25': perUsageFee.value == 0.0000}">
                <p class="mb-0"><small>{{perUsageFee.name}}</small><br>
                  <span class="">
                    {{perUsageFee.value}} {{baseCurrency.code}}
                    <ng-template #popConv7Title>Supplier's Input</ng-template>
                    <ng-template #popConv7Content>
                      <div>
                        <p>This value was entered in different currency and units.</p>
                        <span class="">{{perUsageFee['original']['value']}}
                          {{perUsageFee['original']['currency']}}</span>
                      </div>
                    </ng-template>
                    <a href="javascript:void(0)"
                      *ngIf="isConverted(perUsageFee['original']['currency'])"
                      [ngbPopover]="popConv7Content" [popoverTitle]="popConv7Title"
                      class="float-end">
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                        class="lucide lucide-git-compare-arrows">
                        <circle cx="5" cy="6" r="3" />
                        <path d="M12 6h5a2 2 0 0 1 2 2v7" />
                        <path d="m15 9-3-3 3-3" />
                        <circle cx="19" cy="18" r="3" />
                        <path d="M12 18H7a2 2 0 0 1-2-2V9" />
                        <path d="m9 15 3 3-3 3" />
                      </svg>
                    </a>
                    <input type="checkbox" [(ngModel)]="perUsageFee['is_add_in_total']"
                      [ngModelOptions]="{standalone: true}"
                      (ngModelChange)="onIncludeTotalPerFees($event, perUsageFee, supplier)"
                      class="form-check-input total-check-fees" title="Include in total"
                  [disabled]="!user.canManage(tender)">
                  </span>
                </p>
              </div>
            </div>
            }
          </div>
          <div [ngStyle]="{ 'order' : $safeNavigationMigration(usOrderedFields?.total_event_fees) }" class="va-cell row-index-15 total-event-fees"
            *ngIf="!(usHiddenFields && usHiddenFields[VIEW_FIELDS?.TOTAL_EVENT_FEES] === false)">
            @if (supplier?.bid) {
            {{ supplier?.bid['per_uplift_fees_total'] }} {{baseCurrency.code}}
            }
          </div>
          <div [ngStyle]="{ 'order' : $safeNavigationMigration(usOrderedFields?.wacc) }" class="va-cell row-index-17 wacc wacc-value"
            *ngIf="!(usHiddenFields && usHiddenFields[VIEW_FIELDS?.WACC] === false)">
            @if (supplier?.bid) {
            <span>
              <span [ngbTooltip]="waccTooltipContent" [tooltipClass]="'wacc-tooltip'" placement="top" container="body">
                {{ supplier?.bid.isPaymentPrepayment() ? 'Prepayment' :
                supplier?.bid['exchanged_wacc']}} {{baseCurrency.code}} / {{baseUnit.code}}
              </span>
            </span>

            <!-- WACC Calculation Tooltip Template -->
            <ng-template #waccTooltipContent>
              <div class="wacc-calculation-details">
                <strong>WACC Calculation:</strong><br>
                <div class="mt-2">
                  <strong class="text-white">Formula:</strong><br>
                  (WACC % / 365) × Payment Terms × Total Price × -1
                </div>
                <div class="mt-2">
                  <strong class="text-white">Values:</strong><br>
                  WACC %: {{ tenderSettings?.costOfCapital || 0 }}%<br>
                  Payment Terms: <ng-container *ngIf="supplier?.bid?.transitTime">{{
                    supplier?.bid?.payment?.open_invoice?.payment_terms || 0 }} - {{ supplier?.bid?.transitTime }}
                    (transit) = </ng-container>{{ getEffectivePaymentTerms($safeNavigationMigration(supplier?.bid)) }} days<br>
                  Total Price: {{ $safeNavigationMigration(supplier?.bid?.['total_field']) - (supplier?.bid?.['exchanged_wacc'] || 0) | number:
                  '1.4-4' }} {{baseCurrency.code}}/{{baseUnit.code}}
                </div>
                <div class="mt-2">
                  <strong class="text-white">Calculation:</strong><br>
                  ({{ tenderSettings?.costOfCapital || 0 }} / 100 / 365) × {{
                  getEffectivePaymentTerms($safeNavigationMigration(supplier?.bid)) }} × {{ $safeNavigationMigration(supplier?.bid?.['total_field']) -
                  (supplier?.bid?.['exchanged_wacc'] || 0) | number: '1.4-4' }} × -1<br>
                  = <strong>{{ supplier?.bid['exchanged_wacc'] }} {{baseCurrency.code}}/{{baseUnit.code}}</strong>
                </div>
              </div>
            </ng-template>

            }
          </div>
          <div [ngStyle]="{ 'order' : $safeNavigationMigration(usOrderedFields?.saf_mandate) }" class="va-cell row-index-18 saf-mandate"
            *ngIf="!tender?.company?.settings?.isHiddenField('bid_saf_mandate') && !(usHiddenFields && usHiddenFields[VIEW_FIELDS?.SAF_MANDATE] === false)">
            @if (supplier?.bid) {
            {{supplier?.bid?.safMandate}}
            }
          </div>
          <div [ngStyle]="{ 'order' : $safeNavigationMigration(usOrderedFields?.saf_mandate_blend) }" class="va-cell row-index-19 saf-blend"
            *ngIf="!tender?.company?.settings?.isHiddenField('bid_saf_mandate_blend') && !(usHiddenFields && usHiddenFields[VIEW_FIELDS?.SAF_MANDATE_BLEND] === false)">
            @if (supplier?.bid) {
            {{($safeNavigationMigration(supplier?.bid?.safMandateBlend) !== null && $safeNavigationMigration(supplier?.bid?.safMandateBlend) !== undefined) ?
            supplier?.bid.safMandateBlend + '%' : ''}}
            }
          </div>
          <div [ngStyle]="{ 'order' : $safeNavigationMigration(usOrderedFields?.saf_fee_amount) }" class="va-cell row-index-23 saf-fee-amount"
            *ngIf="!tender?.company?.settings?.isHiddenField('bid_saf_fee_amount') && !(usHiddenFields && usHiddenFields[VIEW_FIELDS?.SAF_FEE_AMOUNT] === false)">
            @if (supplier?.bid) {
            <jft-converted-amount [value]="$safeNavigationMigration(supplier?.bid?.['exchanged_fee_amount'])"
              [currencyCode]="baseCurrency.code" [unitCode]="baseUnit.code"
              [originalValue]="$safeNavigationMigration(supplier?.bid?.safFeeAmountUnits?.price?.value)"
              [originalCurrencyCode]="$safeNavigationMigration(supplier?.bid?.safFeeAmountUnits?.price?.currency?.code)"
              [originalUnitCode]="$safeNavigationMigration(supplier?.bid?.safFeeAmountUnits?.units?.code)"></jft-converted-amount>
            }
          </div>
          <div [ngStyle]="{ 'order' : $safeNavigationMigration(usOrderedFields?.neat_saf) }" class="va-cell row-index-20 saf-neat"
            *ngIf="!tender?.company?.settings?.isHiddenField('bid_neat_saf_mandated_price') && !(usHiddenFields && usHiddenFields[VIEW_FIELDS?.NEAT_SAF] === false)">
            @if (supplier?.bid) {
            <span *ngIf="supplier?.bid?.['exchanged_neat_saf']">
              {{ $safeNavigationMigration(supplier?.bid?.['exchanged_neat_saf']) | number: '1.' }} {{baseCurrency.code}} / {{baseUnit.code}}
            </span>
            <span *ngIf="neatSafOf($safeNavigationMigration(supplier?.bid)) && isNeatSafHockEnabled">
              <span class="ms-1">
                <ng-template #popConv6Title>Supplier's Input</ng-template>
                <ng-template #popConv6Content>
                  <div>
                    <p>This value was entered in different currency and units.</p>
                    <span class="">{{neatSafOf($safeNavigationMigration(supplier?.bid))?.getLabel?.()}}</span>
                  </div>
                </ng-template>
                <a href="javascript:void(0)"
                  *ngIf="isConverted($safeNavigationMigration(neatSafOf($safeNavigationMigration(supplier?.bid))?.price?.currency?.code), $safeNavigationMigration(neatSafOf($safeNavigationMigration(supplier?.bid))?.units?.code))"
                  [ngbPopover]="popConv6Content" [popoverTitle]="popConv6Title"
                  class="float-end">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                    class="lucide lucide-git-compare-arrows">
                    <circle cx="5" cy="6" r="3" />
                    <path d="M12 6h5a2 2 0 0 1 2 2v7" />
                    <path d="m15 9-3-3 3-3" />
                    <circle cx="19" cy="18" r="3" />
                    <path d="M12 18H7a2 2 0 0 1-2-2V9" />
                    <path d="m9 15 3 3-3 3" />
                  </svg>
                </a>
              </span>
            </span>
            }
          </div>
          <div [ngStyle]="{ 'order' : $safeNavigationMigration(usOrderedFields?.neat_saf_volume) }" class="va-cell row-index-21 saf-neat-vol"
            *ngIf="!tender?.company?.settings?.isHiddenField('bid_neat_saf_volume') && !(usHiddenFields && usHiddenFields[VIEW_FIELDS?.NEAT_SAF_VOLUME] === false)">
            @if (supplier?.bid) {
            {{supplier?.bid?.neatSafVolume}}
            }
          </div>
          <!-- Dynamic formula value cells -->
          <ng-container *ngFor="let fKey of dynamicFormulaKeys">
            <div [ngStyle]="{ 'order' : $safeNavigationMigration(usOrderedFields?.[fKey]) }" class="va-cell row-index-31 sum-diff-vol"
              *ngIf="!(usHiddenFields && usHiddenFields[fKey] === false)" [ngbPopover]="supplierFormulaPopover"
              [popoverTitle]="$safeNavigationMigration(activeFormulas[fKey]?.name)" triggers="mouseenter:mouseleave" container="body">
              @if (supplier?.bid) {
              {{ $safeNavigationMigration(supplier?.bid[fKey]) | number: '1.' }} {{baseCurrency.code}} / {{baseUnit.code}}
              }
              <ng-template #supplierFormulaPopover>
                <div class="small">
                  <div class="text-muted mb-1">{{ formulaLabels[fKey] }}</div>
                  <div *ngIf="getFormulaTooltip(fKey, $safeNavigationMigration(supplier?.bid)) as tt">
                    <code>{{ tt.values }} = {{ tt.result | number:'1.2-6' }}</code>
                  </div>
                </div>
              </ng-template>
            </div>
          </ng-container>
          <div [ngStyle]="{ 'order' : $safeNavigationMigration(usOrderedFields?.non_mandatory_fees) }"
            class="va-cell row-index-37 non-mandatory-fees d-flex"
            *ngIf="!(usHiddenFields && usHiddenFields[VIEW_FIELDS?.NON_MANDATORY_FEES] === false) && !tender?.company?.settings?.isHiddenField('bid_non_mandatory_fees')">
            @if (supplier?.bid) {
            <div class="mb-auto text-wrap">
              <jft-read-more-modal [title]="'Non-mandatory fees'" [text]="$safeNavigationMigration(supplier?.bid.nonMandatoryFeesText)">
              </jft-read-more-modal>
            </div>
            }
          </div>
          <div [ngStyle]="{ 'order' : $safeNavigationMigration(usOrderedFields?.payment_type) }" class="va-cell row-index-38 payment-type"
            *ngIf="!(usHiddenFields && usHiddenFields[VIEW_FIELDS?.PAYMENT_TYPE] === false) && !tender?.company?.settings?.isHiddenField('bid_payment_type')">
            @if (supplier?.bid) {
            <div>
              {{ supplier?.bid.getPaymentTypeLabel() }}
            </div>
            }
          </div>
          <div [ngStyle]="{ 'order' : $safeNavigationMigration(usOrderedFields?.payment_terms) }" class="va-cell row-index-39 payment-terms p-0"
            *ngIf="!(usHiddenFields && usHiddenFields[VIEW_FIELDS?.PAYMENT_TERMS] === false) && !tender?.company?.settings?.isHiddenField('bid_payment_terms')">
            @if (supplier?.bid) {
            <ul class="list-group list-group-flush"
              *ngIf="supplier?.bid.payment?.prepayment && !tender?.company?.settings?.isHiddenField('bid_prepayment')">
              <li class="list-group-item py-1 px-2"
                *ngIf="!tender?.company?.settings?.isHiddenField('bid_prepayment_number_of_days_prepaid')">
                <p class="mb-0"><small>Number of Days Prepaid</small><br>
                  <span class="">{{supplier?.bid.payment?.prepayment?.number_days_prepaid}}</span>
                </p>
              </li>
              <li class="list-group-item py-1 px-2"
                *ngIf="!tender?.company?.settings?.isHiddenField('bid_prepayment_payment_first_delivery')">
                <p class="mb-0"><small>First Delivery Date</small><br>
                  <span class="">{{supplier?.bid.payment?.prepayment?.payment_first_delivery_date}}</span>
                </p>
              </li>
              <li class="list-group-item py-1 px-2"
                *ngIf="!tender?.company?.settings?.isHiddenField('bid_prepayment_payment_frequency')">
                <p class="mb-0"><small>Prepayment Frequency</small><br>
                  <span class="">{{supplier?.bid.getPrepaymentFrequencyLabel(tender)}}</span>
                </p>
              </li>
              <li class="list-group-item py-1 px-2"
                *ngIf="!tender?.company?.settings?.isHiddenField('bid_prepayment_amount')">
                <p class="mb-0"><small>Prepayment Amount</small><br>
                  <span class="">{{supplier?.bid.payment?.prepayment?.amount}}</span>
                </p>
              </li>
            </ul>

            <ul class="list-group list-group-flush"
              *ngIf="supplier?.bid.payment?.open_invoice && !tender?.company?.settings?.isHiddenField('bid_open_invoice')">
              <li class="list-group-item py-1 px-2"
                *ngIf="(supplier?.bid.payment?.open_invoice?.payment_terms == 0 || supplier?.bid.payment?.open_invoice?.payment_terms) && !tender?.company?.settings?.isHiddenField('bid_payment_terms')">
                <p class="mb-0"><small>Number of Days Credit</small><br>
                  <span class="">
                    {{tender?.company?.settings?.getFilteredOptionLabel('open_invoice_payment_terms',
                    $safeNavigationMigration(supplier?.bid.payment?.open_invoice?.payment_terms), 'name', true)}}
                  </span>
                </p>
              </li>
              <li class="list-group-item py-1 px-2"
                *ngIf="supplier?.bid.payment?.payment_reference_date?.name && !tender?.company?.settings?.isHiddenField('bid_payment_reference_date')">
                <p class="mb-0"><small>Payment Reference Date</small><br>
                  <span class="">{{supplier?.bid.payment?.payment_reference_date?.name}}</span>
                </p>
              </li>
              <li class="list-group-item py-1 px-2"
                *ngIf="supplier?.bid.getOpenInvoiceFrequencyLabel(tender) && (!tender?.company?.settings?.isHiddenField('bid_open_invoice_invoice_frequency'))">
                <p class="mb-0"><small>Invoice Frequency</small><br>
                  <span class="">
                    {{supplier?.bid.getOpenInvoiceFrequencyLabel(tender)}}
                  </span>
                </p>
              </li>
              <li class="list-group-item py-1 px-2"
                *ngIf="supplier?.bid.getOpenInvoiceTypeLabel(tender) && !tender?.company?.settings?.isHiddenField('bid_invoice_type')">
                <p class="mb-0"><small>Invoice Type</small><br>
                  <span class="">{{supplier?.bid.getOpenInvoiceTypeLabel(tender)}}</span>
                </p>
              </li>
            </ul>
            }
          </div>
          <div [ngStyle]="{ 'order' : $safeNavigationMigration(usOrderedFields?.payment_currency) }" class="va-cell row-index-40 payment-currency"
            *ngIf="!(usHiddenFields && usHiddenFields[VIEW_FIELDS?.PAYMENT_CURRENCY] === false) && !tender?.company?.settings?.isHiddenField('bid_payment_currency')">
            @if (supplier?.bid) {
            {{ supplier?.bid.getPaymentCurrencyLabel() }}
            }
          </div>
          <div [ngStyle]="{ 'order' : $safeNavigationMigration(usOrderedFields?.payment_unit) }" class="va-cell row-index-41 payment-unit"
            *ngIf="!(usHiddenFields && usHiddenFields[VIEW_FIELDS?.PAYMENT_UNIT] === false) && !tender?.company?.settings?.isHiddenField('bid_payment_unit')">
            @if (supplier?.bid) {
            {{ supplier?.bid.getPaymentUnitLabel() }}
            }
          </div>
          <div [ngStyle]="{ 'order' : usOrderedFields.payment_method }" class="va-cell row-index-42 payment-method"
            *ngIf="!(usHiddenFields && usHiddenFields[VIEW_FIELDS?.PAYMENT_METHOD] === false) && !tender?.company?.settings?.isHiddenField('bid_method_of_payment')">
            @if (supplier?.bid) {
            {{ supplier?.bid.getPaymentMethodLabel() }}
            }
          </div>
          <div [ngStyle]="{ 'order' : $safeNavigationMigration(usOrderedFields?.guarantees_deposits_required) }"
            class="va-cell row-index-43 deposit"
            *ngIf="!(usHiddenFields && usHiddenFields[VIEW_FIELDS?.GUARANTEES_DEPOSITS_REQUIRED] === false) && !tender?.company?.settings?.isHiddenField('bid_guarantees_deposits_required')">
            @if (supplier?.bid) {
            <span>
              {{ supplier?.bid.getPaymentGuaranteesDeposit() }}
            </span>
            }
          </div>
          <div [ngStyle]="{ 'order' : $safeNavigationMigration(usOrderedFields?.bank_guarantee_amount) }"
            class="va-cell row-index-44 bank-guarantee-amount"
            *ngIf="!(usHiddenFields && usHiddenFields[VIEW_FIELDS?.BANK_GUARANTEE_AMOUNT] === false) && !tender?.company?.settings?.isHiddenField('bank_guarantee_amount')">
            @if (supplier?.bid) {
            <span>
              {{ $safeNavigationMigration(supplier?.bid.bankGuaranteeAmount) | number:'1.2-2' }}
            </span>
            }
          </div>
          <div [ngStyle]="{ 'order' : $safeNavigationMigration(usOrderedFields?.bank_guarantee_currency) }"
            class="va-cell row-index-45 bank-guarantee-currency"
            *ngIf="!(usHiddenFields && usHiddenFields[VIEW_FIELDS?.BANK_GUARANTEE_CURRENCY] === false) && !tender?.company?.settings?.isHiddenField('bank_guarantee_currency')">
            @if (supplier?.bid) {
            <span>
              {{ supplier?.bid.bankGuaranteeCurrency ? currencies.getById($safeNavigationMigration(supplier?.bid.bankGuaranteeCurrency))?.code :
              '' }}
            </span>
            }
          </div>
          <div [ngStyle]="{ 'order' : $safeNavigationMigration(usOrderedFields?.transit_time) }" class="va-cell row-index-46 transit-time"
            *ngIf="!(usHiddenFields && usHiddenFields[VIEW_FIELDS?.TRANSIT_TIME] === false) && !tender?.company?.settings?.isHiddenField('transit_time')">
            @if (supplier?.bid) {
            <span>
              {{ supplier?.bid.transitTime }}
            </span>
            }
          </div>
          <div [ngStyle]="{ 'order' : usOrderedFields.fin_source }" class="va-cell row-index-46 fin-source"
            *ngIf="false">
            {{supplier?.bid.getRateFinancialSourceLabel()}}
          </div>
          <div [ngStyle]="{ 'order' : usOrderedFields.fin_averaging_method }"
            class="va-cell row-index-47 fin-averaging-method" *ngIf="false">
            {{supplier?.bid.getRateAverageingMethodLabel()}}
          </div>
          <div [ngStyle]="{ 'order' : usOrderedFields.fin_averaging_offset }"
            class="va-cell row-index-48 fin-averaging-offset" *ngIf="false">
            {{supplier?.bid.getRateAveragingOffsetLabel()}}
          </div>
          <div [ngStyle]="{ 'order' : $safeNavigationMigration(usOrderedFields?.invoice_frequency) }"
            class="va-cell row-index-49 invoice-frequency"
            *ngIf="!(usHiddenFields && usHiddenFields[VIEW_FIELDS?.INVOICE_FREQUENCY] === false) && !tender?.company?.settings?.isHiddenField('bid_open_invoice_invoice_frequency')">
            @if (supplier?.bid) {
            {{supplier?.bid.getOpenInvoiceFrequencyLabel(tender)}}
            }
          </div>
          <div [ngStyle]="{ 'order' : $safeNavigationMigration(usOrderedFields?.invoice_type) }" class="va-cell row-index-50 invoice-type"
            *ngIf="!(usHiddenFields && usHiddenFields[VIEW_FIELDS?.INVOICE_TYPE] === false) && !tender?.company?.settings?.isHiddenField('bid_invoice_type')">
            @if (supplier?.bid) {
            {{supplier?.bid.getOpenInvoiceTypeLabel(tender)}}
            }
          </div>
          <div [ngStyle]="{ 'order' : $safeNavigationMigration(usOrderedFields?.payment_reference_date) }"
            class="va-cell row-index-51 payment-reference-date"
            *ngIf="!(usHiddenFields && usHiddenFields[VIEW_FIELDS?.PAYMENT_REFERENCE_DATE] === false) && !tender?.company?.settings?.isHiddenField('bid_payment_reference_date')">
            @if (supplier?.bid) {
            {{supplier?.bid.getOpenInvoiceReferenceDateLabel()}}
            }
          </div>
          <div [ngStyle]="{ 'order' : $safeNavigationMigration(usOrderedFields?.payment_details) }"
            class="va-cell row-index-52 payment-details p-0"
            *ngIf="!(usHiddenFields && usHiddenFields[VIEW_FIELDS?.PAYMENT_DETAILS] === false) && (!tender?.company?.settings?.isHiddenField('bid_exchange_rate') || !tender?.company?.settings?.isHiddenField('bid_ex_rate_financial_source') || !tender?.company?.settings?.isHiddenField('bid_ex_rate_averageing_method'))">
            @if (supplier?.bid) {
            <ul class="list-group list-group-flush"
              *ngIf="supplier?.bid.payment && supplier?.bid.payment.exchange_rate">
              <li class="list-group-item py-1 px-2"
                *ngIf="!tender?.company?.settings?.isHiddenField('bid_ex_rate_financial_source')">
                <p class="mb-0"><small>Financial Source</small><br>
                  <span class="">{{supplier?.bid.payment?.exchange_rate?.financial_source}}</span>
                </p>
              </li>
              <li class="list-group-item py-1 px-2"
                *ngIf="!tender?.company?.settings?.isHiddenField('bid_ex_rate_averageing_method')">
                <p class="mb-0"><small>Exchange Rate Averaging</small><br>
                  <span class="">{{supplier?.bid.payment?.exchange_rate?.averageing_method?.name}}</span>
                </p>
              </li>
            </ul>
            }
          </div>
          <div [ngStyle]="{ 'order' : usOrderedFields.intoplane }" class="va-cell row-index-51 intoplane" *ngIf="false">
            {{ supplier?.bid?.fuelPreference?.name}}
          </div>
          <div [ngStyle]="{ 'order' : usOrderedFields.open_release }" class="va-cell row-index-52 open-release"
            *ngIf="!(usHiddenFields && usHiddenFields[VIEW_FIELDS?.OPEN_RELEASE] === false) && !tender?.company?.settings?.isHiddenField('bid_open_fuel_release')">
            @if (supplier?.bid) {
            <span>{{ supplier?.bid.getopenFuelReleaseLabel() }}</span>
            }
          </div>
          <div [ngStyle]="{ 'order' : usOrderedFields.gross_or_net_billing }" class="va-cell row-index-53 gross-net"
            *ngIf="!(usHiddenFields && usHiddenFields[VIEW_FIELDS?.GROSS_OR_NET_BILLING] === false) && !tender?.company?.settings?.isHiddenField('bid_gross_or_net_billing')">
            @if (supplier?.bid) {
            {{ supplier?.bid.grossNetBilling?.getLabel() }}
            }
          </div>
          <div [ngStyle]="{ 'order' : usOrderedFields.iata_service_level }"
            class="va-cell row-index-54 iata-service-level"
            *ngIf="!(usHiddenFields && usHiddenFields[VIEW_FIELDS?.IATA_SERVICE_LEVEL] === false) && !tender?.company?.settings?.isHiddenField('bid_iata_service_level')">
            @if (supplier?.bid) {
            {{ supplier?.bid.iataServiceLevel?.name }}
            }
          </div>
          <div [ngStyle]="{ 'order' : usOrderedFields.into_plane_service_provider }"
            class="va-cell row-index-55 into-plane-provider"
            *ngIf="!(usHiddenFields && usHiddenFields[VIEW_FIELDS?.INTO_PLANE_SERVICE_PROVIDER] === false) && !tender?.company?.settings?.isHiddenField('bid_into_plane_service_provider')">
            @if (supplier?.bid) {
            {{ supplier?.bid.intoPlaneServiceProvider?.name || supplier?.bid.intoPlane }}
            }
          </div>
          <div [ngStyle]="{ 'order' : usOrderedFields.delivery_airport }"
            *ngIf="!(usHiddenFields && usHiddenFields[VIEW_FIELDS?.DELIVERY_AIRPORT] === false) && isAirPortDeliveryMethods()"
            class="va-cell row-index-56 delivery-airport p-0">
            <ul class="list-group list-group-flush" *ngIf="supplier?.bid">
              <li class="list-group-item py-1 px-2"
                *ngFor="let airPortDelivery of supplier?.bid.airPortDeliveryMethods">
                <p class="mb-0">
                  <small>{{airPortDelivery.method.name}}</small><br>
                  <span>{{airPortDelivery.percentage ? airPortDelivery.percentage + '%' : '-'}}</span>
                  <span *ngIf="airPortDelivery.isPrimary"> - Primary</span>
                </p>
              </li>
            </ul>
          </div>
          <div [ngStyle]="{ 'order' : usOrderedFields.delivery_aircraft }"
            *ngIf="!(usHiddenFields && usHiddenFields[VIEW_FIELDS?.DELIVERY_AIRCRAFT] === false) && isAirCraftDeliveryMethods()"
            class="va-cell row-index-57 delivery-aircraft">
            @if (supplier?.bid) {
            <div class="value">
              <span>{{ supplier?.bid.airCraftDeliveryMethod?.name }}</span>
            </div>
            }
          </div>
          <div [ngStyle]="{ 'order' : usOrderedFields.pre_flight_notification }"
            class="va-cell row-index-58 pre-flight-notification d-flex w-100"
            *ngIf="!(usHiddenFields && usHiddenFields[VIEW_FIELDS?.PRE_FLIGHT_NOTIFICATION] === false) && (!tender?.company?.settings?.isHiddenField('bid_pre_flight_notification_notes') || !tender?.company?.settings?.isHiddenField('bid_pre_flight_notification_hours'))">
            @if (supplier?.bid) {
            <div class="mb-auto text-wrap">
              <jft-read-more-modal [title]="'Pre-flight notification'"
                [text]="$safeNavigationMigration(supplier?.bid.preFlightNotification?.getLabel())"></jft-read-more-modal>
            </div>
            }
          </div>
          <div [ngStyle]="{ 'order' : usOrderedFields.ramp }" class="va-cell row-index-59 ramp d-flex w-100"
            *ngIf="!(usHiddenFields && usHiddenFields[VIEW_FIELDS?.RAMP] === false) && !tender?.company?.settings?.isHiddenField('bid_ramp_limitations_notes')">
            @if (supplier?.bid) {
            <div class="mb-auto text-wrap">
              <jft-read-more-modal [title]="'Ramp limitations'" [text]="$safeNavigationMigration(supplier?.bid.rampLimitations?.getLabel())">
              </jft-read-more-modal>
            </div>
            }
          </div>
          <div [ngStyle]="{ 'order' : $safeNavigationMigration(usOrderedFields?.open_hours) }"
            class="va-cell row-index-60 open-hours d-flex w-100"
            *ngIf="!(usHiddenFields && usHiddenFields[VIEW_FIELDS?.OPEN_HOURS] === false) && !tender?.company?.settings?.isHiddenField('bid_open_hours')">
            @if (supplier?.bid) {
            <div class="mb-auto text-wrap">
              <jft-read-more-modal [title]="'Operating Hours'" [text]="$safeNavigationMigration(supplier?.bid.fuelAvailability?.getLabel())">
              </jft-read-more-modal>
            </div>
            }
          </div>
          <div [ngStyle]="{ 'order' : usOrderedFields.weight_conversion_factor }"
            class="va-cell row-index-61 weight-conversion-factor" *ngIf="false">
            <span>{{ supplier?.bid?.supplyCondition?.volumeConversion }}</span>
          </div>
          <div [ngStyle]="{ 'order' : $safeNavigationMigration(usOrderedFields?.fuel_availability) }"
            class="va-cell row-index-62 fuel-availability"
            *ngIf="!(usHiddenFields && usHiddenFields[VIEW_FIELDS?.FUEL_AVAILABILITY] === false) && !tender?.company?.settings?.isHiddenField('bid_fuel_availability')">
            @if (supplier?.bid) {
            <span>{{ supplier?.bid.fuelAvailabilityPercentage }}%</span>
            }
          </div>
          <div [ngStyle]="{ 'order' : $safeNavigationMigration(usOrderedFields?.contract_start) }" class="va-cell row-index-63 contract-start"
            *ngIf="!(usHiddenFields && usHiddenFields[VIEW_FIELDS?.CONTRACT_START] === false)">
            <ng-container *ngIf="round?.contract && round?.contract?.dateStart">
              <span>{{ round?.contract?.dateStart.toFormat(defaultDateFormat, { zone: "utc" })}}</span>
            </ng-container>
          </div>
          <div [ngStyle]="{ 'order' : $safeNavigationMigration(usOrderedFields?.contract_end) }" class="va-cell row-index-64 contract-end"
            *ngIf="!(usHiddenFields && usHiddenFields[VIEW_FIELDS?.CONTRACT_END] === false)">
            <ng-container *ngIf="round?.contract && round?.contract?.dateEnd">
              <span>{{ round?.contract?.dateEnd.toFormat(defaultDateFormat, { zone: "utc" })}}</span>
            </ng-container>
          </div>
          <div
            *ngIf="!tender?.company?.settings?.isHiddenField('bid_saf_blend_volume') && !(usHiddenFields && usHiddenFields[VIEW_FIELDS?.SAF_BLENDED_VOLUME] === false)"
            [ngStyle]="{ 'order' : $safeNavigationMigration(usOrderedFields?.saf_blended_volume) }" class="va-cell row-index-22">
            <span
              *ngIf="supplier?.bid && ($safeNavigationMigration(supplier?.bid.safMandateBlend) !== null && $safeNavigationMigration(supplier?.bid.safMandateBlend) !== undefined)">
              {{ $safeNavigationMigration(contract?.volume) * ($safeNavigationMigration(supplier?.bid.safMandateBlend) / 100) | number: '1.'}} {{contract?.units.code}}
            </span>
          </div>
          <div
            *ngIf="!tender?.company?.settings?.isHiddenField('bid_saf_cost') && !(usHiddenFields && usHiddenFields[VIEW_FIELDS?.SAF_COST] === false)"
            [ngStyle]="{ 'order' : $safeNavigationMigration(usOrderedFields?.saf_cost) }" class="va-cell row-index-24">
            <jft-converted-amount [value]="$safeNavigationMigration(supplier?.bid?.['exchanged_saf_cost'])"
              [currencyCode]="baseCurrency.code" format="1.0-3"
              [originalValue]="$safeNavigationMigration(supplier?.bid?.['original_saf_cost'])"
              [originalCurrencyCode]="$safeNavigationMigration(supplier?.bid?.['neat_saf_currency'])"
              heading="In Supplier's Currency"
              note="Derived from the supplier's neat SAF price, which was entered in a different currency."></jft-converted-amount>
          </div>
          <div
            *ngIf="!tender?.company?.settings?.isHiddenField('bid_saf_premium') && !(usHiddenFields && usHiddenFields[VIEW_FIELDS?.SAF_PREMIUM] === false)"
            [ngStyle]="{ 'order' : $safeNavigationMigration(usOrderedFields?.saf_premium) }" class="va-cell row-index-25">
            <jft-converted-amount [value]="$safeNavigationMigration(supplier?.bid?.['exchanged_saf_premium'])"
              [currencyCode]="baseCurrency.code" [unitCode]="baseUnit.code" format="1.0-4"
              [originalValue]="$safeNavigationMigration(supplier?.bid?.['original_saf_premium'])"
              [originalCurrencyCode]="$safeNavigationMigration(supplier?.bid?.['neat_saf_currency'])"
              [originalUnitCode]="$safeNavigationMigration(supplier?.bid?.['neat_saf_unit'])"
              heading="In Supplier's Currency"
              note="Derived from the supplier's neat SAF price, which was entered in a different currency or unit."></jft-converted-amount>
          </div>
          <div
            *ngIf="!tender?.company?.settings?.isHiddenField('bid_conventional_jet_percentage') && !(usHiddenFields && usHiddenFields[VIEW_FIELDS?.CONVENTIONAL_JET_PERCENTAGE] === false)"
            [ngStyle]="{ 'order' : $safeNavigationMigration(usOrderedFields?.conventional_jet_percentage) }" class="va-cell row-index-26">
            @if (supplier?.bid) {
            <span *ngIf="supplier?.bid.safMandateBlend">
              {{ 100 - $safeNavigationMigration(supplier?.bid.safMandateBlend) | number: '1.'}} {{'%'}}
            </span>
            }
          </div>
          <div
            *ngIf="!tender?.company?.settings?.isHiddenField('bid_conventional_jet_percentage_price') && !(usHiddenFields && usHiddenFields[VIEW_FIELDS?.CONVENTIONAL_JET_PERCENTAGE_PRICE] === false)"
            [ngStyle]="{ 'order' : $safeNavigationMigration(usOrderedFields?.conventional_jet_percentage_price) }" class="va-cell row-index-27">
            @if (supplier?.bid) {
            <span *ngIf="supplier?.bid.differential?.price && supplier?.bid.safMandateBlend">
              {{ ((supplier?.bid.index?.average_price ? supplier?.bid.index.average_price : 0) +
              $safeNavigationMigration(supplier?.bid['diff_plus_vbfees'])) * ((100 - $safeNavigationMigration(supplier?.bid.safMandateBlend))/100) | number:
              '1.4'}}
              {{baseCurrency.code}}
            </span>
            }
          </div>
          <div
            *ngIf="!tender?.company?.settings?.isHiddenField('bid_conventional_jet_and_saf_premium') && !(usHiddenFields && usHiddenFields[VIEW_FIELDS?.CONVENTIONAL_JET_AND_SAF_PREMIUM] === false)"
            [ngStyle]="{ 'order' : $safeNavigationMigration(usOrderedFields?.conventional_jet_and_saf_premium) }" class="va-cell row-index-28">
            <span *ngIf="$safeNavigationMigration(supplier?.bid?.['exchanged_conventional_jet_and_saf_premium']) !== null
              && $safeNavigationMigration(supplier?.bid?.['exchanged_conventional_jet_and_saf_premium']) !== undefined">
              {{ $safeNavigationMigration(supplier?.bid?.['exchanged_conventional_jet_and_saf_premium']) | number: '1.0-4'}}
              {{ baseCurrency.code }} / {{ baseUnit.code }}
            </span>
          </div>
          <div
            *ngIf="!tender?.company?.settings?.isHiddenField('bid_conventional_jet_volume') && !(usHiddenFields && usHiddenFields[VIEW_FIELDS?.CONVENTIONAL_JET_VOLUME] === false)"
            [ngStyle]="{ 'order' : $safeNavigationMigration(usOrderedFields?.conventional_jet_volume) }" class="va-cell row-index-29">
            @if (supplier?.bid) {
            <span *ngIf="supplier?.bid.safMandateBlend">
              {{ $safeNavigationMigration(contract?.volume) * ((100 - $safeNavigationMigration(supplier?.bid.safMandateBlend)) / 100) | number: '1.'}}
              {{ contract?.units.code }}
            </span>
            }
          </div>
          <div
            *ngIf="!tender?.company?.settings?.isHiddenField('bid_conventional_jet_cost') && !(usHiddenFields && usHiddenFields[VIEW_FIELDS?.CONVENTIONAL_JET_COST] === false)"
            [ngStyle]="{ 'order' : $safeNavigationMigration(usOrderedFields?.conventional_jet_cost) }" class="va-cell row-index-30">
            @if (supplier?.bid) {
            <span *ngIf="supplier?.bid.differential?.price && supplier?.bid.safMandateBlend">
              {{ ((((supplier?.bid.index?.average_price ? supplier?.bid.index.average_price : 0) +
              $safeNavigationMigration(supplier?.bid['diff_plus_vbfees'])) * ((100 - $safeNavigationMigration(supplier?.bid.safMandateBlend))/100)) *
              ($safeNavigationMigration(contract?.volume) | unitExchange: $safeNavigationMigration(contract?.units.code) : unitRates: baseUnit.code)) /
              (safCentsMap[baseCurrency.code] ? 100 : 1) | number: '1.0-0'}}
              {{ (safCentsMap[baseCurrency.code] ? safCentsMap[baseCurrency.code] : baseCurrency.code) }}
            </span>
            }
          </div>
          <div [ngStyle]="{ 'order' : $safeNavigationMigration(usOrderedFields?.supply_conditions_notes) }"
            class="va-cell row-index-65 supplier-comments d-flex"
            *ngIf="!(usHiddenFields && usHiddenFields[VIEW_FIELDS?.SUPPLY_CONDITIONS_NOTES] === false)">
            @if (supplier?.bid) {
            <div class="mb-auto text-wrap">
              <jft-read-more-modal [title]="'Supplier Comments'" [text]="$safeNavigationMigration(supplier?.bid.comments)">
              </jft-read-more-modal>
            </div>
            }
          </div>
          <div [ngStyle]="{ 'order' : $safeNavigationMigration(usOrderedFields?.notes) }" class="va-cell row-index-66 notes d-flex"
            *ngIf="!(usHiddenFields && usHiddenFields[VIEW_FIELDS?.BID_NOTES] === false)">
            @if (supplier?.bid) {
            <div class="mb-auto text-wrap">
              <jft-read-more-modal [title]="'Bid Notes'" [text]="$safeNavigationMigration(supplier?.bid.note)"></jft-read-more-modal>
            </div>
            }
          </div>
          <div [ngStyle]="{ 'order' : $safeNavigationMigration(usOrderedFields?.shared_files) }" class="va-cell row-index-67 shared-files d-flex"
            *ngIf="!(usHiddenFields && usHiddenFields[VIEW_FIELDS?.SHARED_FILES] === false)">
            <ul class="list-group list-group-flush w-100 mb-auto">
              <li *ngFor='let file of supplier?.supplierRequestedDocument'
                class="list-group-item px-0 py-1 px-0 py-1 small">
                <a class="pointer d-flex align-items-center" (click)="downloadDocument(file.file)" placement="top"
                  ngbTooltip="{{file.name }}">
                  <i class="fas fa-file-alt me-2"></i>
                  <span class="d-inline-block text-truncate">
                    {{file.name }}
                  </span>
                </a>
              </li>
            </ul>
          </div>
          <div [ngStyle]="{ 'order' : usOrderedFields.bid_feedback }" class="va-cell row-index-68 bid-feedback"
            *ngIf="isBidFeedbacks">
            @if (supplier?.bid) {
            <div class="mb-auto text-wrap">
              <jft-read-more-modal [title]="'Previous Round Feedback'"
                [text]="$safeNavigationMigration(supplier?.bid.feedback)"></jft-read-more-modal>
            </div>
            }
          </div>
          <div [ngStyle]="{ 'order' : $safeNavigationMigration(usOrderedFields?.awarded_contract_volume) }"
            class="va-cell row-index-69 awarded-contract-volume text-center"
            *ngIf="!(usHiddenFields && usHiddenFields[VIEW_FIELDS?.AWARDED_CONTRACT_VOLUME] === false) && supplier?.awardedPercent">
            {{$safeNavigationMigration(contract?.volume) /100 * $safeNavigationMigration(supplier?.awardedPercent) | number : '1.0-0' | usNumber}}
            {{contract?.units.code}}
          </div>
          <div [ngStyle]="{ 'order' : $safeNavigationMigration(usOrderedFields?.awarded_contract_volume) }"
            class="va-cell row-index-69 awarded-contract-volume text-center"
            *ngIf="!(usHiddenFields && usHiddenFields[VIEW_FIELDS?.AWARDED_CONTRACT_VOLUME] === false) && !supplier?.awardedPercent">
          </div>
          <div [ngStyle]="{ 'order' : $safeNavigationMigration(usOrderedFields?.awarded_monthly_volume) }"
            class="va-cell row-index-70 awarded-monthly-volume text-center"
            *ngIf="!(usHiddenFields && usHiddenFields[VIEW_FIELDS?.AWARDED_MONTHLY_VOLUME] === false) && supplier?.awardedPercent">
            {{ $safeNavigationMigration(contract?.volume) / contract.monthService / 100 * $safeNavigationMigration(supplier?.awardedPercent) | number :
            '1.0-0' | usNumber
            }} {{contract?.units.code}}
          </div>
          <div [ngStyle]="{ 'order' : $safeNavigationMigration(usOrderedFields?.awarded_monthly_volume) }"
            class="va-cell row-index-70 awarded-monthly-volume text-center"
            *ngIf="!(usHiddenFields && usHiddenFields[VIEW_FIELDS?.AWARDED_MONTHLY_VOLUME] === false) && !supplier?.awardedPercent">
          </div>
          <div [ngStyle]="{ 'order' : $safeNavigationMigration(usOrderedFields?.weight_to_volume) }"
            class="va-cell row-index-71 weight_to_volume text-center"
            *ngIf="!(usHiddenFields && usHiddenFields[VIEW_FIELDS?.WEIGHT_TO_VOLUME] === false)">
            @if (supplier?.bid) {
            {{supplier?.bid.weightToVolume}}
            }
          </div>
          <div [ngStyle]="{ 'order' : $safeNavigationMigration(usOrderedFields?.status) }" class="va-cell row-index-73 award-comment text-center">
            <jft-award-comment-icon [comment]="$safeNavigationMigration(supplier?.awardComment)"
              [airline]="$safeNavigationMigration(tender?.company?.name)"></jft-award-comment-icon>
            <span *ngIf="!supplier?.awardComment" class="text-muted">-</span>
          </div>
          <div [ngStyle]="{ 'order' : $safeNavigationMigration(usOrderedFields?.status) }" class="va-cell row-index-72 status text-center">
            <div class="flex-grow-1">
              <ng-container *ngIf="isCurrentRound()">
                <jft-offer-status [signature]="supplier?.bid ? $safeNavigationMigration(supplier?.bid.signature) : null"
                  [status]="$safeNavigationMigration(supplier?.status)" [awardedPercent]="$safeNavigationMigration(supplier?.awardedPercent)">
                </jft-offer-status>
                <div class="row" *ngIf="supplier?.status == offerStatuses.RECEIVED && user.canManage(tender)">
                  <div class="col">
                    <jft-award-button
                      *ngIf="[roundStatuses.ACTIVE, roundStatuses.TENTATIVE_AWARDED, roundStatuses.AWAITING_REVIEW, roundStatuses.EXPIRED].includes($safeNavigationMigration(round?.status))"
                      [class]="'btn btn-outline-primary btn-sm w-100 mt-2'" [popoverPlacement]="'top'"
                      [offer]="supplier" [contract]="contract" [loadingAward]="loadingAward" (onAward)="award($event)">
                    </jft-award-button>
                  </div>
                </div>
                <!-- Cancel Tentative Award Button -->
                <div class="row" *ngIf="supplier?.status == offerStatuses.TENTATIVE_AWARDED && user.canManage(tender)">
                  <div class="col">
                    <button class="btn btn-warning btn-sm w-100 mt-2" (click)="openCancelTentativeAwardModal(supplier)">
                      <span [hidden]="!loadingAward">
                        <div class="spinner-border spinner-border-sm me-1" role="status">
                          <span class="visually-hidden">Loading..</span>
                        </div>
                      </span>
                      Cancel Tentative Award
                    </button>
                  </div>
                </div>
              </ng-container>
            </div>
          </div>
        </ng-template>
      </div>
      }
      }

    </div>
    }
  </div>
</div>

<!-- Cancel Award Confirmation Modal -->
<ng-template #cancelAwardModal let-modal>
  <div class="modal-header bg-danger text-white">
    <h4 class="modal-title">Cancel Award</h4>
    <button type="button" class="btn-close btn-close-white" aria-label="Close" (click)="modal.dismiss()"></button>
  </div>
  <div class="modal-body">
    <p class="mb-4">
      Are you sure you want to cancel the award for <strong>{{contract?.location?.getLabel()}}</strong>
      from <strong>{{selectedSupplierForCancellation?.supplier?.name}}<span
          *ngIf="selectedSupplierForCancellation?.supplier?.supplierAlias">
          ({{selectedSupplierForCancellation?.supplier?.supplierAlias}})</span></strong>?
    </p>

    <!-- Location Information Card -->
    <div class="card mb-3">
      <div class="card-header bg-light">
        <h6 class="card-title mb-0">
          <ng-icon name="lucideMapPin" class="me-2"></ng-icon>
          Location Information
        </h6>
      </div>
      <div class="card-body">
        <div class="row">
          <div class="col-md-3 mb-2">
            <div class="text-muted small">Location</div>
            <div class="fw-bold">{{contract?.location?.getLabel()}}</div>
          </div>
          <div class="col-md-3 mb-2" *ngIf="!tender?.company?.settings?.isHiddenField('location_company')">
            <div class="text-muted small">Company Info</div>
            <div class="fw-bold">
              <span *ngIf="contract?.companyChild">{{contract?.companyChild?.name}}</span>
              <span *ngIf="!contract?.companyChild && contract?.companyInfo">{{contract?.companyInfo}}</span>
              <span *ngIf="!contract?.companyChild && !contract?.companyInfo">{{tender?.company?.name}}</span>
            </div>
          </div>
          <div class="col-md-3 mb-2" *ngIf="!tender?.company?.settings?.isHiddenField('location_fuel_type')">
            <div class="text-muted small">Fuel Type</div>
            <div class="fw-bold">{{contract?.fuelType?.name || contract?.fuelType || 'N/A'}}</div>
          </div>
          <div class="col-md-3 mb-2" *ngIf="!tender?.company?.settings?.isHiddenField('location_flight_type')">
            <div class="text-muted small">Flight Type</div>
            <div class="fw-bold">{{contract?.flightType?.name || contract?.flightType || 'N/A'}}</div>
          </div>
          <div class="col-md-3 mb-2" *ngIf="!tender?.company?.settings?.isHiddenField('location_delivery_point')">
            <div class="text-muted small">Preferred Delivery Point</div>
            <div class="fw-bold">{{contract?.fuelPreference?.name || 'N/A'}}</div>
          </div>
          <div class="col-md-3 mb-2">
            <div class="text-muted small">Total Volume</div>
            <div class="fw-bold">{{$safeNavigationMigration(contract?.volume) | number:'1.0-0'}} {{contract?.units?.code}}</div>
          </div>
        </div>
      </div>
    </div>

    <!-- Supplier Award Information Card -->
    <div class="card mb-3">
      <div class="card-header bg-light">
        <h6 class="card-title mb-0">
          <ng-icon name="lucideBuilding2" class="me-2"></ng-icon>
          Supplier Award Information
        </h6>
      </div>
      <div class="card-body">
        <div class="row">
          <div class="col-md-3 mb-2">
            <div class="text-muted small">Supplier</div>
            <div class="fw-bold">{{selectedSupplierForCancellation?.supplier?.name || 'N/A'}}<span
                *ngIf="selectedSupplierForCancellation?.supplier?.supplierAlias"
                class="text-muted"><br>({{selectedSupplierForCancellation?.supplier?.supplierAlias}})</span></div>
          </div>
          <div class="col-md-3 mb-2">
            <div class="text-muted small">Awarded Contract Volume</div>
            <div class="fw-bold">{{($safeNavigationMigration(contract?.volume) * $safeNavigationMigration(selectedSupplierForCancellation?.awardedPercent) / 100) |
              number:'1.0-0'}} {{contract?.units?.code}}</div>
          </div>
          <div class="col-md-3 mb-2">
            <div class="text-muted small">Award Percentage</div>
            <div class="fw-bold">{{selectedSupplierForCancellation?.awardedPercent}}%</div>
          </div>
          <div class="col-md-3 mb-2">
            <div class="text-muted small">Award Type</div>
            <div class="fw-bold">
              <span
                *ngIf="selectedSupplierForCancellation?.awardSelfSupply && selectedSupplierForCancellation?.awardSelfSupply == selfSupplyOptions.LOGISTICS">Logistics
                Only</span>
              <span
                *ngIf="selectedSupplierForCancellation?.awardSelfSupply && selectedSupplierForCancellation?.awardSelfSupply == selfSupplyOptions.FUEL_ONLY">Fuel
                Only</span>
              <span *ngIf="!selectedSupplierForCancellation?.awardSelfSupply">Fuel & Logistics</span>
            </div>
          </div>
          <div class="col-md-3 mb-2" *ngIf="getContractStartDate(selectedSupplierForCancellation)">
            <div class="text-muted small">Contract Start</div>
            <div class="fw-bold">{{getContractStartDate(selectedSupplierForCancellation) | date:'dd/MM/yyyy':'UTC'}}
            </div>
          </div>
          <div class="col-md-3 mb-2" *ngIf="getContractEndDate(selectedSupplierForCancellation)">
            <div class="text-muted small">Contract End</div>
            <div class="fw-bold">{{getContractEndDate(selectedSupplierForCancellation) | date:'dd/MM/yyyy':'UTC'}}</div>
          </div>
        </div>
      </div>
    </div>

    <div class="alert alert-danger">
      <p><ng-icon name="lucideTriangleAlert" class="me-2"></ng-icon> <strong>Warning:</strong> This will revert the
        offer back to 'Received' status.</p>
      <p>The offer can be then re-awarded. If the round is still active, the supplier can edit and resubmit their offer.
      </p>
      <p class="mb-0">Supplier will be automatically notified via emailed daily summary.</p>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-light me-3" (click)="modal.dismiss()" [disabled]="loadingAward">Cancel</button>
    <button type="button" class="btn btn-danger" (click)="confirmCancelAward(modal)" [disabled]="loadingAward">
      <span *ngIf="loadingAward">
        <div class="spinner-border spinner-border-sm me-1" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
        <span>Cancelling...</span>
      </span>
      <span *ngIf="!loadingAward">Cancel Award</span>
    </button>
  </div>
</ng-template>

<!-- Cancel Tentative Award Confirmation Modal -->
<ng-template #cancelTentativeAwardModal let-modal>
  <div class="modal-header bg-danger text-white">
    <h4 class="modal-title">Cancel Tentative Award</h4>
    <button type="button" class="btn-close btn-close-white" aria-label="Close" (click)="modal.dismiss()"></button>
  </div>
  <div class="modal-body">
    <p class="mb-4">
      Are you sure you want to cancel the tentative award for <strong>{{contract?.location?.getLabel()}}</strong>
      from <strong>{{selectedSupplierForCancellation?.supplier?.name}}<span
          *ngIf="selectedSupplierForCancellation?.supplier?.supplierAlias">
          ({{selectedSupplierForCancellation?.supplier?.supplierAlias}})</span></strong>?
    </p>

    <!-- Location Information Card -->
    <div class="card mb-3">
      <div class="card-header bg-light">
        <h6 class="card-title mb-0">
          <ng-icon name="lucideMapPin" class="me-2"></ng-icon>
          Location Information
        </h6>
      </div>
      <div class="card-body">
        <div class="row">
          <div class="col-md-3 mb-2">
            <div class="text-muted small">Location</div>
            <div class="fw-bold">{{contract?.location?.iata}}</div>
          </div>
          <div class="col-md-3 mb-2" *ngIf="!tender?.company?.settings?.isHiddenField('location_company')">
            <div class="text-muted small">Company Info</div>
            <div class="fw-bold">
              <span *ngIf="contract?.companyChild">{{contract?.companyChild?.name}}</span>
              <span *ngIf="!contract?.companyChild && contract?.companyInfo">{{contract?.companyInfo}}</span>
              <span *ngIf="!contract?.companyChild && !contract?.companyInfo">{{tender?.company?.name}}</span>
            </div>
          </div>
          <div class="col-md-3 mb-2" *ngIf="!tender?.company?.settings?.isHiddenField('location_fuel_type')">
            <div class="text-muted small">Fuel Type</div>
            <div class="fw-bold">{{contract?.fuelType?.name || contract?.fuelType || 'N/A'}}</div>
          </div>
          <div class="col-md-3 mb-2" *ngIf="!tender?.company?.settings?.isHiddenField('location_flight_type')">
            <div class="text-muted small">Flight Type</div>
            <div class="fw-bold">{{contract?.flightType?.name || contract?.flightType || 'N/A'}}</div>
          </div>
          <div class="col-md-3 mb-2" *ngIf="!tender?.company?.settings?.isHiddenField('location_delivery_point')">
            <div class="text-muted small">Preferred Delivery Point</div>
            <div class="fw-bold">{{contract?.fuelPreference?.name || 'N/A'}}</div>
          </div>
          <div class="col-md-3 mb-2">
            <div class="text-muted small">Total Volume</div>
            <div class="fw-bold">{{$safeNavigationMigration(contract?.volume) | number:'1.0-0'}} {{contract?.units?.code}}</div>
          </div>
        </div>
      </div>
    </div>

    <!-- Tentative Award Information Card -->
    <div class="card mb-3">
      <div class="card-header bg-light">
        <h6 class="card-title mb-0">
          <ng-icon name="lucideBuilding2" class="me-2"></ng-icon>
          Tentative Award Information
        </h6>
      </div>
      <div class="card-body">
        <div class="row">
          <div class="col-md-3 mb-2">
            <div class="text-muted small">Supplier</div>
            <div class="fw-bold">{{selectedSupplierForCancellation?.supplier?.name || 'N/A'}}<span
                *ngIf="selectedSupplierForCancellation?.supplier?.supplierAlias"
                class="text-muted"><br>({{selectedSupplierForCancellation?.supplier?.supplierAlias}})</span></div>
          </div>
          <div class="col-md-3 mb-2">
            <div class="text-muted small">Awarded Contract Volume</div>
            <div class="fw-bold">{{($safeNavigationMigration(contract?.volume) * $safeNavigationMigration(selectedSupplierForCancellation?.awardedPercent) / 100) |
              number:'1.0-0'}} {{contract?.units?.code}}</div>
          </div>
          <div class="col-md-3 mb-2">
            <div class="text-muted small">Award Percentage</div>
            <div class="fw-bold">{{selectedSupplierForCancellation?.awardedPercent}}%</div>
          </div>
          <div class="col-md-3 mb-2">
            <div class="text-muted small">Award Type</div>
            <div class="fw-bold">
              <span
                *ngIf="selectedSupplierForCancellation?.awardSelfSupply && selectedSupplierForCancellation?.awardSelfSupply == selfSupplyOptions.LOGISTICS">Logistics
                Only</span>
              <span
                *ngIf="selectedSupplierForCancellation?.awardSelfSupply && selectedSupplierForCancellation?.awardSelfSupply == selfSupplyOptions.FUEL_ONLY">Fuel
                Only</span>
              <span *ngIf="!selectedSupplierForCancellation?.awardSelfSupply">Fuel & Logistics</span>
            </div>
          </div>
          <div class="col-md-3 mb-2" *ngIf="getContractStartDate(selectedSupplierForCancellation)">
            <div class="text-muted small">Contract Start</div>
            <div class="fw-bold">{{getContractStartDate(selectedSupplierForCancellation)}}</div>
          </div>
          <div class="col-md-3 mb-2" *ngIf="getContractEndDate(selectedSupplierForCancellation)">
            <div class="text-muted small">Contract End</div>
            <div class="fw-bold">{{getContractEndDate(selectedSupplierForCancellation)}}</div>
          </div>
        </div>
      </div>
    </div>

    <div class="alert alert-danger">
      <ng-icon name="lucideTriangleAlert" class="me-2"></ng-icon>
      <strong>Warning:</strong> This will revert the offer back to 'Received' status and the supplier will not be
      notified.
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-light me-3" (click)="modal.dismiss()" [disabled]="loadingAward">Cancel</button>
    <button type="button" class="btn btn-danger" (click)="confirmCancelTentativeAward(modal)" [disabled]="loadingAward">
      <span *ngIf="loadingAward">
        <div class="spinner-border spinner-border-sm me-1" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
        <span>Cancelling...</span>
      </span>
      <span *ngIf="!loadingAward">Cancel Tentative Award</span>
    </button>
  </div>
</ng-template>

<!-- Withdraw Bid Confirmation Modal -->
<ng-template #withdrawBidModal let-modal>
  <div class="modal-header">
    <h4 class="modal-title">Confirm Bid Withdrawal</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()"></button>
  </div>
  <div class="modal-body">
    <p>Are you sure you want to withdraw the bid for <strong>{{selectedSupplierForCancellation?.supplier?.name}}<span
          *ngIf="selectedSupplierForCancellation?.supplier?.supplierAlias">
          ({{selectedSupplierForCancellation?.supplier?.supplierAlias}})</span></strong>?</p>
    <p class="text-muted small">This bid will be withdrawn and no longer visible in the current round.</p>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-light" (click)="modal.dismiss()">Cancel</button>
    <button type="button" class="btn btn-danger text-nowrap" [disabled]="loadingAward"
      (click)="confirmWithdrawBid(modal)">
      <span [hidden]="!loadingAward">
        <div class="spinner-border spinner-border-sm me-1" role="status">
          <span class="visually-hidden">Loading..</span>
        </div>
      </span>
      Withdraw Bid
    </button>
  </div>
</ng-template>